import * as E from "react";
import g, { useContext as J, useCallback as pe, createContext as ba, useState as C, useEffect as W, useSyncExternalStore as fa, use as ya, useDeferredValue as va, useMemo as Pa } from "react";
import { q as Ta, g as ja, r as wa, F as Sa, m as Aa, b as Ia, B as Ea, a as le, j as De, N as Ca, C as Oa, G as za, I as Ba, o as Ra, H as xa, d as Na, k as La, J as Ma, M as Da, O as Ga, P as Ge, w as _a, c as $a, Q as Ya, l as Ha, i as H } from "./lib-1be19634.js";
import { L as K, M as F, d as M, p as te, j as S, a6 as Ua, a9 as de, a0 as q, aa as ue, ab as Ka, a as _e, E as $e, a7 as re, g as ae, r as Fa } from "./country-d4e42059.js";
import { S as qa } from "./index-510f96a1.js";
const It = () => ({
  push(a, n) {
    n && (a += "?" + Ta.stringify(n)), window.location.href = a;
  }
}), Va = () => new URLSearchParams(location.search), Et = () => location == null ? void 0 : location.pathname, Wa = (e) => {
  const {
    componentCls: a,
    notificationMarginEdge: n,
    animationMaxHeight: i
  } = e, t = `${a}-notice`, r = new K("antNotificationFadeIn", {
    "0%": {
      transform: "translate3d(100%, 0, 0)",
      opacity: 0
    },
    "100%": {
      transform: "translate3d(0, 0, 0)",
      opacity: 1
    }
  }), o = new K("antNotificationTopFadeIn", {
    "0%": {
      top: -i,
      opacity: 0
    },
    "100%": {
      top: 0,
      opacity: 1
    }
  }), s = new K("antNotificationBottomFadeIn", {
    "0%": {
      bottom: e.calc(i).mul(-1).equal(),
      opacity: 0
    },
    "100%": {
      bottom: 0,
      opacity: 1
    }
  }), d = new K("antNotificationLeftFadeIn", {
    "0%": {
      transform: "translate3d(-100%, 0, 0)",
      opacity: 0
    },
    "100%": {
      transform: "translate3d(0, 0, 0)",
      opacity: 1
    }
  });
  return {
    [a]: {
      [`&${a}-top, &${a}-bottom`]: {
        marginInline: 0,
        [t]: {
          marginInline: "auto auto"
        }
      },
      [`&${a}-top`]: {
        [`${a}-fade-enter${a}-fade-enter-active, ${a}-fade-appear${a}-fade-appear-active`]: {
          animationName: o
        }
      },
      [`&${a}-bottom`]: {
        [`${a}-fade-enter${a}-fade-enter-active, ${a}-fade-appear${a}-fade-appear-active`]: {
          animationName: s
        }
      },
      [`&${a}-topRight, &${a}-bottomRight`]: {
        [`${a}-fade-enter${a}-fade-enter-active, ${a}-fade-appear${a}-fade-appear-active`]: {
          animationName: r
        }
      },
      [`&${a}-topLeft, &${a}-bottomLeft`]: {
        marginRight: {
          value: 0,
          _skip_check_: !0
        },
        marginLeft: {
          value: n,
          _skip_check_: !0
        },
        [t]: {
          marginInlineEnd: "auto",
          marginInlineStart: 0
        },
        [`${a}-fade-enter${a}-fade-enter-active, ${a}-fade-appear${a}-fade-appear-active`]: {
          animationName: d
        }
      }
    }
  };
}, Qa = Wa, Ja = ["top", "topLeft", "topRight", "bottom", "bottomLeft", "bottomRight"], Xa = {
  topLeft: "left",
  topRight: "right",
  bottomLeft: "left",
  bottomRight: "right",
  top: "left",
  bottom: "left"
}, Za = (e, a) => {
  const {
    componentCls: n
  } = e;
  return {
    [`${n}-${a}`]: {
      [`&${n}-stack > ${n}-notice-wrapper`]: {
        [a.startsWith("top") ? "top" : "bottom"]: 0,
        [Xa[a]]: {
          value: 0,
          _skip_check_: !0
        }
      }
    }
  };
}, en = (e) => {
  const a = {};
  for (let n = 1; n < e.notificationStackLayer; n++)
    a[`&:nth-last-child(${n + 1})`] = {
      overflow: "hidden",
      [`& > ${e.componentCls}-notice`]: {
        opacity: 0,
        transition: `opacity ${e.motionDurationMid}`
      }
    };
  return Object.assign({
    [`&:not(:nth-last-child(-n+${e.notificationStackLayer}))`]: {
      opacity: 0,
      overflow: "hidden",
      color: "transparent",
      pointerEvents: "none"
    }
  }, a);
}, an = (e) => {
  const a = {};
  for (let n = 1; n < e.notificationStackLayer; n++)
    a[`&:nth-last-child(${n + 1})`] = {
      background: e.colorBgBlur,
      backdropFilter: "blur(10px)",
      "-webkit-backdrop-filter": "blur(10px)"
    };
  return Object.assign({}, a);
}, nn = (e) => {
  const {
    componentCls: a
  } = e;
  return Object.assign({
    [`${a}-stack`]: {
      [`& > ${a}-notice-wrapper`]: Object.assign({
        transition: `all ${e.motionDurationSlow}, backdrop-filter 0s`,
        position: "absolute"
      }, en(e))
    },
    [`${a}-stack:not(${a}-stack-expanded)`]: {
      [`& > ${a}-notice-wrapper`]: Object.assign({}, an(e))
    },
    [`${a}-stack${a}-stack-expanded`]: {
      [`& > ${a}-notice-wrapper`]: {
        "&:not(:nth-last-child(-n + 1))": {
          opacity: 1,
          overflow: "unset",
          color: "inherit",
          pointerEvents: "auto",
          [`& > ${e.componentCls}-notice`]: {
            opacity: 1
          }
        },
        "&:after": {
          content: '""',
          position: "absolute",
          height: e.margin,
          width: "100%",
          insetInline: 0,
          bottom: e.calc(e.margin).mul(-1).equal(),
          background: "transparent",
          pointerEvents: "auto"
        }
      }
    }
  }, Ja.map((n) => Za(e, n)).reduce((n, i) => Object.assign(Object.assign({}, n), i), {}));
}, tn = nn, Ye = (e) => {
  const {
    iconCls: a,
    componentCls: n,
    // .ant-notification
    boxShadow: i,
    fontSizeLG: t,
    notificationMarginBottom: r,
    borderRadiusLG: o,
    colorSuccess: s,
    colorInfo: d,
    colorWarning: l,
    colorError: c,
    colorTextHeading: w,
    notificationBg: k,
    notificationPadding: h,
    notificationMarginEdge: b,
    notificationProgressBg: T,
    notificationProgressHeight: f,
    fontSize: y,
    lineHeight: v,
    width: B,
    notificationIconSize: z,
    colorText: R
  } = e, p = `${n}-notice`;
  return {
    position: "relative",
    marginBottom: r,
    marginInlineStart: "auto",
    background: k,
    borderRadius: o,
    boxShadow: i,
    [p]: {
      padding: h,
      width: B,
      maxWidth: `calc(100vw - ${F(e.calc(b).mul(2).equal())})`,
      overflow: "hidden",
      lineHeight: v,
      wordWrap: "break-word"
    },
    [`${p}-message`]: {
      marginBottom: e.marginXS,
      color: w,
      fontSize: t,
      lineHeight: e.lineHeightLG
    },
    [`${p}-description`]: {
      fontSize: y,
      color: R
    },
    [`${p}-closable ${p}-message`]: {
      paddingInlineEnd: e.paddingLG
    },
    [`${p}-with-icon ${p}-message`]: {
      marginBottom: e.marginXS,
      marginInlineStart: e.calc(e.marginSM).add(z).equal(),
      fontSize: t
    },
    [`${p}-with-icon ${p}-description`]: {
      marginInlineStart: e.calc(e.marginSM).add(z).equal(),
      fontSize: y
    },
    // Icon & color style in different selector level
    // https://github.com/ant-design/ant-design/issues/16503
    // https://github.com/ant-design/ant-design/issues/15512
    [`${p}-icon`]: {
      position: "absolute",
      fontSize: z,
      lineHeight: 1,
      // icon-font
      [`&-success${a}`]: {
        color: s
      },
      [`&-info${a}`]: {
        color: d
      },
      [`&-warning${a}`]: {
        color: l
      },
      [`&-error${a}`]: {
        color: c
      }
    },
    [`${p}-close`]: Object.assign({
      position: "absolute",
      top: e.notificationPaddingVertical,
      insetInlineEnd: e.notificationPaddingHorizontal,
      color: e.colorIcon,
      outline: "none",
      width: e.notificationCloseButtonSize,
      height: e.notificationCloseButtonSize,
      borderRadius: e.borderRadiusSM,
      transition: `background-color ${e.motionDurationMid}, color ${e.motionDurationMid}`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:hover": {
        color: e.colorIconHover,
        backgroundColor: e.colorBgTextHover
      },
      "&:active": {
        backgroundColor: e.colorBgTextActive
      }
    }, Ia(e)),
    [`${p}-progress`]: {
      position: "absolute",
      display: "block",
      appearance: "none",
      WebkitAppearance: "none",
      inlineSize: `calc(100% - ${F(o)} * 2)`,
      left: {
        _skip_check_: !0,
        value: o
      },
      right: {
        _skip_check_: !0,
        value: o
      },
      bottom: 0,
      blockSize: f,
      border: 0,
      "&, &::-webkit-progress-bar": {
        borderRadius: o,
        backgroundColor: "rgba(0, 0, 0, 0.04)"
      },
      "&::-moz-progress-bar": {
        background: T
      },
      "&::-webkit-progress-value": {
        borderRadius: o,
        background: T
      }
    },
    [`${p}-btn`]: {
      float: "right",
      marginTop: e.marginSM
    }
  };
}, rn = (e) => {
  const {
    componentCls: a,
    // .ant-notification
    notificationMarginBottom: n,
    notificationMarginEdge: i,
    motionDurationMid: t,
    motionEaseInOut: r
  } = e, o = `${a}-notice`, s = new K("antNotificationFadeOut", {
    "0%": {
      maxHeight: e.animationMaxHeight,
      marginBottom: n
    },
    "100%": {
      maxHeight: 0,
      marginBottom: 0,
      paddingTop: 0,
      paddingBottom: 0,
      opacity: 0
    }
  });
  return [
    // ============================ Holder ============================
    {
      [a]: Object.assign(Object.assign({}, wa(e)), {
        position: "fixed",
        zIndex: e.zIndexPopup,
        marginRight: {
          value: i,
          _skip_check_: !0
        },
        [`${a}-hook-holder`]: {
          position: "relative"
        },
        //  animation
        [`${a}-fade-appear-prepare`]: {
          opacity: "0 !important"
        },
        [`${a}-fade-enter, ${a}-fade-appear`]: {
          animationDuration: e.motionDurationMid,
          animationTimingFunction: r,
          animationFillMode: "both",
          opacity: 0,
          animationPlayState: "paused"
        },
        [`${a}-fade-leave`]: {
          animationTimingFunction: r,
          animationFillMode: "both",
          animationDuration: t,
          animationPlayState: "paused"
        },
        [`${a}-fade-enter${a}-fade-enter-active, ${a}-fade-appear${a}-fade-appear-active`]: {
          animationPlayState: "running"
        },
        [`${a}-fade-leave${a}-fade-leave-active`]: {
          animationName: s,
          animationPlayState: "running"
        },
        // RTL
        "&-rtl": {
          direction: "rtl",
          [`${o}-btn`]: {
            float: "left"
          }
        }
      })
    },
    // ============================ Notice ============================
    {
      [a]: {
        [`${o}-wrapper`]: Object.assign({}, Ye(e))
      }
    }
  ];
}, He = (e) => ({
  zIndexPopup: e.zIndexPopupBase + Sa + 50,
  width: 384
}), Ue = (e) => {
  const a = e.paddingMD, n = e.paddingLG;
  return Aa(e, {
    notificationBg: e.colorBgElevated,
    notificationPaddingVertical: a,
    notificationPaddingHorizontal: n,
    notificationIconSize: e.calc(e.fontSizeLG).mul(e.lineHeightLG).equal(),
    notificationCloseButtonSize: e.calc(e.controlHeightLG).mul(0.55).equal(),
    notificationMarginBottom: e.margin,
    notificationPadding: `${F(e.paddingMD)} ${F(e.paddingContentHorizontalLG)}`,
    notificationMarginEdge: e.marginLG,
    animationMaxHeight: 150,
    notificationStackLayer: 3,
    notificationProgressHeight: 2,
    notificationProgressBg: `linear-gradient(90deg, ${e.colorPrimaryBorderHover}, ${e.colorPrimary})`
  });
}, Ke = ja("Notification", (e) => {
  const a = Ue(e);
  return [rn(a), Qa(a), tn(a)];
}, He), on = Ea(["Notification", "PurePanel"], (e) => {
  const a = `${e.componentCls}-notice`, n = Ue(e);
  return {
    [`${a}-pure-panel`]: Object.assign(Object.assign({}, Ye(n)), {
      width: n.width,
      maxWidth: `calc(100vw - ${F(e.calc(n.notificationMarginEdge).mul(2).equal())})`,
      margin: 0
    })
  };
}, He);
var sn = globalThis && globalThis.__rest || function(e, a) {
  var n = {};
  for (var i in e)
    Object.prototype.hasOwnProperty.call(e, i) && a.indexOf(i) < 0 && (n[i] = e[i]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var t = 0, i = Object.getOwnPropertySymbols(e); t < i.length; t++)
      a.indexOf(i[t]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[t]) && (n[i[t]] = e[i[t]]);
  return n;
};
function me(e, a) {
  return a === null || a === !1 ? null : a || /* @__PURE__ */ E.createElement(Oa, {
    className: `${e}-close-icon`
  });
}
const ln = {
  success: za,
  info: Ba,
  error: Ra,
  warning: xa
}, Fe = (e) => {
  const {
    prefixCls: a,
    icon: n,
    type: i,
    message: t,
    description: r,
    btn: o,
    role: s = "alert"
  } = e;
  let d = null;
  return n ? d = /* @__PURE__ */ E.createElement("span", {
    className: `${a}-icon`
  }, n) : i && (d = /* @__PURE__ */ E.createElement(ln[i] || null, {
    className: M(`${a}-icon`, `${a}-icon-${i}`)
  })), /* @__PURE__ */ E.createElement("div", {
    className: M({
      [`${a}-with-icon`]: d
    }),
    role: s
  }, d, /* @__PURE__ */ E.createElement("div", {
    className: `${a}-message`
  }, t), /* @__PURE__ */ E.createElement("div", {
    className: `${a}-description`
  }, r), o && /* @__PURE__ */ E.createElement("div", {
    className: `${a}-btn`
  }, o));
}, dn = (e) => {
  const {
    prefixCls: a,
    className: n,
    icon: i,
    type: t,
    message: r,
    description: o,
    btn: s,
    closable: d = !0,
    closeIcon: l,
    className: c
  } = e, w = sn(e, ["prefixCls", "className", "icon", "type", "message", "description", "btn", "closable", "closeIcon", "className"]), {
    getPrefixCls: k
  } = E.useContext(le), h = a || k("notification"), b = `${h}-notice`, T = De(h), [f, y, v] = Ke(h, T);
  return f(/* @__PURE__ */ E.createElement("div", {
    className: M(`${b}-pure-panel`, y, n, v, T)
  }, /* @__PURE__ */ E.createElement(on, {
    prefixCls: h
  }), /* @__PURE__ */ E.createElement(Ca, Object.assign({}, w, {
    prefixCls: h,
    eventKey: "pure",
    duration: null,
    closable: d,
    className: M({
      notificationClassName: c
    }),
    closeIcon: me(h, l),
    content: /* @__PURE__ */ E.createElement(Fe, {
      prefixCls: b,
      icon: i,
      type: t,
      message: r,
      description: o,
      btn: s
    })
  }))));
}, un = dn;
function mn(e, a, n) {
  let i;
  switch (e) {
    case "top":
      i = {
        left: "50%",
        transform: "translateX(-50%)",
        right: "auto",
        top: a,
        bottom: "auto"
      };
      break;
    case "topLeft":
      i = {
        left: 0,
        top: a,
        bottom: "auto"
      };
      break;
    case "topRight":
      i = {
        right: 0,
        top: a,
        bottom: "auto"
      };
      break;
    case "bottom":
      i = {
        left: "50%",
        transform: "translateX(-50%)",
        right: "auto",
        top: "auto",
        bottom: n
      };
      break;
    case "bottomLeft":
      i = {
        left: 0,
        top: "auto",
        bottom: n
      };
      break;
    default:
      i = {
        right: 0,
        top: "auto",
        bottom: n
      };
      break;
  }
  return i;
}
function cn(e) {
  return {
    motionName: `${e}-fade`
  };
}
var kn = globalThis && globalThis.__rest || function(e, a) {
  var n = {};
  for (var i in e)
    Object.prototype.hasOwnProperty.call(e, i) && a.indexOf(i) < 0 && (n[i] = e[i]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var t = 0, i = Object.getOwnPropertySymbols(e); t < i.length; t++)
      a.indexOf(i[t]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[t]) && (n[i[t]] = e[i[t]]);
  return n;
};
const he = 24, gn = 4.5, pn = "topRight", hn = (e) => {
  let {
    children: a,
    prefixCls: n
  } = e;
  const i = De(n), [t, r, o] = Ke(n, i);
  return t(/* @__PURE__ */ g.createElement(Da, {
    classNames: {
      list: M(r, o, i)
    }
  }, a));
}, bn = (e, a) => {
  let {
    prefixCls: n,
    key: i
  } = a;
  return /* @__PURE__ */ g.createElement(hn, {
    prefixCls: n,
    key: i
  }, e);
}, fn = /* @__PURE__ */ g.forwardRef((e, a) => {
  const {
    top: n,
    bottom: i,
    prefixCls: t,
    getContainer: r,
    maxCount: o,
    rtl: s,
    onAllRemoved: d,
    stack: l,
    duration: c,
    pauseOnHover: w = !0,
    showProgress: k
  } = e, {
    getPrefixCls: h,
    getPopupContainer: b,
    notification: T,
    direction: f
  } = J(le), [, y] = La(), v = t || h("notification"), B = (Y) => mn(Y, n ?? he, i ?? he), z = () => M({
    [`${v}-rtl`]: s ?? f === "rtl"
  }), R = () => cn(v), [p, L] = Ma({
    prefixCls: v,
    style: B,
    className: z,
    motion: R,
    closable: !0,
    closeIcon: me(v),
    duration: c ?? gn,
    getContainer: () => (r == null ? void 0 : r()) || (b == null ? void 0 : b()) || document.body,
    maxCount: o,
    pauseOnHover: w,
    showProgress: k,
    onAllRemoved: d,
    renderNotifications: bn,
    stack: l === !1 ? !1 : {
      threshold: typeof l == "object" ? l == null ? void 0 : l.threshold : void 0,
      offset: 8,
      gap: y.margin
    }
  });
  return g.useImperativeHandle(a, () => Object.assign(Object.assign({}, p), {
    prefixCls: v,
    notification: T
  })), L;
});
function qe(e) {
  const a = g.useRef(null), n = Na("Notification");
  return [g.useMemo(() => {
    const t = (d) => {
      var l;
      if (!a.current) {
        process.env.NODE_ENV !== "production" && n(!1, "usage", "You are calling notice in render which will break in React 18 concurrent mode. Please trigger in effect instead.");
        return;
      }
      const {
        open: c,
        prefixCls: w,
        notification: k
      } = a.current, h = `${w}-notice`, {
        message: b,
        description: T,
        icon: f,
        type: y,
        btn: v,
        className: B,
        style: z,
        role: R = "alert",
        closeIcon: p,
        closable: L
      } = d, Y = kn(d, ["message", "description", "icon", "type", "btn", "className", "style", "role", "closeIcon", "closable"]), D = me(h, typeof p < "u" ? p : k == null ? void 0 : k.closeIcon);
      return c(Object.assign(Object.assign({
        // use placement from props instead of hard-coding "topRight"
        placement: (l = e == null ? void 0 : e.placement) !== null && l !== void 0 ? l : pn
      }, Y), {
        content: /* @__PURE__ */ g.createElement(Fe, {
          prefixCls: h,
          icon: f,
          type: y,
          message: b,
          description: T,
          btn: v,
          role: R
        }),
        className: M(y && `${h}-${y}`, B, k == null ? void 0 : k.className),
        style: Object.assign(Object.assign({}, k == null ? void 0 : k.style), z),
        closeIcon: D,
        closable: L ?? !!D
      }));
    }, o = {
      open: t,
      destroy: (d) => {
        var l, c;
        d !== void 0 ? (l = a.current) === null || l === void 0 || l.close(d) : (c = a.current) === null || c === void 0 || c.destroy();
      }
    };
    return ["success", "info", "warning", "error"].forEach((d) => {
      o[d] = (l) => t(Object.assign(Object.assign({}, l), {
        type: d
      }));
    }), o;
  }, []), /* @__PURE__ */ g.createElement(fn, Object.assign({
    key: "notification-holder"
  }, e, {
    ref: a
  }))];
}
function yn(e) {
  return qe(e);
}
let O = null, Q = (e) => e(), X = [], V = {};
function be() {
  const {
    getContainer: e,
    rtl: a,
    maxCount: n,
    top: i,
    bottom: t,
    showProgress: r,
    pauseOnHover: o
  } = V, s = (e == null ? void 0 : e()) || document.body;
  return {
    getContainer: () => s,
    rtl: a,
    maxCount: n,
    top: i,
    bottom: t,
    showProgress: r,
    pauseOnHover: o
  };
}
const vn = /* @__PURE__ */ g.forwardRef((e, a) => {
  const {
    notificationConfig: n,
    sync: i
  } = e, {
    getPrefixCls: t
  } = J(le), r = V.prefixCls || t("notification"), o = J(Ya), [s, d] = qe(Object.assign(Object.assign(Object.assign({}, n), {
    prefixCls: r
  }), o.notification));
  return g.useEffect(i, []), g.useImperativeHandle(a, () => {
    const l = Object.assign({}, s);
    return Object.keys(l).forEach((c) => {
      l[c] = function() {
        return i(), s[c].apply(s, arguments);
      };
    }), {
      instance: l,
      sync: i
    };
  }), d;
}), Pn = /* @__PURE__ */ g.forwardRef((e, a) => {
  const [n, i] = g.useState(be), t = () => {
    i(be);
  };
  g.useEffect(t, []);
  const r = Ge(), o = r.getRootPrefixCls(), s = r.getIconPrefixCls(), d = r.getTheme(), l = /* @__PURE__ */ g.createElement(vn, {
    ref: a,
    sync: t,
    notificationConfig: n
  });
  return /* @__PURE__ */ g.createElement($a, {
    prefixCls: o,
    iconPrefixCls: s,
    theme: d
  }, r.holderRender ? r.holderRender(l) : l);
});
function ce() {
  if (!O) {
    const e = document.createDocumentFragment(), a = {
      fragment: e
    };
    O = a, Q(() => {
      _a(/* @__PURE__ */ g.createElement(Pn, {
        ref: (n) => {
          const {
            instance: i,
            sync: t
          } = n || {};
          Promise.resolve().then(() => {
            !a.instance && i && (a.instance = i, a.sync = t, ce());
          });
        }
      }), e);
    });
    return;
  }
  O.instance && (X.forEach((e) => {
    switch (e.type) {
      case "open": {
        Q(() => {
          O.instance.open(Object.assign(Object.assign({}, V), e.config));
        });
        break;
      }
      case "destroy":
        Q(() => {
          O == null || O.instance.destroy(e.key);
        });
        break;
    }
  }), X = []);
}
function Tn(e) {
  V = Object.assign(Object.assign({}, V), e), Q(() => {
    var a;
    (a = O == null ? void 0 : O.sync) === null || a === void 0 || a.call(O);
  });
}
function Ve(e) {
  const a = Ge();
  process.env.NODE_ENV !== "production" && !a.holderRender && Ga("notification"), X.push({
    type: "open",
    config: e
  }), ce();
}
const jn = (e) => {
  X.push({
    type: "destroy",
    key: e
  }), ce();
}, wn = ["success", "info", "warning", "error"], Sn = {
  open: Ve,
  destroy: jn,
  config: Tn,
  useNotification: yn,
  _InternalPanelDoNotUseOrYouWillBeFired: un
}, We = Sn;
wn.forEach((e) => {
  We[e] = (a) => Ve(Object.assign(Object.assign({}, a), {
    type: e
  }));
});
process.env.NODE_ENV;
process.env.NODE_ENV;
const An = We, Qe = g.createContext(void 0);
function In(e) {
  const [a, n] = An.useNotification({
    maxCount: 1
  }), [i, t] = Ha.useMessage({
    maxCount: 1
  }), r = pe(
    (s) => {
      const {
        type: d,
        // message, 
        description: l
        //  duration = 4.5, 
        //  placement = 'bottomLeft'
      } = s;
      te(
        "SYSTEM_NOTETIFICATION",
        {
          open: !0,
          message: l,
          severity: d
        }
      );
    },
    [a]
  ), o = pe(
    (s) => {
      const d = `open-message-${Date.now()}`;
      i.open({
        key: d,
        ...s
      });
    },
    [i]
  );
  return /* @__PURE__ */ S.jsxs(Qe.Provider, { value: { openNotification: r, openMessage: o }, children: [
    e.children,
    n,
    t
  ] });
}
function En() {
  const e = g.useContext(Qe);
  if (e === void 0)
    throw new Error("useNotificationContext must be used within a NotificationProvider");
  return e;
}
var Cn = typeof global == "object" && global && global.Object === Object && global;
const On = Cn;
var zn = typeof self == "object" && self && self.Object === Object && self, Bn = On || zn || Function("return this")();
const Rn = Bn;
var xn = Rn.Symbol;
const $ = xn;
var Je = Object.prototype, Nn = Je.hasOwnProperty, Ln = Je.toString, U = $ ? $.toStringTag : void 0;
function Mn(e) {
  var a = Nn.call(e, U), n = e[U];
  try {
    e[U] = void 0;
    var i = !0;
  } catch {
  }
  var t = Ln.call(e);
  return i && (a ? e[U] = n : delete e[U]), t;
}
var Dn = Object.prototype, Gn = Dn.toString;
function _n(e) {
  return Gn.call(e);
}
var $n = "[object Null]", Yn = "[object Undefined]", fe = $ ? $.toStringTag : void 0;
function Xe(e) {
  return e == null ? e === void 0 ? Yn : $n : fe && fe in Object(e) ? Mn(e) : _n(e);
}
function Ze(e) {
  return e != null && typeof e == "object";
}
var Hn = "[object Symbol]";
function Un(e) {
  return typeof e == "symbol" || Ze(e) && Xe(e) == Hn;
}
function Kn(e, a) {
  for (var n = -1, i = e == null ? 0 : e.length, t = Array(i); ++n < i; )
    t[n] = a(e[n], n, e);
  return t;
}
var Fn = Array.isArray;
const qn = Fn;
var Vn = 1 / 0, ye = $ ? $.prototype : void 0, ve = ye ? ye.toString : void 0;
function ea(e) {
  if (typeof e == "string")
    return e;
  if (qn(e))
    return Kn(e, ea) + "";
  if (Un(e))
    return ve ? ve.call(e) : "";
  var a = e + "";
  return a == "0" && 1 / e == -Vn ? "-0" : a;
}
function Wn(e, a) {
  return function(n) {
    return e(a(n));
  };
}
function Qn(e) {
  return e == null ? "" : ea(e);
}
var Jn = Wn(Object.getPrototypeOf, Object);
const Xn = Jn;
var Zn = "[object Object]", ei = Function.prototype, ai = Object.prototype, aa = ei.toString, ni = ai.hasOwnProperty, ii = aa.call(Object);
function ti(e) {
  if (!Ze(e) || Xe(e) != Zn)
    return !1;
  var a = Xn(e);
  if (a === null)
    return !0;
  var n = ni.call(a, "constructor") && a.constructor;
  return typeof n == "function" && n instanceof n && aa.call(n) == ii;
}
var na = /[\\^$.*+?()[\]{}|]/g, ri = RegExp(na.source);
function oi(e) {
  return e = Qn(e), e && ri.test(e) ? e.replace(na, "\\$&") : e;
}
const si = (e) => Object.keys(e).map((a) => `${encodeURIComponent(a)}=${encodeURIComponent(e[a])}`).join("&"), li = (e, a, n, i) => (e.toUpperCase() === "GET" && typeof n == "object" && (n && (a += "?" + si(n)), n = null), n instanceof FormData ? delete i["Content-Type"] : typeof n == "object" && n !== null && (n = JSON.stringify(n)), i["Country-Id"] || (i["Country-Id"] = "" + Ua()), i["Language-Id"] || (i["Language-Id"] = "" + de()), { url: a, body: n, headers: i }), di = async (e, a) => a.ok ? await a.json() : a.json().then((n) => Promise.reject(n)), P = async (e, a, n = null, i = {}) => {
  try {
    i = {
      "Content-Type": "application/json",
      ...i
    };
    const {
      url: t,
      body: r,
      headers: o
    } = li(e, a, n, i), s = {
      method: e,
      headers: o
    };
    r && (s.body = r);
    const l = /^(http|https|ftp):\/\/[^\s]+$/.test(t) ? t : "/bossjob-api-server" + t, c = await fetch(l, s);
    return di(l, c);
  } catch (t) {
    return Promise.reject(t);
  }
}, j = "/authentication", Ct = (e) => {
  const a = "", n = {
    ...e,
    cf_token: e.cf_token || a
  };
  return n.cf_token || delete n.cf_token, P("POST", `${j}/email-otp/generate`, n, {
    "Language-Id": de()
  }).catch((i) => Promise.reject(i));
}, ui = (e) => Promise.resolve(e), mi = (e) => {
  let a = e == null ? void 0 : e.fcm_token_web_jobseeker, n = !1;
  return typeof window < "u" && (n = !!sessionStorage.getItem("noNeedFirebaseToken"), a = n ? null : sessionStorage.getItem("firebase-messaging-token")), P("POST", `${j}/jobseekers/login`, {
    ...e,
    client_id: q("CLIENT_ID"),
    client_secret: q("CLIENT_SECRET"),
    fcm_token_web_jobseeker: a,
    language_code: ue()
  });
}, ci = (e) => {
  let a = e == null ? void 0 : e.fcm_token_web_jobseeker, n = !1;
  return typeof window < "u" && (n = !!sessionStorage.getItem("noNeedFirebaseToken"), a = n ? null : sessionStorage.getItem("firebase-messaging-token")), P("POST", `${j}/jobseekers/social-login`, {
    ...e,
    client_id: q("CLIENT_ID"),
    client_secret: q("CLIENT_SECRET"),
    fcm_token_web_jobseeker: a,
    language_code: ue()
  });
}, Ot = (e) => P(
  "POST",
  `${j}/phone-otp/generate`,
  e,
  {
    "Language-Id": de(),
    Deviceid: localStorage.getItem("uuid")
  }
), zt = (e) => P("POST", `${j}/verification-otp`, e), Bt = (e) => P("POST", `${j}/verification-phone-otp`, e), Rt = (e) => P("POST", `${j}/bind/user-email`, e), xt = (e) => P("POST", `${j}/check/bind-number`, e), Nt = (e) => P("POST", `${j}/phone-number`, e), Lt = (e) => P("POST", `${j}/check/is-email-use`, e), Mt = (e) => P("POST", `${j}/qrcode/generate`, e), Dt = (e) => P("POST", `${j}/qrcode/polling`, e), ki = (e) => P("POST", `${j}/jobseekers/email-magic-link/generate`, {
  ...e
}), gi = (e) => P("POST", `${j}/recruiters/email-magic-link/generate`, {
  ...e
}), pi = (e, a) => P("POST", `${j}/user/destination/traceability`, e, a), hi = (e) => {
  if (!e)
    return [];
  const a = [];
  return ((e == null ? void 0 : e.country_lists) ?? (e == null ? void 0 : e.country_code) ?? []).forEach((i) => {
    var t;
    if (i.is_sms_allowed) {
      const r = {
        value: i.code,
        label: i.code + " (" + i.value + ")",
        id: i.id,
        flag: `${qa}/flags1/${(t = i.key) == null ? void 0 : t.toUpperCase()}.png`,
        country: i.value,
        countryKey: i.key
      };
      a.push(r);
    }
  }), a;
}, bi = (e, ...a) => {
  if (!e)
    return e;
  a.length;
  const n = ti(a[0]);
  return n && (a = a[0], Object.keys(a).length), [...e.matchAll(/{{[^\}]*}}/g)].map((t) => oi(t[0])).forEach((t, r) => {
    n && (r = t.match(/\w+/)), a[r], e = e.replace(new RegExp(t), a[r] || "");
  }), e;
};
function _(e) {
  return e != null && typeof e == "object" && e["@@functional/placeholder"] === !0;
}
function N(e) {
  return function a(n) {
    return arguments.length === 0 || _(n) ? a : e.apply(this, arguments);
  };
}
function fi(e) {
  return function a(n, i) {
    switch (arguments.length) {
      case 0:
        return a;
      case 1:
        return _(n) ? a : N(function(t) {
          return e(n, t);
        });
      default:
        return _(n) && _(i) ? a : _(n) ? N(function(t) {
          return e(t, i);
        }) : _(i) ? N(function(t) {
          return e(n, t);
        }) : e(n, i);
    }
  };
}
const yi = Array.isArray || function(a) {
  return a != null && a.length >= 0 && Object.prototype.toString.call(a) === "[object Array]";
};
function Pe(e) {
  for (var a = [], n; !(n = e.next()).done; )
    a.push(n.value);
  return a;
}
function Te(e, a, n) {
  for (var i = 0, t = n.length; i < t; ) {
    if (e(a, n[i]))
      return !0;
    i += 1;
  }
  return !1;
}
function vi(e) {
  var a = String(e).match(/^function (\w*)/);
  return a == null ? "" : a[1];
}
function Z(e, a) {
  return Object.prototype.hasOwnProperty.call(a, e);
}
function Pi(e, a) {
  return e === a ? e !== 0 || 1 / e === 1 / a : e !== e && a !== a;
}
const ne = typeof Object.is == "function" ? Object.is : Pi;
var je = Object.prototype.toString, Ti = /* @__PURE__ */ function() {
  return je.call(arguments) === "[object Arguments]" ? function(a) {
    return je.call(a) === "[object Arguments]";
  } : function(a) {
    return Z("callee", a);
  };
}();
const ia = Ti;
var ji = !/* @__PURE__ */ {
  toString: null
}.propertyIsEnumerable("toString"), we = ["constructor", "valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"], Se = /* @__PURE__ */ function() {
  return arguments.propertyIsEnumerable("length");
}(), wi = function(a, n) {
  for (var i = 0; i < a.length; ) {
    if (a[i] === n)
      return !0;
    i += 1;
  }
  return !1;
}, Si = /* @__PURE__ */ N(typeof Object.keys == "function" && !Se ? function(a) {
  return Object(a) !== a ? [] : Object.keys(a);
} : function(a) {
  if (Object(a) !== a)
    return [];
  var n, i, t = [], r = Se && ia(a);
  for (n in a)
    Z(n, a) && (!r || n !== "length") && (t[t.length] = n);
  if (ji)
    for (i = we.length - 1; i >= 0; )
      n = we[i], Z(n, a) && !wi(t, n) && (t[t.length] = n), i -= 1;
  return t;
});
const Ae = Si;
var Ai = /* @__PURE__ */ N(function(a) {
  return a === null ? "Null" : a === void 0 ? "Undefined" : Object.prototype.toString.call(a).slice(8, -1);
});
const Ie = Ai;
function Ee(e, a, n, i) {
  var t = Pe(e), r = Pe(a);
  function o(s, d) {
    return ke(s, d, n.slice(), i.slice());
  }
  return !Te(function(s, d) {
    return !Te(o, d, s);
  }, r, t);
}
function ke(e, a, n, i) {
  if (ne(e, a))
    return !0;
  var t = Ie(e);
  if (t !== Ie(a))
    return !1;
  if (typeof e["fantasy-land/equals"] == "function" || typeof a["fantasy-land/equals"] == "function")
    return typeof e["fantasy-land/equals"] == "function" && e["fantasy-land/equals"](a) && typeof a["fantasy-land/equals"] == "function" && a["fantasy-land/equals"](e);
  if (typeof e.equals == "function" || typeof a.equals == "function")
    return typeof e.equals == "function" && e.equals(a) && typeof a.equals == "function" && a.equals(e);
  switch (t) {
    case "Arguments":
    case "Array":
    case "Object":
      if (typeof e.constructor == "function" && vi(e.constructor) === "Promise")
        return e === a;
      break;
    case "Boolean":
    case "Number":
    case "String":
      if (!(typeof e == typeof a && ne(e.valueOf(), a.valueOf())))
        return !1;
      break;
    case "Date":
      if (!ne(e.valueOf(), a.valueOf()))
        return !1;
      break;
    case "Error":
      return e.name === a.name && e.message === a.message;
    case "RegExp":
      if (!(e.source === a.source && e.global === a.global && e.ignoreCase === a.ignoreCase && e.multiline === a.multiline && e.sticky === a.sticky && e.unicode === a.unicode))
        return !1;
      break;
  }
  for (var r = n.length - 1; r >= 0; ) {
    if (n[r] === e)
      return i[r] === a;
    r -= 1;
  }
  switch (t) {
    case "Map":
      return e.size !== a.size ? !1 : Ee(e.entries(), a.entries(), n.concat([e]), i.concat([a]));
    case "Set":
      return e.size !== a.size ? !1 : Ee(e.values(), a.values(), n.concat([e]), i.concat([a]));
    case "Arguments":
    case "Array":
    case "Object":
    case "Boolean":
    case "Number":
    case "String":
    case "Date":
    case "Error":
    case "RegExp":
    case "Int8Array":
    case "Uint8Array":
    case "Uint8ClampedArray":
    case "Int16Array":
    case "Uint16Array":
    case "Int32Array":
    case "Uint32Array":
    case "Float32Array":
    case "Float64Array":
    case "ArrayBuffer":
      break;
    default:
      return !1;
  }
  var o = Ae(e);
  if (o.length !== Ae(a).length)
    return !1;
  var s = n.concat([e]), d = i.concat([a]);
  for (r = o.length - 1; r >= 0; ) {
    var l = o[r];
    if (!(Z(l, a) && ke(a[l], e[l], s, d)))
      return !1;
    r -= 1;
  }
  return !0;
}
var Ii = /* @__PURE__ */ fi(function(a, n) {
  return ke(a, n, [], []);
});
const Ei = Ii;
function Ci(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Oi(e) {
  return Object.prototype.toString.call(e) === "[object String]";
}
function zi(e) {
  var a = Object.prototype.toString.call(e);
  return a === "[object Uint8ClampedArray]" || a === "[object Int8Array]" || a === "[object Uint8Array]" || a === "[object Int16Array]" || a === "[object Uint16Array]" || a === "[object Int32Array]" || a === "[object Uint32Array]" || a === "[object Float32Array]" || a === "[object Float64Array]" || a === "[object BigInt64Array]" || a === "[object BigUint64Array]";
}
var Bi = /* @__PURE__ */ N(function(a) {
  return a != null && typeof a["fantasy-land/empty"] == "function" ? a["fantasy-land/empty"]() : a != null && a.constructor != null && typeof a.constructor["fantasy-land/empty"] == "function" ? a.constructor["fantasy-land/empty"]() : a != null && typeof a.empty == "function" ? a.empty() : a != null && a.constructor != null && typeof a.constructor.empty == "function" ? a.constructor.empty() : yi(a) ? [] : Oi(a) ? "" : Ci(a) ? {} : ia(a) ? function() {
    return arguments;
  }() : zi(a) ? a.constructor.from("") : void 0;
});
const Ri = Bi;
var xi = /* @__PURE__ */ N(function(a) {
  return a != null && Ei(a, Ri(a));
});
const Ce = xi, Ni = {
  title: "Welcome to",
  tips: "Looking to hire people? Sign up as ",
  continueWith: "or continue with",
  agreement: "I have read and agreed to {{value1}} and {{value2}}",
  emailValid: "Please enter a valid email address.",
  emailLabel: "Email Address",
  sendCodeDigit: "Please enter the 6-digit code that we sent ",
  checkSpamEmail: "Check your spam mail if you didn’t receive code",
  otherOptions: "other options",
  alternatively: "Alternatively, request a",
  resendCode: "Resend code",
  country: "Country",
  phoneNumber: "Phone Number",
  twoFactor: "Safety Verification",
  authentication: "authentication",
  secure: "Secure your account and receive code on your email",
  emailTips: "The login method is inconsistent with the last login, please verify via email",
  setUpLater: "Set this up later",
  enableTwoFactor: "two-factor",
  authenticationEnabled: "authentication enabled",
  factorTip: "If we notice an attempted login from a device or browser that we don’t recognise, we will ask you for code sent to your email address.",
  verifyText: "Verify your identity",
  verifyExtra: "This additional step confirms your identity during the login process.",
  optError: "Fail to send OTP",
  resendEmailCode: "Resend email OTP success",
  invalidOtp: "The OTP you have entered is wrong. Please try again.",
  resendPhoneCode: "The mobile OTP has been successfully resent.",
  verifyEmail: "Verify email",
  thisPhoneNumberAssociated: "Choose account",
  accounts: "accounts.",
  thisPhoneNumber: "This phone number is associated with ",
  youNeedToChooseVerified: "To proceed, you need to choose an email to verify and connect",
  validateErr: "This Email address has been used. Please change to another email",
  checkYourSpam: "Check your spam folder if you didn’t receive code.",
  authenticationSuccessful: "Authentication Successful",
  Bossjob: "Bossjob",
  back: "Back",
  vipText: {
    GetVipPrivilegesImmediately: "Get VIP Privileges Immediately",
    InviteNewUsersToRegister: "Invite New Users To Register",
    BossjobAI: "Bossjob AI",
    ResumeAssistant: "Resume Assistant",
    HighSalaryOffer: "High Salary Offer",
    HelpYouGet: "Help You Get",
    promptDesc: "Oops, you're already logged in; registering repeatedly isn't possible. Please log out and try again.",
    returnHome: "Back to Home",
    signOut: "Sign Out",
    inviteFriendsToGet: "Invite Friends To Get",
    AIResumeCoaching: "AI RESUME COACHING",
    HighQualityVIPResumeTemplateAndAIAssistantToHelpYouGetHighPayingOffer: "Invite a friend to join Bossjob, both receive 1-month Free VIP access.",
    copyLinkToInviteNow: "Copy your Invite link"
  },
  links: {
    apple: "Continue with Apple",
    google: "Continue with Google",
    facebook: "Continue with Facebook",
    appleText: "Apple",
    line: "Continue with Line",
    twitter: "Continue with X"
  },
  seoMetaTitle: "Sign Up or Login as Talent | Bossjob",
  JoinBossjob: "Join Bossjob",
  kickStartYourCareer: "kick-start your career!",
  enterYourEmailAddress: "Enter your email address",
  submit: "Submit",
  "pleaseEnterAvalidEmailAddress.": "Please enter a valid email address.",
  bySigningUp: "By signing up, I have read and agreed to",
  termsOfUse: "Terms of Use",
  and: "and",
  privacyPolicy: "Privacy Policy",
  signInWith: "Sign in with",
  lookingToHire: "Looking to hire people? Sign up as ",
  employer: "an Employer",
  welcomeBack: "Welcome back!",
  signUpAnAccount: "Sign up an account",
  pleaseEnter: "Please enter the 6-digit one-time password that we sent to",
  enter6DigitOTP: "Enter 6-digit OTP",
  getOPT: "get OTP",
  heOTPYouHaveEnteredIsWrong: "The OTP you have entered is wrong. Please try again.",
  resendOTP: "Resend OTP",
  havingTrouble: "Having trouble?",
  requestAmagicLink: "Request a Magic Link",
  seoMetaDescription: "Chat with bosses in real-time and get hired fast. Join 3 million professionals in Southeast Asia! Sign up or login to find job matches in ",
  seoMetaDescription2: "Network of 2 million+ professionals.",
  magicLinkText: "Magic link",
  magicLink: {
    welcomeBack: "Welcome back!",
    signUp: "Sign up an account",
    haveSendEmail: "We’ve sent a magic link to {{email}}. Please click on the link to proceed.",
    toHome: "Back to home page"
  },
  loginUsingSocialMediaOTP: "Login using social media/OTP",
  loginUsingQRCode: "Login using QR code",
  scanQRCodeOnAppToLogin: "Scan this code with Bossjob APP to login instantly",
  donHaveApp: "Don’t have App",
  sendCode: "Send verification code",
  howToScanQRCode: "How to scan the QR code",
  ImJobSeeker: "I'm a Jobseeker",
  ImRecruiter: "I'm an Employer",
  menuLoginToVersion: "Menu > Login to Web",
  scannedSuccessfully: "Scanned successfully",
  pleaseConfirmLoginOnAPP: "Please confirm the request on APP",
  pleaseRefreshQrCode: "Refresh QR Code",
  clickToRefresh: "Refresh",
  accountMismatch: "Your account role did not match, please switch to talent to log in",
  loginWithQRCode: "Login with QR code",
  email: "Email",
  phone: "Phone",
  haveSendEmail: "We’ve sent a magic link to {{email}}. Please click on it to proceed.",
  leftBanner: {
    free: "Free",
    lifetime: "Lifetime",
    quick: "Quick",
    production: "Production",
    aIAssisted: "AI Assisted",
    resumeEditing: "Resume Editing",
    aGoodResume: "A Good Resume",
    aGoodResumeDesc: "Supercharge Your Job Search"
  },
  enterYourEmail: "Enter your email",
  verificationEmailCode: "We will send a verification code to your email",
  confirmationCode: "Enter confirmation code",
  enterOTP: "Please enter the 6-digit code that we sent to",
  verificationPhoneCode: "We will send a verification code to your phone",
  enterYourPhone: "Enter your Phone",
  connectYourEmail: "Please connect your email",
  connectYourEmailTip: "We'll just need your email address to finish registering or logging onto Bossjob.",
  downloadApp: "Download APP",
  neptune: "Neptune",
  neptuneOffersJob: "Neptune offers job seekers verified, current information on companies hiring, enabling informed career decisions."
}, ta = {
  getStarted: Ni
}, ra = {
  0: "Success",
  40001: "Parameter validation failed or invalid",
  40002: "Incorrect authentication credentials",
  40003: "Authentication credentials were not provided",
  40004: "Resource not found",
  40005: "You do not have permission to perform this action",
  40006: "There has been too many attempts. Please try again in {{retry_after}} seconds",
  41001: "The email has already been taken",
  41002: "The client id has already been taken",
  41003: "The secret key has already been taken",
  41004: "Users must have an email address",
  41005: "Failed to register this email",
  41006: "Unable update status",
  41007: "The uploaded file exceeds the maximum file size limit (20MB)",
  41008: "The uploaded file is not supported",
  41009: "The current password does not match",
  41010: "Password and confirm password does not match",
  41011: "You have already responded to the connection request",
  41012: "Duplicate items found",
  41014: "The connection request has been sent to this talent",
  41015: "You haven't send a connection request to this talent",
  41016: "You have been subscribed to Bosshunt newsletter successfully",
  41017: "The pipeline with this name has been created",
  41018: "The resume with this email has been created",
  41019: "Resource not found",
  41020: "To date cannot be before from date",
  41022: "User do not have enough credit to parse",
  41023: "The pipeline not found",
  41024: "The stage not found",
  41025: "Resume ids not found",
  41026: "You are not allowed to edit this comment",
  41027: "The talent with this email has been created",
  41028: "Annual gross salary from cannot be later than annual gross salary to",
  41029: "Monthly fee from cannot be later than monthly fee to",
  41030: "Turnaround time from period cannot be later than turnaround time to period",
  41031: "This record does not exist",
  41032: "Guarantee period from period cannot be later than guarantee period to period",
  41034: "User do not have enough credit to parse the resume",
  41035: "Failed to generate token",
  41036: "Invalid token",
  41037: "Email already verified",
  41038: "Email already exists",
  41039: "This number has already been used for an account Please try a different number",
  41040: "The OTP you have entered is wrong. Please try again",
  41041: "Invalid email",
  41042: "Otp has been used",
  41043: "Otp has been expired",
  41044: "Account has been suspended",
  41045: "Phone number already verified",
  41046: "Not allowed choices",
  41047: "Your account has been suspended Please contact support@bossjobcom for clarification",
  41048: "Invalid user or phone number",
  41049: "Source field is required",
  41050: "Expiration of identity",
  41051: "User has no phone number record",
  41052: "Invalid google crendentials",
  41053: "Invalid linkedin crendentials",
  41054: "Invalid facebook crendentials",
  41055: "Invalid apple crendentials",
  41056: "Your email or code doesn't look right, please try again.",
  41057: "Email is required",
  41058: "User is not exist",
  41059: "Invalid integer list value",
  41060: "Only company coordinator admin can delete this company",
  41061: "Only company admin can upload company document",
  41062: "Company is already verified",
  41063: "Failed to upload document",
  41064: "The uploaded file exceeds the maximum image size limit (4mb)",
  41065: "Missed sync company ids",
  41066: "Company not found",
  41067: "Company is pending verification",
  41069: "Work experience not found",
  41070: "Invalid sort order",
  41071: "Photo not exists at this sort order",
  41072: "Please go through onboarding process",
  41073: "Invalid work experience status",
  41074: "Name already exist",
  41075: "Name contains restricted characters: +",
  41077: "Invalid id or key",
  41078: "Invalid working address",
  41079: "Company is not verified",
  41080: "Invalid user",
  41081: "recruiter is not in selected company",
  41082: "Failed to upload banner",
  41083: "Failed to upload company photo",
  41084: "Failed to upload logo",
  41085: "The uploaded image exceeds the maximum image size limit (5mb)",
  41086: "The uploaded image exceeds the maximum image size limit (1mb)",
  41087: "Time limit exceeded",
  41088: "Cannot delete company coordinator",
  41089: "Cannot change the role of a coordinator",
  41090: "Invalid new admin",
  41091: "Culture ids must be number",
  41092: "Invalid culture ids",
  41093: "Benefit ids must be number",
  41094: "Invalid benefit ids",
  41095: "Parameter value error",
  41096: "Not supported country",
  41097: "Parameter talent ids field is required",
  41098: "Parameter latitude and longitude are required fields",
  41099: "Missed sync job ids",
  41100: "Parameter query field is invalid value",
  41101: "Some locations does not exist",
  41102: "Some job types does not exist",
  41103: "Some salary ranges does not exist",
  41104: "Some job categories does not exist",
  41105: "Some main function does not exist",
  41106: "Some job function id does not exist",
  41107: "Some function job title id does not exist",
  41108: "Some industries does not exist",
  41109: "Some experiences does not exist",
  41110: "Some degrees does not exist",
  41111: "Invalid value",
  41112: "Subscribe job frequency does not exist",
  41113: "This job does not exist",
  41114: "You have not join company",
  41115: "Invalid date from or date to",
  41116: "Auto forward has already been turned off",
  41117: "Auto forward has already been turned on",
  41118: "Auto forward resume permission error",
  41119: "Emails can not be empty",
  41120: "The job salary has already been unmasked",
  41121: "The job salary has already been masked",
  41122: "The recruiter has no permission to mask salary",
  41123: "The recruiter has no enough job credits",
  41124: "The job has already been upgraded to a featured job",
  41125: "Enter a valid email address",
  41126: "The recruiter has no company",
  41127: "The job has already been closed",
  41128: "Query params is invalid value",
  41129: "The job has already been upgraded to an urgent job",
  41130: "Cannot input “-” in this field",
  41131: "User id field is required",
  41132: "This job is not found",
  41133: "Jobseeker resume is not found",
  41134: "Your job application is being processed",
  41135: "Parameter user id is required",
  41136: "All the screening questions are required to be answered",
  41137: "Invalid report job reason",
  41139: "Exist contact exchange request in progress",
  41140: "Not allowed to chat with yourself",
  41141: "Attendance was marked already",
  41142: "Invalid interview status",
  41143: "Invalid time to mark attendance, must be more than 30minutes after interview started",
  41145: "Not allowed update interview status",
  41146: "Not allowed to check",
  41147: "You have already checked in for this interview",
  41148: "You are able to check in starting from two hours before the interview commence",
  41149: "You are able to check in latest half an hour after the interview commence",
  41150: "This job does not exist",
  41151: "This job is not active",
  41152: "Not allowed to cancel upcoming interview",
  41153: "The interview time must be greater than the current time",
  41154: "Exist interview in progress",
  41155: "Request has already been disabled",
  41156: "Job Not found",
  41157: "Invalid resume id",
  41158: "Unable to setup auto-send resume for chat in progress",
  41159: "Exist location confirmation in progress",
  41162: "Exist resume request in progress",
  41163: "The results of this interview have been requested",
  41164: "Parameter talent id field is required",
  41165: "Parameter talent ids field is required",
  41167: "Ensure start date field is earlier than end date",
  41168: "Address already exists",
  41169: "Id length cannot be greater than 1000",
  41170: "More than three resumes have been submitted",
  41171: "OTP expired",
  41172: "OTP already used",
  41173: "The phone number has been taken",
  41174: "The uploaded file exceeds the maximum file size limit (5 MB)",
  41175: "The uploaded file extension is not supported",
  41176: "The uploaded image exceeds the maximum image size limit (500kb)",
  41177: "Invalid ids value",
  41178: "Invalid job order",
  41179: "Filename field is required",
  41181: "You can only have max 10 common phrases",
  41182: "Ensure issue date is earlier than expiry date, expiry date is later than issue date",
  41183: "Invalid attachment url",
  41184: "Mobile error",
  41185: "Body error",
  41186: "You cannot delete resume that selected for auto sent resume",
  41187: "User,sender must be consistent",
  41188: "User,receiver must be consistent",
  41191: "Work experience not found",
  41192: "Invalid work experience status, not able to join this company",
  41194: "Cannot join unverified company",
  41196: "Only company admin can perform verification for recruiter to join this company",
  41197: "You cannot perform verification for yourself to join this company",
  41198: "Recruiter is not found",
  41199: "Recruiter did not request to join this company",
  41201: "Recruiter has no company record",
  41202: "Recruiter is not company coordinator",
  41204: "Missing role key",
  41205: "Company admin cannot leave company without transferring admin ownership",
  41207: "The uploaded image exceeds the maximum image size",
  41208: "Description is required",
  41209: "Date is required",
  41213: "Talent was already removed",
  41214: "Parameter removed reason field is required",
  41217: "Invalid job id",
  41219: "You have not join company",
  41221: "Content type only supports application/x-www-form-urlencoded and is required when request method is post",
  41222: "request method only supports post or get methods",
  41223: "Not allowed category",
  41224: "If is auto reply chat field is true, need message data",
  41225: "You don't have permission setting auto reply",
  41226: "Please provide query parameter message type id",
  41227: "User not registered",
  41228: "Greetings,Not suitable message and auto reply message could not contains email and phone number",
  41229: "Company listing info not found",
  41230: "recruiter work experience not found",
  41231: "You are the coordinator of the company and cannot perform the current operation",
  41232: "Company not claimed",
  41233: "You dont have permission delete this chat",
  41234: "Your phone number doesn't look right, please re-enter",
  41235: "Invalid link",
  41236: "You have entered an incorrect phone or area code",
  41237: "Your phone number verification failed or timed out",
  41238: "Work experience start time must be less than end time",
  41239: "Event not found",
  41240: "The event has not started yet",
  41241: "The event has ended",
  41242: "You has not participated in this event",
  41243: "Reward is fully redeemed",
  41244: "Reached redeem limit",
  41245: "More than three video resumes have been submitted",
  41246: "Not enough points to withdraw",
  41247: "Minimum withdraw amount is 100 points for Tron(TRC20)",
  41248: "Minimum withdraw amount is 1000 points for Ethereum(ERC20)",
  41249: "Withdraw amount multiplier is 100 points",
  41250: "Invalid Tron(TRC20) address",
  41251: "Invalid Ethereum(ERC20) address",
  41252: "Query exceeds limit",
  41253: "Ensure that there are no more than 10 digits before the decimal point",
  41254: "Resume cannot exceed 5 copies",
  41255: "This resume is not yours",
  41256: "No more than 30",
  41257: "The number of times has been used up",
  41258: "You cannot obtain data for this user",
  41259: "The time cannot be greater than the current time",
  41260: "Invalid verification",
  41262: "You cannot created more than 3 remote job preferences",
  41263: "You cannot created more than 3 on-site or hybrid job preferences",
  41264: "Supported resume file types are pdf,doc,docx",
  41265: "Supported video file types are mp4,avi,mov,wmv,flv,mkv,mpeg,webm,3gp,ogg",
  41266: "The import-task already exists within our company",
  41267: "Unsupported import link",
  41268: "You do not have permission to perform this operation",
  41269: "Only 10 people can be invited at a time",
  41270: "The selected role ID does not match the value",
  41271: "Invalid line crendentials",
  41272: "Invalid x crendentials",
  41273: "The invitation link has expired",
  41274: "Your identity information does not match the position you submitted, and you cannot start a chat with the employer for this position.",
  41275: "Due to bandwidth issues, you have exceeded the allowable limit of queries for AICV. Please try again in 24 hours.",
  41276: "The number of brands or products added exceeds the limit.",
  41277: "The number of related pictures added for a brand or product exceeds the limit.",
  41278: "The uploaded url does not meet the specifications.",
  41279: "The job reminder content you set is duplicated, please modify it and save it.",
  41280: "Apologies, AI is currently unavailable due to an error. Please try again later.",
  41281: "Resume parsing failed, please make sure you upload the correct resume.",
  48905: "The email has been registered",
  50001: "Internal server error",
  50002: "Failed to upload resume",
  50003: "Missing profiles",
  50004: "This contact exchange request has been processed",
  50005: "You don't have enough unlock talent credits",
  50006: "Not found interview message",
  50007: "This resume request has been processed",
  50008: "Failed to upload profile picture",
  50009: "Unlocked talent failed",
  50010: "Parameter ids is required",
  50011: "The talent has been unlocked",
  50012: "Parameter resume last updated name is invalid value",
  50013: "No result found at the moment Please try again",
  50014: "Search salary is fail",
  50015: "You have joined another company,Please log in to the management backend again and exit the company before joining another company"
}, Li = {
  title: "欢迎来到",
  tips: "寻找人才? 登录 ",
  continueWith: "使用其他方式",
  agreement: "我已经阅读并同意 {{value1}} 和 {{value2}}",
  emailValid: "请输入有效的电子邮件地址。",
  emailLabel: "邮箱",
  sendCodeDigit: "请输入我们发送的6位验证码 ",
  checkSpamEmail: "如果您没有收到验证码，请检查您的垃圾邮件",
  otherOptions: "其他登录方式",
  alternatively: "或者, 请求一个",
  resendCode: "重新发送验证码",
  country: "国家",
  phoneNumber: "电话号码",
  twoFactor: "安全验证",
  authentication: "验证",
  secure: "为确保账户安全，请在邮箱中查收验证码。",
  emailTips: "登录方式与上次登录不一致，请通过电子邮件验证安全",
  setUpLater: "稍后设置",
  enableTwoFactor: "双重验证",
  authenticationEnabled: "验证已启用",
  factorTip: "如果我们发现有人试图通过我们无法识别的设备或浏览器登录，我们会要求您向您的电子邮件地址发送代码。",
  verifyText: "二次身份验证",
  verifyExtra: "这个额外的步骤表明确实是您在尝试登录。",
  optError: "发送OTP失败",
  resendEmailCode: "重新发送邮箱OTP成功",
  invalidOtp: "您输入的验证码有误。请重试。",
  resendPhoneCode: "重新发送电话OTP成功",
  verifyEmail: "验证邮箱",
  thisPhoneNumberAssociated: "选择帐号",
  accounts: "帐号",
  thisPhoneNumber: "此电话号码已关联的账号 ",
  youNeedToChooseVerified: "您需要选择一个经过验证的电子邮件地址进行关联",
  validateErr: "电子邮件已注册。请更改绑定到另一个email",
  checkYourSpam: "如果您没有收到验证码，请检查您的垃圾邮件。",
  authenticationSuccessful: "验证成功",
  Bossjob: "Bossjob",
  back: "返回",
  vipText: {
    GetVipPrivilegesImmediately: "立即获取 VIP 特权",
    InviteNewUsersToRegister: "邀请新用户注册",
    BossjobAI: "Bossjob AI",
    ResumeAssistant: "简历助手",
    HighSalaryOffer: "高薪职位",
    HelpYouGet: "帮助您获取",
    promptDesc: "您已经登录；无法重复注册。请退出登录后再试一次。",
    returnHome: "返回首页",
    signOut: "退出",
    inviteFriendsToGet: "邀请好友加入",
    AIResumeCoaching: "解锁AI简历辅导功能",
    HighQualityVIPResumeTemplateAndAIAssistantToHelpYouGetHighPayingOffer: "高质量 VIP 简历模板和 AI 助手助您获得高薪职位。",
    copyLinkToInviteNow: "立即复制邀请链接"
  },
  links: {
    apple: "使用Apple账号继续",
    google: "使用Google账号继续",
    facebook: "使用Facebook账号继续",
    appleText: "Apple",
    line: "使用Line账号登录",
    twitter: "使用X账号登录"
  },
  seoMetaTitle: "注册求职账号，马上开始找工作 | Bossjob",
  JoinBossjob: "上Bossjob",
  kickStartYourCareer: "和老板直接聊工作！",
  enterYourEmailAddress: "输入你的电子邮箱地址",
  submit: "提交",
  "pleaseEnterAvalidEmailAddress.": "请输入有效的电子邮件地址。",
  bySigningUp: "注册即表示我已阅读并同意",
  termsOfUse: "使用条款",
  and: "和",
  privacyPolicy: "隐私政策",
  signInWith: "其他登录方式",
  lookingToHire: "我要招聘！",
  employer: "点击此处免费注册企业账号",
  welcomeBack: "欢迎回来！",
  signUpAnAccount: "注册新帐户",
  pleaseEnter: "请输入我们发送的6位一次性密码",
  enter6DigitOTP: "输入 6 位数验证码",
  getOPT: "获得验证码",
  heOTPYouHaveEnteredIsWrong: "您输入的一次性密码有误。请重试。",
  resendOTP: "重新发送",
  havingTrouble: "您需要帮助吗？",
  requestAmagicLink: "请求魔术链接",
  seoMetaDescription: "立即加入Bossjob，直接和老板聊职位！加入300万全球顶尖人才，立即体验最高效的找工作平台在",
  seoMetaDescription2: "2百万注册求职者在线等你",
  magicLinkText: "魔术链接",
  magicLink: {
    welcomeBack: "欢迎回来！",
    signUp: "注册一个账户",
    haveSendEmail: "我们已向{{email}}发送了一个魔法链接。 请点击链接继续。",
    toHome: "回到主页"
  },
  loginUsingSocialMediaOTP: "验证码登录/注册",
  loginUsingQRCode: "使用二维码登录",
  scanQRCodeOnAppToLogin: "使用Bossjob APP扫描二维码即可登录",
  donHaveApp: "没有应用程序",
  sendCode: "发送验证码",
  howToScanQRCode: "如何扫描二维码",
  ImJobSeeker: "我是一名求职者",
  ImRecruiter: "我是招聘人员",
  menuLoginToVersion: "菜单 > 登录网页版",
  scannedSuccessfully: "扫描成功",
  pleaseConfirmLoginOnAPP: "请在APP上确认登录",
  pleaseRefreshQrCode: "请刷新二维码",
  clickToRefresh: "点击刷新",
  accountMismatch: "账户类型不匹配，请使用求职端登录",
  loginWithQRCode: "扫描二维码登录",
  email: "邮件",
  phone: "电话",
  haveSendEmail: "我们已向{{email}}发送了一个魔法链接。 请点击链接继续。",
  leftBanner: {
    free: "免费",
    lifetime: "终身",
    quick: "高效率",
    production: "制作",
    aIAssisted: "AI助手",
    resumeEditing: "编辑简历",
    aGoodResume: "一份优秀的简历",
    aGoodResumeDesc: "平均工资提高 37%"
  },
  enterYourEmail: "请输入您的邮箱",
  verificationEmailCode: "我们将向您的电子邮箱发送验证码",
  confirmationCode: "输入验证码",
  enterOTP: "请输入我们发送给您的 6 位验证码",
  verificationPhoneCode: "我们会向您的手机发送验证码",
  enterYourPhone: "输入手机号码",
  connectYourEmail: "请关联您的电子邮件",
  connectYourEmailTip: "只需输入您的电子邮件地址即可完成注册或登录 Bossjob。",
  downloadApp: "下载APP",
  neptune: "Neptune",
  neptuneOffersJob: "Neptune offers job seekers verified, current information on companies hiring, enabling informed career decisions."
}, Mi = {
  getStarted: Li
}, Di = {
  0: "成功",
  40001: "参数验证失败或无效",
  40002: "缺少身份验证",
  40003: "未提供身份验证凭据",
  40004: "资源未找到",
  40005: "您没有执行此操作的权限",
  40006: "尝试次数过多。请在 {{retry_after}} 秒后重试",
  41001: "电子邮件已被使用",
  41002: "客户端ID已被占用",
  41003: "密钥已被使用",
  41004: "用户必须有电子邮件地址",
  41005: "注册此电子邮件失败",
  41006: "无法更新状态",
  41007: "上传的文件超过最大文件大小限制(20MB)",
  41008: "不支持该格式文档的上传",
  41009: "您的当前密码不匹配。",
  41010: "密码和确认密码不一致",
  41011: "您已经响应了连接请求",
  41012: "发现重复项",
  41014: "连接请求已发送到该人才",
  41015: "您尚未向该人才发送连接请求",
  41016: "您已成功订阅了Bosshunt 简讯",
  41017: "已创建具有此名称的管道",
  41018: "已创建此电子邮件的简历",
  41019: "资源未找到",
  41020: "截止日期不能早于起始日期",
  41022: "用户没有足够的积分来解析",
  41023: "找不到管道",
  41024: "找不到阶段",
  41025: "找不到Resume",
  41026: "您无权编辑此评论",
  41027: "已创建此电子邮件的简历",
  41028: "年薪毛额开始不得晚于年薪毛额",
  41029: "月费不得晚于月费到",
  41030: "从时间到时间之间的转弯时间不能晚于转弯时间到时间段",
  41031: "记录不存在",
  41032: "从担保期到担保期不能晚于担保期",
  41034: "用户没有足够的积分来解析",
  41035: "生成密钥失败",
  41036: "无效的凭证",
  41037: "电子邮件地址已验证",
  41038: "邮箱已经存在",
  41039: "此号码已被用于一个帐户，请尝试不同的号码",
  41040: "您输入的验证码有误，请重试",
  41041: "邮箱格式错误",
  41042: "Otp 已被使用",
  41043: "验证码已过期",
  41044: "您的账户已被停用",
  41045: "电话号码通过验证",
  41046: "不允许选择",
  41047: "您的帐户已被暂停。请联系 support@bossjobcom 以获取澄清信息",
  41048: "无效的电话号码",
  41049: "source是必填项",
  41050: "身份的过期",
  41051: "用户没有电话号码记录",
  41052: "无效的 google crendentials",
  41053: "无效的领英证书",
  41054: "无效的 facebook crendentials",
  41055: "无效的苹果crendentials",
  41056: "您的邮件或验证码看起来不对，请重新输入。",
  41057: "电子邮件为必填",
  41058: "用户不存在",
  41059: "无效整数列表值",
  41060: "只有公司Coordinator 管理员可以删除这个公司",
  41061: "只有公司管理员可以上传公司文档",
  41062: "公司已被验证",
  41063: "上传文档失败",
  41064: "上传的文件超过最大图像大小限制(4mb)。",
  41065: "错过同步公司",
  41066: "未找到公司",
  41067: "公司正在等待验证",
  41069: "找不到工作经历",
  41070: "无效排序顺序",
  41071: "照片不存在于此排序顺序",
  41072: "请通过登机过程",
  41073: "无效的工作体验状态",
  41074: "名称已存在",
  41075: "名称包含受限字符：+",
  41077: "无效ID或密钥",
  41078: "无效的工作地址",
  41079: "公司未验证",
  41080: "无效用户",
  41081: "招聘者不在选定的公司",
  41082: "上传横幅失败",
  41083: "上传公司照片失败",
  41084: "上传徽标失败",
  41085: "上传的图像超过最大图像大小限制 (5mb)",
  41086: "上传的图像超过最大图像大小限制 (5mb)",
  41087: "超过时间限制",
  41088: "无法删除公司Coordinator",
  41089: "无法更改 Coordinator 的角色",
  41090: "无效的新管理员",
  41091: "文化ID必须是数字",
  41092: "无效的文化",
  41093: "福利ID必须是数字",
  41094: "无效的福利ID",
  41095: "参数错误",
  41096: "不支持的国家",
  41097: "参数天赋ID字段是必需的",
  41098: "参数纬度和经度是必填字段",
  41099: "缺失同步作业ID",
  41100: "参数查询字段是无效值",
  41101: "存储位置不存在",
  41102: "存储位置不存在",
  41103: "某些薪金范围不存在",
  41104: "某些工作类别不存在",
  41105: "某些主要功能不存在",
  41106: "一些作业函数 id 不存在",
  41107: "一些函数作业标题不存在",
  41108: "某些行业不存在",
  41109: "有些经验不存在",
  41110: "某些度不存在",
  41111: "无效值",
  41112: "订阅作业频率不存在",
  41113: "此作业不存在",
  41114: "您还没有加入公司",
  41115: "无效的开始日期或结束日期",
  41116: "自动前进已被关闭",
  41117: "自动前进已被关闭",
  41118: "自动转发恢复权限错误",
  41119: "邮件不能为空",
  41120: "工作薪资已经取消了掩码",
  41121: "工作工资已被蒙版",
  41122: "征聘者无权掩盖报酬",
  41123: "招聘者没有足够的工作积分",
  41124: "作业已升级为精选工作",
  41125: "请输入一个有效的电子邮件地址",
  41126: "招聘者没有公司",
  41127: "工作已经被关闭",
  41128: "查询参数无效的值",
  41129: "作业已升级为紧急工作",
  41130: "无法在此字段输入“-”",
  41131: "用户为必填项",
  41132: "找不到此作业",
  41133: "找不到求职者简历",
  41134: "正在处理您的作业申请",
  41135: "参数用户ID是必需的",
  41136: "需要回答所有筛选问题",
  41137: "无效报告作业原因",
  41139: "正在进行联系人交换请求",
  41140: "不允许给自己授权",
  41141: "出席情况已被标记",
  41142: "无效的面试状态",
  41143: "无效时间标记出勤，必须在约谈开始后超过 30分钟",
  41145: "不允许更新面试状态",
  41146: "不允许签入",
  41147: "您已经为这次面试签入",
  41148: "您可以从开始面试前的两个小时开始检查",
  41149: "您可以在面试开始后的最晚半小时内检查",
  41150: "此作业不存在",
  41151: "此作业未激活",
  41152: "不允许取消即将进行的面试。",
  41153: "面谈时间必须大于当前时间",
  41154: "面试已存在",
  41155: "请求已被禁用",
  41156: "工作未找到",
  41157: "无效的简历编号",
  41158: "无法为正在进行的聊天设置自动发送",
  41159: "正在确认所在位置",
  41162: "继续请求正在进行中",
  41163: "这次面谈的结果已经被要求了",
  41164: "参数求职者字段是必需的",
  41165: "人才字段是必填项",
  41167: "确保开始日期字段早于结束日期",
  41168: "地址已存在",
  41169: "Id 长度不能大于 1000",
  41170: "已提交三次以上的简历。",
  41171: "验证码已过期",
  41172: "OTP 已被使用",
  41173: "电话号码已被使用",
  41174: "上传的文件超过最大文件大小限制 (5 MB)",
  41175: "不支持上传的文件扩展名",
  41176: "上传的图像超过最大图像大小限制 (500kb)",
  41177: "无效值",
  41178: "无效的作业顺序",
  41179: "文件名是必填项",
  41181: "您只能拥有最多10个常用短语",
  41182: "确保发行日期早于过期日期，过期日期晚于发行日期",
  41183: "无效的附件url",
  41184: "移动设备错误",
  41185: "内容错误",
  41186: "您不能删除为自动发送简历而选择的简历",
  41187: "用户，发送者必须一致。",
  41188: "用户，接收者必须一致。",
  41191: "找不到工作经验",
  41192: "无效的工作体验状态，不能加入此公司",
  41194: "无法加入未经验证的公司",
  41196: "只有公司管理员可以验证招募者加入这个公司",
  41197: "您不能验证自己加入这个公司",
  41198: "找不到招聘者",
  41199: "招募者没有请求加入这个公司",
  41201: "招聘者没有公司记录",
  41202: "招募者不是公司Coordinator",
  41204: "缺少角色键",
  41205: "公司管理员不能不转移管理员所有权就离开公司",
  41207: "上传图片大小超过上限",
  41208: "请输入描述",
  41209: "日期是必填项",
  41213: "人才已被移除",
  41214: "缺失移除原因",
  41217: "工作ID无效",
  41219: "您还没有加入公司",
  41221: "内容类型仅支持应用程序/x-www-form-urlencoded",
  41222: "请求方法仅支持GET或POST方法",
  41223: "不允许的类别",
  41224: "如果自动回复聊天字段为真，需要消息数据",
  41225: "您没有权限设置自动回复",
  41226: "请提供查询参数消息类型",
  41227: "用户未注册",
  41228: "问候，不适合的消息和自动回复消息不能包含电子邮件和电话号码",
  41229: "未找到公司融资信息",
  41230: "找不到工作经历",
  41231: "您是公司的管理员，无法执行当前操作",
  41232: "公司未被认领",
  41233: "您没有权限删除此会话",
  41234: "您的电话号码看起来不正确，请重新输入",
  41235: "无效的链接",
  41236: "您输入了不正确的电话或区域代码",
  41237: "您的电话号码验证失败或超时",
  41238: "工作经历开始时间必须小于结束时间",
  41239: "未找到该活动",
  41240: "活动尚未开始",
  41241: "活动已结束",
  41242: "您尚未参与此活动",
  41243: "奖励已被领取完毕",
  41244: "已达到领取上限",
  41245: "已提交三次以上的简历",
  41246: "兑换积分余额不足",
  41247: "Tron(TRC20) 最低兑换积分为100分",
  41248: "Ethereum(ERC20) 最低兑换积分为1000分",
  41249: "请以100分为最小单位的整数来进行兑换",
  41250: "Tron(TRC20) 地址错误",
  41251: "Ethereum(ERC20) 地址错误",
  41252: "查询超出限制",
  41253: "确保小数点前不超过 10 位数字",
  41254: "简历不能超过 5 个副本",
  41255: "这个简历不是你的",
  41256: "不能超过 30 个",
  41257: "次数已经使用完",
  41258: "您不能获取此用户的数据",
  41259: "时间不能大于当前时间",
  41260: "无效的验证",
  41262: "无法创建超过 3 个远程工作偏好",
  41263: "无法创建超过3个本地或混合型工作偏好",
  41264: "支持的简历文件类型有 pdf、doc、docx",
  41265: "支持的视频文件类型有 mp4、avi、mov、wmv、flv、mkv、mpeg、webm、3gp、ogg",
  41266: "导入任务已经存在于我们公司内部",
  41267: "不支持的导入链接",
  41268: "You do not have permission to perform this operation",
  41269: "Only 10 people can be invited at a time",
  41270: "The selected role ID does not match the value",
  41271: "Invalid line crendentials",
  41272: "Invalid x crendentials",
  41273: "The invitation link has expired",
  41274: "Your identity information does not match the position you submitted, and you cannot start a chat with the employer for this position.",
  41275: "由于带宽问题，您已超出AICV允许的查询限制。请在24小时后再尝试。",
  41276: "The number of brands or products added exceeds the limit.",
  41277: "The number of related pictures added for a brand or product exceeds the limit.",
  41278: "The uploaded url does not meet the specifications.",
  41279: "The job reminder content you set is duplicated, please modify it and save it.",
  41280: "Apologies, AI is currently unavailable due to an error. Please try again later.",
  41281: "Resume parsing failed, please make sure you upload the correct resume.",
  48905: "该邮箱已经被注册",
  50001: "服务器内部错误",
  50002: "上传简历失败",
  50003: "缺失配置",
  50004: "此联系人交换请求已被处理",
  50005: "您没有足够的解锁人才的积分",
  50006: "未找到面试消息",
  50007: "简历请求已被处理",
  50008: "图片上传失败",
  50009: "解锁人才失败",
  50010: "参数缺失",
  50011: "人才已经解锁",
  50012: "简历最后更新的名称是无效的值",
  50013: "目前没有找到结果。请再试一次",
  50014: "搜索薪资失败",
  50015: "You have joined another company,Please log in to the management backend again and exit the company before joining another company"
}, Gi = {
  title: "Selamat Datang di",
  tips: "Ingin mempekerjakan orang? Daftar sebagai ",
  continueWith: "atau lanjutkan dengan",
  agreement: "Saya telah membaca dan menyetujui {{value1}} dan {{value2}}",
  emailValid: "Silakan isi alamat email.",
  emailLabel: "Alamat email",
  sendCodeDigit: "Silakan masukkan 6 digit kode yang kami kirimkan ",
  checkSpamEmail: "Periksa email spam Anda jika Anda tidak menerima kode",
  otherOptions: "pilihan lain",
  alternatively: "Alternatifnya, minta a",
  resendCode: "Kirim ulang kode",
  country: "Negara",
  phoneNumber: "Nomor telepon",
  twoFactor: "Verifikasi Keamanan",
  authentication: "autentikasi",
  secure: "Amankan akun Anda dan terima kode di email Anda",
  emailTips: "Metode login tidak sesuai dengan login terakhir, harap verifikasi keamanan melalui email",
  setUpLater: "Atur ini nanti",
  enableTwoFactor: "dua faktor",
  authenticationEnabled: "otentikasi diaktifkan",
  factorTip: "Jika kami melihat adanya upaya login dari perangkat atau browser yang tidak kami kenali, kami akan meminta kode yang dikirimkan ke alamat email Anda.",
  verifyText: "Verifikasi bahwa itu memang Anda",
  verifyExtra: "Langkah tambahan ini menunjukkan bahwa memang Anda yang mencoba masuk.",
  optError: "Kirim OTP gagal",
  resendEmailCode: "Kirim ulang email 'OTP sukses",
  invalidOtp: "OTP yang Anda masukkan salah. Silakan coba lagi.",
  resendPhoneCode: "Kirim ulang telepon'OTP sukses",
  verifyEmail: "Verifikasi email",
  thisPhoneNumberAssociated: "Pilih akun",
  accounts: "akun.",
  thisPhoneNumber: "Nomor telepon ini dikaitkan dengan ",
  youNeedToChooseVerified: "Anda harus memilih alamat email terverifikasi untuk dikaitkan",
  validateErr: "Email telah didaftarkan. Silakan ubah pengikatannya ke email lain",
  checkYourSpam: "Periksa email spam Anda jika Anda tidak menerima kode.",
  authenticationSuccessful: "Otentikasi Berhasil",
  Bossjob: "Bossjob",
  back: "Kembali",
  vipText: {
    GetVipPrivilegesImmediately: "Dapatkan Hak Istimewa VIP Segera",
    InviteNewUsersToRegister: "Undang Pengguna Baru Untuk Mendaftar",
    BossjobAI: "Pekerjaan bos AI",
    ResumeAssistant: "Asisten Resume",
    HighSalaryOffer: "Tawaran Gaji Tinggi",
    HelpYouGet: "Membantu Anda Mendapatkan",
    promptDesc: "Ups, Anda sudah masuk; mendaftar berulang kali tidak mungkin. Silakan logout dan coba lagi.",
    returnHome: "Kembali ke Beranda",
    signOut: "Keluar",
    inviteFriendsToGet: "Undang Teman Untuk Mendapatkan",
    AIResumeCoaching: "PELATIHAN RESUME AI",
    HighQualityVIPResumeTemplateAndAIAssistantToHelpYouGetHighPayingOffer: "Templat Resume VIP Berkualitas Tinggi Dan Asisten AI Untuk Membantu Anda Mendapatkan Penawaran Berbayar Tinggi.",
    copyLinkToInviteNow: "Salin tautan untuk mengundang sekarang"
  },
  links: {
    apple: "Lanjutkan dengan Apple",
    google: "Lanjutkan dengan Google",
    facebook: "Lanjutkan dengan Facebook",
    appleText: "Apple",
    line: "Lanjutkan dengan Line",
    twitter: "Lanjutkan dengan X"
  },
  seoMetaTitle: "Memulai | Bossjob",
  JoinBossjob: "Bergabunglah dengan Bossjob",
  kickStartYourCareer: "mulailah karir Anda!",
  enterYourEmailAddress: "Masukkan alamat email",
  submit: "Kirim",
  "pleaseEnterAvalidEmailAddress.": "Silakan isi alamat email.",
  bySigningUp: "Dengan mendaftar, saya telah membaca dan menyetujui",
  termsOfUse: "Syarat Penggunaan",
  and: "dan",
  privacyPolicy: "Kebijakan Privasi",
  signInWith: "Masuk dengan",
  lookingToHire: "Ingin mempekerjakan orang? Daftar sebagai ",
  employer: "Pemberi pekerjaan",
  welcomeBack: "Selamat datang kembali!",
  signUpAnAccount: "Daftarkan akun",
  pleaseEnter: "Silakan masukkan 6 digit kata sandi satu kali yang kami kirimkan",
  enter6DigitOTP: "Masukkan OTP 6 digit",
  getOPT: "dapatkan OPT",
  heOTPYouHaveEnteredIsWrong: "OTP yang Anda masukkan salah. Silakan coba lagi.",
  resendOTP: "Kirim ulang OTP",
  havingTrouble: "Mempunyai masalah?",
  requestAmagicLink: "Minta Magic Link",
  seoMetaDescription: "Bergabunglah dengan Bossjob untuk mempercepat karir profesional Anda hari ini! Akses kursus dan peluang kerja di ",
  seoMetaDescription2: "Jaringan 2 juta+ profesional.",
  magicLinkText: "tautan ajaib",
  magicLink: {
    welcomeBack: "Selamat Datang kembali!",
    signUp: "Daftarkan akun",
    haveSendEmail: "Kami telah mengirimkan tautan ajaib ke {{email}}. Silakan klik tautan untuk melanjutkan.",
    toHome: "Kembali ke halaman beranda"
  },
  loginUsingSocialMediaOTP: "Login menggunakan media sosial/OTP",
  loginUsingQRCode: "Masuk menggunakan kode QR",
  scanQRCodeOnAppToLogin: "Pindai kode ini dengan aplikasi Bossjob untuk login secara instan",
  donHaveApp: "Tidak punya Aplikasi",
  sendCode: "Kirim kode verifikasi",
  howToScanQRCode: "Cara memindai kode QR",
  ImJobSeeker: "Saya Pencari Kerja",
  ImRecruiter: "Saya Perekrut",
  menuLoginToVersion: "Menu > Masuk ke versi web",
  scannedSuccessfully: "Berhasil dipindai",
  pleaseConfirmLoginOnAPP: "Harap konfirmasi login di APP",
  pleaseRefreshQrCode: "Harap segarkan kode QR",
  clickToRefresh: "Klik untuk menyegarkan",
  accountMismatch: "Jenis akun tidak cocok, silakan gunakan lamaran pekerjaan untuk login",
  loginWithQRCode: "Masuk dengan kode QR",
  email: "Email",
  phone: "Telepon",
  haveSendEmail: "Kami telah mengirimkan tautan ajaib ke {{email}}. Silakan klik tautan untuk melanjutkan.",
  leftBanner: {
    free: "Gratis",
    lifetime: "Seumur hidup",
    quick: "Cepat",
    production: "Produksi",
    aIAssisted: "Dibantu AI",
    resumeEditing: "Pengeditan resume",
    aGoodResume: "Resume yang Bagus",
    aGoodResumeDesc: "Meningkatkan Gaji Anda Rata-Rata 37%"
  },
  enterYourEmail: "Masukan email Anda",
  verificationEmailCode: "Kami akan mengirimkan kode verifikasi ke email Anda",
  confirmationCode: "Masukan kode konfirmasi",
  enterOTP: "Silakan masukkan 6 digit kode yang kami kirimkan",
  verificationPhoneCode: "Kami akan mengirimkan kode verifikasi ke telepon Anda",
  enterYourPhone: "Masukan nomor telepon Anda",
  connectYourEmail: "Silakan sambungkan email Anda",
  connectYourEmailTip: "Kami hanya membutuhkan alamat email Anda untuk menyelesaikan pendaftaran atau masuk ke Bossjob.",
  downloadApp: "Unduh aplikasi",
  neptune: "Neptunus",
  neptuneOffersJob: "Neptunus menawarkan kepada para pencari kerja informasi terkini yang telah terverifikasi mengenai perusahaan yang sedang merekrut, yang akan membantu para pencari kerja untuk mengambil keputusan karir yang tepat."
}, _i = {
  getStarted: Gi
}, $i = {
  0: "Kesuksesan",
  40001: "Validasi parameter gagal atau tidak valid",
  40002: "Kredensial autentikasi salah",
  40003: "Kredensial otentikasi tidak diberikan",
  40004: "Sumber tidak ditemukan",
  40005: "Anda tidak memiliki izin untuk melakukan tindakan ini",
  40006: "Sudah terlalu banyak upaya. Silakan coba lagi dalam {{retry_after}} detik",
  41001: "Email sudah diambil",
  41002: "Id klien telah diambil",
  41003: "Kunci rahasia telah diambil",
  41004: "Pengguna harus memiliki alamat email",
  41005: "Gagal mendaftarkan email ini",
  41006: "Tidak dapat memperbarui status",
  41007: "File yang diupload melebihi batas ukuran file maksimal (20 Mb)",
  41008: "File yang diunggah tidak didukung",
  41009: "Kata sandi saat ini tidak cocok",
  41010: "Kata sandi dan konfirmasi kata sandi tidak cocok",
  41011: "Anda telah menanggapi permintaan koneksi",
  41012: "Item duplikat ditemukan",
  41014: "Permintaan koneksi telah dikirim ke talenta ini",
  41015: "Anda belum mengirimkan permintaan koneksi ke talenta ini",
  41016: "Anda telah berhasil berlangganan buletin Bosshunt",
  41017: "Saluran pipa dengan nama ini telah dibuat",
  41018: "Resume dengan email ini telah dibuat",
  41019: "Sumber tidak ditemukan",
  41020: "Hari ini tidak boleh sebelum tanggal",
  41022: "Pengguna tidak memiliki kredit yang cukup untuk mengurai",
  41023: "Saluran pipa tidak ditemukan",
  41024: "Panggung tidak ditemukan",
  41025: "Id resume tidak ditemukan",
  41026: "Anda tidak diperbolehkan mengedit komentar ini",
  41027: "Bakat dengan email ini telah diciptakan",
  41028: "Gaji kotor tahunan dari tidak boleh lebih dari gaji kotor tahunan sampai",
  41029: "Biaya bulanan dari tidak boleh lebih lambat dari biaya bulanan ke",
  41030: "Waktu penyelesaian dari suatu periode tidak boleh lebih lambat dari waktu penyelesaian ke periode",
  41031: "Catatan ini tidak ada",
  41032: "Masa jaminan dari periode tidak boleh lebih lama dari periode jaminan ke periode",
  41034: "Pengguna tidak memiliki kredit yang cukup untuk mengurai resume",
  41035: "Gagal membuat token",
  41036: "Token tidak valid",
  41037: "Email sudah diverifikasi",
  41038: "Email sudah ada",
  41039: "Nomor ini sudah digunakan untuk sebuah akun. Silakan coba nomor lain",
  41040: "OTP yang Anda masukkan salah. Silakan coba lagi",
  41041: "Email tidak valid",
  41042: "Otp telah digunakan",
  41043: "Otp telah kedaluwarsa",
  41044: "Akun telah ditangguhkan",
  41045: "Nomor telepon sudah diverifikasi",
  41046: "Pilihan yang tidak diperbolehkan",
  41047: "Akun Anda telah ditangguhkan Silakan hubungi support@bossjobcom untuk klarifikasi",
  41048: "Pengguna atau nomor telepon tidak valid",
  41049: "Bidang sumber diperlukan",
  41050: "Kedaluwarsa identitas",
  41051: "Pengguna tidak memiliki catatan nomor telepon",
  41052: "Kredensial Google tidak valid",
  41053: "Kredensial linkedin tidak valid",
  41054: "Kredensial facebook tidak valid",
  41055: "Kredensial Apple tidak valid",
  41056: "Alamat email atau kode verifikasi Anda salah. Silakan masukkan kembali.",
  41057: "Email diperlukan",
  41058: "Pengguna tidak ada",
  41059: "Nilai daftar bilangan bulat tidak valid",
  41060: "Hanya admin koordinator perusahaan yang dapat menghapus perusahaan ini",
  41061: "Hanya admin perusahaan yang dapat mengunggah dokumen perusahaan",
  41062: "Perusahaan sudah diverifikasi",
  41063: "Gagal mengunggah dokumen",
  41064: "File yang diupload melebihi batas ukuran gambar maksimal (4mb)",
  41065: "Id perusahaan sinkronisasi tidak terjawab",
  41066: "Perusahaan tidak ditemukan",
  41067: "Perusahaan menunggu verifikasi",
  41069: "Pengalaman kerja tidak ditemukan",
  41070: "Urutan sortir tidak valid",
  41071: "Foto tidak ada dalam urutan ini",
  41072: "Silakan melalui proses orientasi",
  41073: "Status pengalaman kerja tidak valid",
  41074: "Nama sudah ada",
  41075: "Nama berisi karakter yang dibatasi: +",
  41077: "Id atau kunci tidak valid",
  41078: "Alamat kerja tidak valid",
  41079: "Perusahaan tidak terverifikasi",
  41080: "Pengguna tidak valid",
  41081: "perekrut tidak ada di perusahaan terpilih",
  41082: "Gagal mengunggah spanduk",
  41083: "Gagal mengunggah foto perusahaan",
  41084: "Gagal mengunggah logo",
  41085: "Gambar yang diupload melebihi batas ukuran gambar maksimal (5mb)",
  41086: "Gambar yang diupload melebihi batas ukuran gambar maksimal (1mb)",
  41087: "Batas waktu terlampaui",
  41088: "Tidak dapat menghapus koordinator perusahaan",
  41089: "Tidak dapat mengubah peran koordinator",
  41090: "Admin baru tidak valid",
  41091: "Id budaya harus berupa angka",
  41092: "Id budaya tidak valid",
  41093: "Id manfaat harus berupa angka",
  41094: "ID manfaat tidak valid",
  41095: "Kesalahan nilai parameter",
  41096: "Negara tidak didukung",
  41097: "Bidang parameter id bakat wajib diisi",
  41098: "Parameter lintang dan bujur adalah bidang wajib",
  41099: "Id tugas sinkronisasi tidak terjawab",
  41100: "Bidang kueri parameter adalah nilai yang tidak valid",
  41101: "Beberapa lokasi tidak ada",
  41102: "Beberapa jenis pekerjaan tidak ada",
  41103: "Beberapa rentang gaji tidak ada",
  41104: "Beberapa kategori pekerjaan tidak ada",
  41105: "Beberapa fungsi utama tidak ada",
  41106: "Beberapa id fungsi pekerjaan tidak ada",
  41107: "Beberapa id judul pekerjaan fungsi tidak ada",
  41108: "Beberapa industri tidak ada",
  41109: "Beberapa pengalaman tidak ada",
  41110: "Beberapa derajat tidak ada",
  41111: "Nilai tidak valid",
  41112: "Frekuensi pekerjaan berlangganan tidak ada",
  41113: "Pekerjaan ini tidak ada",
  41114: "Anda belum bergabung dengan perusahaan",
  41115: "Tanggal dari atau tanggal ke tidak valid",
  41116: "Penerusan otomatis telah dimatikan",
  41117: "Penerusan otomatis telah diaktifkan",
  41118: "Kesalahan izin melanjutkan penerusan otomatis",
  41119: "Email wajib diisi",
  41120: "Gaji pekerjaan telah terungkap",
  41121: "Gaji pekerjaan sudah ditutupi",
  41122: "Perekrut tidak memiliki izin untuk menutupi gaji",
  41123: "Perekrut tidak memiliki kredit pekerjaan yang cukup",
  41124: "Pekerjaan tersebut telah ditingkatkan menjadi pekerjaan unggulan",
  41125: "Masukkan alamat email yang valid",
  41126: "Perekrut tidak memiliki perusahaan",
  41127: "Pekerjaan telah ditutup",
  41128: "Parameter kueri adalah nilai yang tidak valid",
  41129: "Pekerjaan tersebut telah ditingkatkan menjadi pekerjaan mendesak",
  41130: "Tidak dapat memasukkan “-” pada kolom ini",
  41131: "Bidang Id pengguna wajib diisi",
  41132: "Pekerjaan ini tidak ditemukan",
  41133: "Resume pencari kerja tidak ditemukan",
  41134: "Lamaran pekerjaan Anda sedang diproses",
  41135: "Id pengguna parameter diperlukan",
  41136: "Semua pertanyaan penyaringan harus dijawab",
  41137: "Laporan alasan pekerjaan tidak valid",
  41139: "Ada permintaan pertukaran kontak yang sedang berlangsung",
  41140: "Tidak diperbolehkan ngobrol dengan diri sendiri",
  41141: "Kehadiran sudah ditandai",
  41142: "Status wawancara tidak valid",
  41143: "Waktu untuk menandai kehadiran tidak valid, harus lebih dari 30 menit setelah wawancara dimulai",
  41145: "Tidak diperbolehkan memperbarui status wawancara",
  41146: "Tidak diperbolehkan untuk memeriksa",
  41147: "Anda sudah check-in untuk wawancara ini",
  41148: "Anda dapat check-in mulai dari dua jam sebelum wawancara dimulai",
  41149: "Anda dapat check-in paling lambat setengah jam setelah wawancara dimulai",
  41150: "Pekerjaan ini tidak ada",
  41151: "Pekerjaan ini tidak aktif",
  41152: "Tidak diperbolehkan membatalkan wawancara yang akan datang",
  41153: "Waktu wawancara harus lebih besar dari waktu saat ini",
  41154: "Ada wawancara yang sedang berlangsung",
  41155: "Permintaan telah dinonaktifkan",
  41156: "Pekerjaan Tidak ditemukan",
  41157: "ID resume tidak valid",
  41158: "Tidak dapat menyiapkan resume kirim otomatis untuk obrolan yang sedang berlangsung",
  41159: "Konfirmasi lokasi yang ada sedang dalam proses",
  41162: "Permintaan resume yang ada sedang dalam proses",
  41163: "Hasil wawancara ini telah diminta",
  41164: "Bidang parameter id bakat wajib diisi",
  41165: "Bidang parameter id bakat wajib diisi",
  41167: "Pastikan kolom tanggal mulai lebih awal dari tanggal akhir",
  41168: "Alamat sudah ada",
  41169: "Panjang id tidak boleh lebih dari 1000",
  41170: "Lebih dari tiga resume telah diserahkan",
  41171: "OTP kedaluwarsa",
  41172: "OTP sudah digunakan",
  41173: "Nomor telepon telah diambil",
  41174: "File yang diupload melebihi batas ukuran file maksimal (5 MB)",
  41175: "Ekstensi file yang diunggah tidak didukung",
  41176: "Gambar yang diupload melebihi batas ukuran gambar maksimal (500kb)",
  41177: "Nilai id tidak valid",
  41178: "Perintah pekerjaan tidak valid",
  41179: "Bidang nama file wajib diisi",
  41181: "Anda hanya dapat memiliki maksimal 10 frasa umum",
  41182: "Pastikan tanggal penerbitan lebih awal dari tanggal kadaluarsa, tanggal kadaluwarsa lebih lambat dari tanggal penerbitan",
  41183: "Url lampiran tidak valid",
  41184: "Kesalahan seluler",
  41185: "Kesalahan tubuh",
  41186: "Anda tidak dapat menghapus resume yang dipilih untuk resume yang dikirim secara otomatis",
  41187: "Pengguna, pengirim harus konsisten",
  41188: "Pengguna, penerima harus konsisten",
  41191: "Pengalaman kerja tidak ditemukan",
  41192: "Status pengalaman kerja tidak valid, tidak dapat bergabung dengan perusahaan ini",
  41194: "Tidak dapat bergabung dengan perusahaan yang belum diverifikasi",
  41196: "Hanya admin perusahaan yang dapat melakukan verifikasi bagi perekrut untuk bergabung dengan perusahaan ini",
  41197: "Anda tidak dapat melakukan verifikasi untuk diri sendiri untuk bergabung dengan perusahaan ini",
  41198: "Perekrut tidak ditemukan",
  41199: "Perekrut tidak meminta untuk bergabung dengan perusahaan ini",
  41201: "Perekrut tidak memiliki catatan perusahaan",
  41202: "Perekrut bukan koordinator perusahaan",
  41204: "Kunci peran tidak ada",
  41205: "Admin perusahaan tidak dapat keluar dari perusahaan tanpa mengalihkan kepemilikan admin",
  41207: "Gambar yang diunggah melebihi ukuran gambar maksimum",
  41208: "Deskripsi diperlukan",
  41209: "Tanggal wajib diisi",
  41213: "Bakat sudah dihilangkan",
  41214: "Bidang alasan parameter dihapus wajib diisi",
  41217: "Id pekerjaan tidak valid",
  41219: "Anda belum bergabung dengan perusahaan",
  41221: "Jenis konten hanya mendukung application/x-www-form-urlencoded dan diperlukan ketika metode permintaan diposkan",
  41222: "metode permintaan hanya mendukung metode posting atau dapatkan",
  41223: "Kategori tidak diperbolehkan",
  41224: "Jika bidang obrolan balasan otomatis benar, memerlukan data pesan",
  41225: "Anda tidak memiliki izin untuk menyetel balasan otomatis",
  41226: "Harap berikan id jenis pesan parameter kueri",
  41227: "Pengguna tidak terdaftar",
  41228: "Salam, Pesan yang tidak sesuai dan pesan balasan otomatis tidak boleh berisi email dan nomor telepon",
  41229: "Info daftar perusahaan tidak ditemukan",
  41230: "pengalaman kerja perekrut tidak ditemukan",
  41231: "Anda adalah koordinator perusahaan dan tidak dapat melakukan operasi saat ini",
  41232: "Perusahaan tidak diklaim",
  41233: "Anda tidak memiliki izin untuk menghapus obrolan ini",
  41234: "Nomor telepon Anda sepertinya salah, silakan masukkan kembali",
  41235: "Tautan tidak valid",
  41236: "Anda salah memasukkan nomor telepon atau kode area",
  41237: "Verifikasi nomor telepon Anda gagal atau batas waktunya habis",
  41238: "Waktu mulai pengalaman kerja harus kurang dari waktu berakhir",
  41239: "Event tidak ditemukan",
  41240: "Event belum dimulai",
  41241: "Event sudah berakhir",
  41242: "Anda belum berpartisipasi dalam acara ini",
  41243: "Hadiah telah ditebus sepenuhnya",
  41244: "Mencapai batas penukaran",
  41245: "Lebih dari tiga resume video telah dikirimkan",
  41246: "Poin tidak cukup untuk ditarik",
  41247: "Jumlah penarikan minimum adalah 100 poin untuk Tron (TRC20)",
  41248: "Jumlah penarikan minimum adalah 1000 poin untuk Ethereum (ERC20)",
  41249: "Pengganda jumlah penarikan adalah 100 poin",
  41250: "Alamat Tron (TRC20) tidak valid",
  41251: "Alamat Ethereum (ERC20) tidak valid",
  41252: "Permintaan melebihi batas",
  41253: "Pastikan tidak ada lebih dari 10 digit sebelum koma desimal",
  41254: "Resume tidak boleh melebihi 5 salinan",
  41255: "Resume ini bukan milik Anda",
  41256: "Tidak lebih dari 30",
  41257: "Berapa kali telah habis",
  41258: "Anda tidak dapat memperoleh data untuk pengguna ini",
  41259: "Waktunya tidak boleh lebih besar dari waktu saat ini",
  41260: "Kode verifikasi tidak benar",
  41262: "Anda tidak dapat membuat lebih dari 3 preferensi pekerjaan jarak jauh",
  41263: "Anda tidak dapat membuat lebih dari 3 preferensi pekerjaan di tempat atau campuran",
  41264: "Jenis file resume yang didukung adalah pdf,doc,docx",
  41265: "Jenis file video yang didukung adalah mp4,avi,mov,wmv,flv,mkv,mpeg,webm,3gp,ogg",
  41266: "Tugas impor sudah ada di perusahaan kami",
  41267: "Tautan impor tidak didukung",
  41268: "Anda tidak memiliki izin untuk melakukan operasi ini",
  41269: "Hanya 10 orang yang dapat diundang dalam satu waktu",
  41270: "ID peran yang dipilih tidak cocok dengan nilainya",
  41271: "Kredensial baris tidak valid",
  41272: "Kredensial x tidak valid",
  41273: "Tautan undangan telah kedaluwarsa",
  41274: "Informasi identitas Anda tidak sesuai dengan posisi yang Anda kirimkan, dan Anda tidak dapat memulai obrolan dengan perusahaan untuk posisi ini.",
  41275: "Karena masalah bandwidth, Anda telah melampaui batas kueri yang diperbolehkan untuk AICV. Silakan coba lagi dalam 24 jam.",
  41276: "Jumlah merek atau produk yang ditambahkan melebihi batas.",
  41277: "Jumlah gambar terkait yang ditambahkan untuk suatu merek atau produk melebihi batas.",
  41278: "Url yang diunggah tidak memenuhi spesifikasi.",
  41279: "Konten pengingat pekerjaan yang Anda tetapkan terduplikasi, silakan ubah dan simpan.",
  41280: "Mohon maaf, AI saat ini tidak tersedia karena ada kesalahan. Silakan coba lagi nanti.",
  41281: "Pemindaian resume gagal, pastikan Anda mengunggah resume yang benar.",
  48905: "Email telah didaftarkan",
  50001: "Kesalahan server dari dalam",
  50002: "Gagal mengunggah resume",
  50003: "Profil hilang",
  50004: "Permintaan pertukaran kontak ini telah diproses",
  50005: "Anda tidak memiliki cukup kredit bakat untuk membuka kunci",
  50006: "Pesan wawancara tidak ditemukan",
  50007: "Permintaan resume ini telah diproses",
  50008: "Gagal mengunggah gambar profil",
  50009: "Gagal membuka bakat",
  50010: "Id parameter wajib diisi",
  50011: "Bakatnya telah terbuka",
  50012: "Parameter melanjutkan nama yang terakhir diperbarui adalah nilai yang tidak valid",
  50013: "Tidak ada hasil yang ditemukan saat ini Silakan coba lagi",
  50014: "Pencarian gaji gagal",
  50015: "Anda telah bergabung dengan perusahaan lain, Silakan masuk lagi ke backend manajemen dan keluar dari perusahaan sebelum bergabung dengan perusahaan lain"
}, Yi = {
  title: "ようこそ",
  tips: "人材をお探しですか？会員登録 ",
  continueWith: "または続ける",
  agreement: "{{value1}} と {{value2}} に同意します",
  emailValid: "有効なメールアドレスを入力してください",
  emailLabel: "メールアドレス",
  sendCodeDigit: "送信された6桁のコードを入力してください ",
  checkSpamEmail: "コードが届かない場合は迷惑メールを確認してください",
  otherOptions: "その他のオプション",
  alternatively: "または、リクエスト",
  resendCode: "コードを再送信",
  country: "国",
  phoneNumber: "電話番号",
  twoFactor: "セキュリティ認証",
  authentication: "認証",
  secure: "アカウントを保護し、メールでコードを受け取る",
  emailTips: "ログイン方法は最後のログインと一致しません。メールでセキュリティを確認してください。",
  setUpLater: "後で設定する",
  enableTwoFactor: "二要素",
  authenticationEnabled: "認証は有効です",
  factorTip: "認識できないデバイスやブラウザからのログイン試行があった場合、メールアドレスに送信されたコードを要求します",
  verifyText: "本人確認を行ってください",
  verifyExtra: "この追加の手順により、実際に本人がログインしようとしていることが分かります",
  optError: "OTPの送信に失敗しました",
  resendEmailCode: "メールへ認証コードを再送信しました",
  invalidOtp: "入力された認証コードが間違っています。もう一度お試しください。",
  resendPhoneCode: "電話へ認証コードを再送信しました",
  verifyEmail: "メール認証",
  thisPhoneNumberAssociated: "アカウントを選択してください",
  accounts: "アカウント",
  thisPhoneNumber: "この電話番号は次に関連付けられています ",
  youNeedToChooseVerified: "関連付ける認証済みのメールアドレスを選択する必要があります。",
  validateErr: "このメールアドレスは既に使用されています。別のメールアドレスに変更してください",
  checkYourSpam: "コードが届かない場合は迷惑メールを確認してください",
  authenticationSuccessful: "認証に成功しました",
  Bossjob: "ボスジョブ",
  back: "戻る",
  vipText: {
    GetVipPrivilegesImmediately: "VIP特権をすぐに入手",
    InviteNewUsersToRegister: "新規ユーザーを招待",
    BossjobAI: "ボスジョブAI",
    ResumeAssistant: "履歴書作成アシスタント",
    HighSalaryOffer: "高給与のオファー",
    HelpYouGet: "あなたのお手伝い",
    promptDesc: "おっと、既にログインしています。繰り返し登録することはできません。ログアウトして再度お試しください",
    returnHome: "ホームに戻る",
    signOut: "サインアウト",
    inviteFriendsToGet: "友達を招待してゲット",
    AIResumeCoaching: "履歴書のAIコーチ",
    HighQualityVIPResumeTemplateAndAIAssistantToHelpYouGetHighPayingOffer: "高品質のVIP履歴書テンプレートとAIアシスタントが高待遇のオファー獲得をサポート。",
    copyLinkToInviteNow: "リンクをコピーして招待"
  },
  links: {
    apple: "Appleで続行",
    google: "Googleで続行",
    facebook: "Facebookで続行",
    appleText: "Apple",
    line: "LINEで続行",
    twitter: "Xで続行"
  },
  seoMetaTitle: "始めよう | Bossjob",
  JoinBossjob: "Bossjobに参加する",
  kickStartYourCareer: "キャリアをスタートさせましょう！",
  enterYourEmailAddress: "メールアドレスを入力してください",
  submit: "提出",
  "pleaseEnterAvalidEmailAddress.": "有効なメールアドレスを入力してください。",
  bySigningUp: "サインアップすることで、以下の内容に同意したことになります",
  termsOfUse: "利用規約",
  and: "および",
  privacyPolicy: "プライバシーポリシー",
  signInWith: "でサインインする",
  lookingToHire: "人材をお探しですか？会員登録 ",
  employer: "雇用主",
  welcomeBack: "お帰りなさい！",
  signUpAnAccount: "アカウントにサインアップ",
  pleaseEnter: "送信した6桁のパスワードを入力してください",
  enter6DigitOTP: "6桁の認証コードを入力してください",
  getOPT: "認証コードを取得",
  heOTPYouHaveEnteredIsWrong: "入力したOTPが間違っています。もう一度お試しください。",
  resendOTP: "OTPを再送する",
  havingTrouble: "困ったことはありますか？",
  requestAmagicLink: "マジックリンクをリクエストする",
  seoMetaDescription: "Bossjobに参加して、あなたのプロフェッショナルとしてのキャリアを加速させましょう！以下のコースと求人情報にアクセス ",
  seoMetaDescription2: "200万人以上のプロフェッショナルのネットワーク。",
  magicLinkText: "マジックリンク",
  magicLink: {
    welcomeBack: "お帰りなさい！",
    signUp: "アカウントにサインアップ",
    haveSendEmail: "{{email}} にマジックリンクを送信しました。クリックして続行してください。",
    toHome: "ホームページに戻る"
  },
  loginUsingSocialMediaOTP: "ソーシャルメディア/OTPを使用してログインする",
  loginUsingQRCode: "QRコードを使用してログインする",
  scanQRCodeOnAppToLogin: "Bossjobアプリでこのコードをスキャンして即座にログインします",
  donHaveApp: "アプリをお持ちでない場合",
  sendCode: "確認コードを送信",
  howToScanQRCode: "QRコードのスキャン方法",
  ImJobSeeker: "求職者です",
  ImRecruiter: "雇用主です",
  menuLoginToVersion: "メニュー > Webにログイン",
  scannedSuccessfully: "正常にスキャンされました",
  pleaseConfirmLoginOnAPP: "アプリでログインを確認してください",
  pleaseRefreshQrCode: "QRコードを更新してください",
  clickToRefresh: "クリックして更新",
  accountMismatch: "アカウントのタイプが一致しません。求人応募を使用してログインしてください",
  loginWithQRCode: "QRコードでログインする",
  email: "メール",
  phone: "電話",
  haveSendEmail: "{{email}} にマジックリンクを送信しました。クリックして続行してください。",
  leftBanner: {
    free: "無料",
    lifetime: "ライフタイム",
    quick: "クイック",
    production: "プロダクション",
    aIAssisted: "AIアシスタント",
    resumeEditing: "履歴書の編集",
    aGoodResume: "素敵な履歴書",
    aGoodResumeDesc: "給与が平均37％アップします"
  },
  enterYourEmail: "メールアドレスを入力してください",
  verificationEmailCode: "認証コードをメールでお送りします",
  confirmationCode: "確認コードを入力してください",
  enterOTP: "送信された6桁のコードを入力してください",
  verificationPhoneCode: "認証コードをメールでお送りします",
  enterYourPhone: "電話番号を入力してください",
  connectYourEmail: "メールと連携してください",
  connectYourEmailTip: "あなたのサードパーティアカウントが有効性が確認できませんでした。Bossjobへの登録またはログインの前に、メールアドレスまたは携帯電話番号の連携を完了する必要があります。",
  downloadApp: "アプリをダウンロードする",
  neptune: "Neptune",
  neptuneOffersJob: "Neptuneは、認証された企業の最新情報を求職者に提供し、十分な情報に基づいたキャリア決定を可能にします。"
}, Hi = {
  getStarted: Yi
}, Ui = {
  0: "成功",
  40001: "パラメータの検証に失敗、または無効です",
  40002: "認証情報が正しくありません",
  40003: "認証情報が提供されていません",
  40004: "リソースが見つかりません",
  40005: "この操作を実行する権限がありません",
  40006: "試行回数が多すぎます。{{retry_after}} 秒後に再試行してください。",
  41001: "そのメールアドレスは既に使用されています",
  41002: "クライアントIDは既に使用されています",
  41003: "秘密鍵は既に使用されています",
  41004: "ユーザーはメールアドレスを持っている必要があります",
  41005: "このメールアドレスの登録に失敗しました",
  41006: "ステータスを更新できません",
  41007: "アップロードされたファイルは最大ファイルサイズ制限（20MB）を超えています。",
  41008: "アップロードされたファイルはサポートされていません。",
  41009: "現在のパスワードが一致しません",
  41010: "パスワードと確認用パスワードが一致しません",
  41011: "すでにコネクションリクエストに応答済みです",
  41012: "重複したアイテムが見つかりました",
  41014: "この人材に対するコネクションリクエストが送信されました",
  41015: "この人材に対してコネクションリクエストを送っていません",
  41016: "ボスハントのニュースレターに正常に登録されました",
  41017: "この名前のパイプラインは作成されました",
  41018: "このメールアドレスで作成された履歴書があります。",
  41019: "リソースが見つかりません",
  41020: "日付は開始日より前にすることはできません",
  41022: "ユーザーは解析するための十分なクレジットを持っていません",
  41023: "パイプラインが見つかりません",
  41024: "ステージが見つかりません",
  41025: "履歴書IDが見つかりません",
  41026: "このコメントを編集することは許可されていません",
  41027: "このメールアドレスを持つ人材が作成されました",
  41028: "年収の上限は年収の下限を超えることはできません",
  41029: "毎月の手数料は月額料金より遅くすることはできません",
  41030: "開始期間の処理時間は終了期間の処理時間より後にはできません。",
  41031: "このレコードは存在しません",
  41032: "保証期間の開始日は、終了日よりも後にはできません。",
  41034: "ユーザーは履歴書を解析するための十分なクレジットを持っていません",
  41035: "トークンの生成に失敗しました",
  41036: "無効なトークン",
  41037: "メールアドレスはすでに確認済みです",
  41038: "メールアドレスは既に存在しています",
  41039: "この番号はすでにアカウントに使用されています。別の番号を試してください。",
  41040: "入力したOTPは間違っています。もう一度お試しください。",
  41041: "無効なメールアドレス",
  41042: "Otpが使用されました",
  41043: "Otpが期限切れになりました",
  41044: "アカウントは停止されています",
  41045: "電話番号はすでに確認済みです",
  41046: "許可されていない選択肢",
  41047: "アカウントが停止されました。詳細は support@bossjobcom までご連絡ください。",
  41048: "ユーザー名または電話番号が無効です",
  41049: "ソースフィールドは必須です",
  41050: "身分証の有効期限",
  41051: "ユーザーには電話番号の記録がありません",
  41052: "無効なGoogleの認証情報です",
  41053: "Linkedinのログイン情報が無効です",
  41054: "Facebookの認証情報が無効です",
  41055: "無効なAppleの資格情報です",
  41056: "メールアドレスまたは認証コードが正しくありません。再入力してください。",
  41057: "メールアドレスは必須です。",
  41058: "ユーザーは存在しません",
  41059: "無効な整数リストの値です",
  41060: "この企業を削除する権限は、会社のコーディネーター管理者のみが持っています。",
  41061: "企業の管理者のみが企業文書をアップロードできます",
  41062: "会社はすでに確認済みです",
  41063: "ドキュメントのアップロードに失敗しました",
  41064: "アップロードされたファイルは、最大画像サイズ制限（4mb）を超えています。",
  41065: "企業IDを同期できませんでした",
  41066: "会社が見つかりません",
  41067: "会社は検証中です",
  41069: "職務経験が見つかりません",
  41070: "ソート順が無効です",
  41071: "写真はこのソート順に存在しません",
  41072: "オンボーディングプロセスを進めてください",
  41073: "無効な職務経験のステータスです",
  41074: "名前は既に存在しています",
  41075: "名前に制限された文字が含まれています：+",
  41077: "IDまたはキーが無効です",
  41078: "無効な勤務先住所です",
  41079: "企業は認証されていません",
  41080: "無効なユーザー",
  41081: "選択された会社には採用担当者がいません",
  41082: "バナーのアップロードに失敗しました",
  41083: "企業の写真のアップロードに失敗しました",
  41084: "ロゴのアップロードに失敗しました",
  41085: "アップロードされた画像は、最大画像サイズ制限（5MB）を超えています。",
  41086: "アップロードされた画像は、最大画像サイズ制限（1MB）を超えています。",
  41087: "制限時間を超えています",
  41088: "会社のコーディネーターを削除することはできません",
  41089: "コーディネーターの役割を変更することはできません",
  41090: "新しい管理者は無効です",
  41091: "カルチャーIDは数字である必要があります",
  41092: "無効なカルチャーIDです",
  41093: "福利厚生IDは数字である必要があります",
  41094: "無効な福利厚生ID",
  41095: "パラメータの値が間違っています",
  41096: "対応していない国です",
  41097: "パラメータのタレントIDフィールドは必須項目です",
  41098: "パラメータの緯度と経度は必須項目です",
  41099: "ジョブIDの同期に失敗しました",
  41100: "パラメータのクエリフィールドには無効な値があります",
  41101: "いくつかの場所は存在しません",
  41102: "いくつかの職種が存在しません",
  41103: "いくつかの給与範囲が存在しません",
  41104: "いくつかのジョブカテゴリが存在しません",
  41105: "いくつかの主要な機能が存在しません",
  41106: "いくつかの職務権限IDが存在しません",
  41107: "いくつかの職種IDが存在しません",
  41108: "いくつかの産業が存在しません",
  41109: "いくつかの経歴が存在しません",
  41110: "いくつかの学位は存在しません",
  41111: "無効な値",
  41112: "求人情報の購読頻度は存在しません",
  41113: "この求人は存在しません",
  41114: "あなたはまだ会社に参加していません",
  41115: "日付が無効です。開始日または終了日を確認してください。",
  41116: "自動転送は既にオフになっています",
  41117: "自動転送は既にオンになっています",
  41118: "履歴書の自動転送許可エラー",
  41119: "メールアドレスは空欄にできません",
  41120: "求人の給与は既に公開されています",
  41121: "求人の給与は既に非公開にされています",
  41122: "採用担当者は給与を非公開にする権限がありません",
  41123: "リクルーターの求人クレジットが不足しています",
  41124: "この求人はすでに注目の求人にアップグレードされています",
  41125: "有効なメールアドレスを入力してください",
  41126: "リクルーターには会社がありません",
  41127: "求人は既に締め切られています",
  41128: "クエリパラメータは無効な値です",
  41129: "この仕事はすでに緊急の仕事にアップグレードされました",
  41130: "このフィールドには-を入力できません。",
  41131: "ユーザーIDフィールドは必須項目です",
  41132: "この仕事は見つかりません。",
  41133: "求職者の履歴書が見つかりません",
  41134: "お申し込みいただいた求人は現在処理中です",
  41135: "パラメータのユーザーIDは必須項目です",
  41136: "すべての選考質問に回答する必要があります。",
  41137: "無効な求人理由",
  41139: "連絡交換リクエストが進行中です",
  41140: "自分自身とのチャットは許可されていません",
  41141: "出席はすでにマークされています",
  41142: "面接ステータスが無効です",
  41143: "出席の時間が無効です。面接開始後30分以上経過する必要があります。",
  41145: "面接ステータスの更新は許可されていません",
  41146: "確認することは許可されていません",
  41147: "この面接にはすでにチェックイン済みです",
  41148: "面接が開始する2時間前からチェックインが可能です",
  41149: "面接開始後、最新の30分以内にチェックインすることができます",
  41150: "この求人は存在しません",
  41151: "この求人は非アクティブです",
  41152: "今後の面接をキャンセルすることは許可されていません",
  41153: "面接の時間は現在の時間よりも遅くする必要があります",
  41154: "現在面接中です",
  41155: "リクエストは既に無効になっています",
  41156: "求人情報が見つかりません",
  41157: "履歴書IDが無効です",
  41158: "進行中のチャットに自動送信履歴書を設定できません",
  41159: "現在位置の確認が進行中です",
  41162: "進行中の履歴書リクエストがあります",
  41163: "この面接の結果は要求されました。",
  41164: "パラメータのタレントIDフィールドは必須項目です",
  41165: "人材ID のパラメータフィールドは必須です。",
  41167: "開始日が終了日よりも前になるようにしてください",
  41168: "住所は既に存在しています",
  41169: "IDの長さは1000を超えることはできません",
  41170: "3つ以上の履歴書が提出されました",
  41171: "OTPの有効期限が切れました",
  41172: "OTPは既に使用されています",
  41173: "電話番号は既に使用されています",
  41174: "アップロードされたファイルは、最大ファイルサイズ制限（5 MB）を超えています",
  41175: "アップロードされたファイルの拡張子はサポートされていません",
  41176: "アップロードされた画像は、最大画像サイズ制限（500kb）を超えています。",
  41177: "無効なIDの値です",
  41178: "求人情報が無効です",
  41179: "ファイル名のフィールドは必須項目です",
  41181: "共通フレーズは最大10個までです",
  41182: "発行日が有効期限よりも前であることを確認し、有効期限が発行日よりも後であることを確認してください",
  41183: "添付ファイルのURLが無効です",
  41184: "モバイルエラー",
  41185: "本文エラー",
  41186: "自動送信された履歴書を選択した場合、削除することはできません",
  41187: "ユーザー、送信者は一致している必要があります",
  41188: "ユーザー、受信者は一致している必要があります",
  41191: "職務経歴が見つかりません",
  41192: "無効な職務経歴のステータスです。この企業には参加できません。",
  41194: "未認証の企業には参加できません",
  41196: "企業の管理者のみが、この企業に採用担当者を追加するための検証を行うことができます",
  41197: "この会社に参加するために、自分自身の検証はできません。",
  41198: "リクルーターが見つかりません",
  41199: "採用担当者は入社を希望していません",
  41201: "採用担当者には会社の記録がありません",
  41202: "採用担当者は企業コーディネーターではありません",
  41204: "役割キーが見つかりません",
  41205: "会社の管理者は、管理者の所有権を移転せずに会社を離れることはできません",
  41207: "アップロードされた画像は最大画像サイズを超えています。",
  41208: "説明は必須です",
  41209: "日付は必須です",
  41213: "人材はすでに削除されています",
  41214: "パラメーター削除理由フィールドは必須です",
  41217: "求人IDが無効です",
  41219: "あなたはまだ会社に参加していません",
  41221: "コンテンツタイプは application/x-www-form-urlencoded のみをサポートし、リクエスト方法がpostの場合に必要です。",
  41222: "リクエストメソッドはpostかgetメソッドのみをサポートします",
  41223: "許可されていないカテゴリ",
  41224: "もし自動返信チャットフィールドがtrueの場合、メッセージデータが必要です",
  41225: "自動返信の設定権限がありません",
  41226: "クエリパラメータのメッセージタイプIDを指定してください",
  41227: "ユーザーは登録されていません",
  41228: "挨拶や適切でないメッセージ、自動返信メッセージには、電メールアドレスや電話番号を含めることはできません。",
  41229: "企業リスト情報が見つかりません",
  41230: "採用担当者の職歴が見つかりません",
  41231: "あなたは会社のコーディネーターであり、現在の操作を実行することはできません",
  41232: "会社が請求されていません",
  41233: "このチャットを削除する権限がありません",
  41234: "電話番号が正しくありません。再入力してください。",
  41235: "無効なリンクです",
  41236: "電話番号または地域コードが正しくありません",
  41237: "電話番号の確認に失敗したか、タイムアウトしました",
  41238: "職歴の開始期間は終了期間より前でなければなりません",
  41239: "イベントが見つかりません",
  41240: "イベントはまだ開始されていません",
  41241: "イベントは終了しました",
  41242: "あなたはこのイベントに参加していません",
  41243: "報酬は完全に交換されました",
  41244: "引き換え制限に達しました",
  41245: "3つ以上のビデオ履歴書が提出されました",
  41246: "引き出すためのポイントが足りません",
  41247: "Tron（TRC20）の最小引き出し金額は100ポイントです",
  41248: "イーサリアム（ERC20）の最小引き出し金額は1000ポイントです",
  41249: "出金額の倍率は100ポイントごとです",
  41250: "無効なTron（TRC20）アドレスです",
  41251: "無効なEthereum（ERC20）アドレスです",
  41252: "クエリが制限を超えています",
  41253: "小数点以下の桁数が10桁以下であることを確認してください",
  41254: "履歴書は5部を超えることは出来ません",
  41255: "この履歴書はあなたのものではありません",
  41256: "30以下",
  41257: "回数が使い果たされました",
  41258: "このユーザーのデータを取得できません",
  41259: "時間は現在時刻より大きくすることは出来ません",
  41260: "認証コードが間違っています",
  41262: "3つ以上のリモートジョブ設定を作成することはできません",
  41263: "3つ以上のオンサイトまたはハイブリッドジョブプリファレンスを作成することはできません。",
  41264: "サポートされている履歴書のファイルタイプは pdf,docx,docx",
  41265: "サポートされている動画のファイルタイプは mp4,avi,mov,wmv,flv,mkv,mpeg,webm,3gp,ogg",
  41266: "インポートタスクはすでに社内に存在します",
  41267: "未対応のインポートリンク",
  41268: "この操作を実行する権限がありません",
  41269: "一度に招待できるのは10人までです",
  41270: "選択されたロール ID が値と一致しません",
  41271: "無効なラインの資格情報です",
  41272: "無効なXの資格情報です",
  41273: "招待リンクが期限切れになっています",
  41274: "身元情報が提出した職位と一致しません。雇用主とのチャットを開始することはできません。",
  41275: "帯域幅の問題により、AICVのクエリ制限を超えました。24時間後にもう一度お試しください。",
  41276: "追加されたブランドまたはプロダクトの数が制限を超えています。",
  41277: "ブランドやプロダクトの関連画像の数が制限を超えています。",
  41278: "アップロードされたURLが正しくありません。",
  41279: "設定したジョブリマインダーの内容が重複しているので、修正して保存してください。",
  41280: "申し訳ありませんが、AIは現在エラーのため利用できません。後でもう一度お試しください。",
  41281: "Resume parsing failed, please make sure you upload the correct resume.",
  48905: "このメールアドレスは既に登録されています",
  50001: "内部サーバーエラー",
  50002: "履歴書のアップロードに失敗しました",
  50003: "プロフィールが見つかりません",
  50004: "この連絡交換リクエストは処理されました。",
  50005: "人材アンロック用のクレジットが足りません",
  50006: "面接メッセージが見つかりません",
  50007: "この履歴書のリクエストは処理されました",
  50008: "プロフィール写真のアップロードに失敗しました",
  50009: "人材のアンロックに失敗しました",
  50010: "パラメーターのIDは必須です",
  50011: "人材がアンロックされました",
  50012: "履歴書の最終更新名のパラメーターが無効な値です",
  50013: "現在、結果が見つかりません。もう一度お試しください。",
  50014: "給与検索に失敗しました",
  50015: "別の会社に参加しました。管理バックエンドに再度ログインし、別の会社に参加する前に会社を終了してください"
}, Ki = {
  title: "歡迎來到",
  tips: "尋找人才？登錄 ",
  continueWith: "使用其他方式",
  agreement: "我已經閱讀並同意 {{value1}} 和 {{value2}}",
  emailValid: "請輸入一個有效的郵件地址。",
  emailLabel: "郵件地址",
  sendCodeDigit: "請輸入我們發送的6位驗證碼 ",
  checkSpamEmail: "如果您沒有收到驗證碼，請檢查您的垃圾郵件",
  otherOptions: "其他選項",
  alternatively: "或者，請求一個",
  resendCode: "重新發送驗證碼",
  country: "國家",
  phoneNumber: "電話號碼",
  twoFactor: "安全驗證",
  authentication: "驗證",
  secure: "確認您的帳戶並在您的郵件中接收代碼",
  emailTips: "登錄方式與上次登錄不一致，請通過郵件驗證安全",
  setUpLater: "稍後設置",
  enableTwoFactor: "雙重驗證",
  authenticationEnabled: "驗證已啟用",
  factorTip: "如果我們發現有人試圖通過我們無法識別的設備或流覽器登錄，我們會要求您向您的電子郵件地址發送代碼。",
  verifyText: "身份驗證",
  verifyExtra: "這個額外的步驟表明確實是您在嘗試登錄。",
  optError: "發送OTP失敗",
  resendEmailCode: "重新發送郵箱OTP成功",
  invalidOtp: "您輸入的一次性密碼有誤。請重試。",
  resendPhoneCode: "重新發送電話OTP成功",
  verifyEmail: "驗證郵箱",
  thisPhoneNumberAssociated: "選擇帳號",
  accounts: "帳戶.",
  thisPhoneNumber: "此電話號碼已關聯的帳號 ",
  youNeedToChooseVerified: "您需要選擇並驗證Email來關聯帳號",
  validateErr: "郵件已註冊。請更改綁定到另一個email",
  checkYourSpam: "如果您沒有收到驗證碼，請檢查您的垃圾郵件。",
  authenticationSuccessful: "認證成功",
  Bossjob: "Bossjob",
  back: "返回",
  vipText: {
    GetVipPrivilegesImmediately: "立即獲得貴賓特權",
    InviteNewUsersToRegister: "邀請新用戶註冊",
    BossjobAI: "Bossjob 人工智能",
    ResumeAssistant: "簡歷助理",
    HighSalaryOffer: "高薪職位",
    HelpYouGet: "幫助您獲取",
    promptDesc: "您已經登錄；無法重複註冊。請退出登錄後再試一次。",
    returnHome: "返回首頁",
    signOut: "登出",
    inviteFriendsToGet: "邀請朋友獲取",
    AIResumeCoaching: "解鎖AI職業輔導功能",
    HighQualityVIPResumeTemplateAndAIAssistantToHelpYouGetHighPayingOffer: "高質量 VIP 簡歷範本和 AI 助手助您獲得高薪職位。",
    copyLinkToInviteNow: "立即複製邀請鏈接"
  },
  links: {
    apple: "使用Apple登錄",
    google: "使用Google登錄",
    facebook: "使用Facebook登錄",
    appleText: "Apple",
    line: "Continue with Line",
    twitter: "Continue with X"
  },
  seoMetaTitle: "註冊求職帳號，馬上開始找工作 | Bossjob",
  JoinBossjob: "上Bossjob",
  kickStartYourCareer: "和老闆直接聊工作！",
  enterYourEmailAddress: "輸入你的電子郵箱地址",
  submit: "提交",
  "pleaseEnterAvalidEmailAddress.": "請輸入有效的電子郵件地址。",
  bySigningUp: "註冊即表示我已閱讀並同意",
  termsOfUse: "使用條款",
  and: "和",
  privacyPolicy: "隱私政策",
  signInWith: "其他登錄方式",
  lookingToHire: "我要招聘！",
  employer: "點擊此處免費註冊企業帳號",
  welcomeBack: "歡迎回來！",
  signUpAnAccount: "註冊新帳戶",
  pleaseEnter: "請輸入我們發送的6位一次性密碼",
  enter6DigitOTP: "輸入 6 位數驗證碼",
  getOPT: "獲得驗證碼",
  heOTPYouHaveEnteredIsWrong: "您輸入的一次性密碼有誤。請重試。",
  resendOTP: "重新發送",
  havingTrouble: "您需要幫助嗎？",
  requestAmagicLink: "請求魔術鏈接",
  seoMetaDescription: "立即加入Bossjob，直接和老闆聊職位！加入300萬全球頂尖人才，立即體驗最高效的找工作平台在",
  seoMetaDescription2: "2百萬註冊求職者在線等你",
  magicLinkText: "魔術鏈接",
  magicLink: {
    welcomeBack: "歡迎回來！",
    signUp: "註冊一個帳戶",
    haveSendEmail: "我們已向{{email}}發送了一個魔法鏈接。 請點擊鏈接繼續。",
    toHome: "回到主頁"
  },
  loginUsingSocialMediaOTP: "驗證碼登錄/註冊",
  loginUsingQRCode: "使用二維碼登錄",
  scanQRCodeOnAppToLogin: "使用Bossjob APP掃描二維碼即可登錄",
  donHaveApp: "沒有應用程序",
  sendCode: "發送驗證碼",
  howToScanQRCode: "如何掃描二維碼",
  ImJobSeeker: "我是一名求職者",
  ImRecruiter: "我是招聘人員",
  menuLoginToVersion: "菜單 > 登錄網頁版",
  scannedSuccessfully: "掃描成功",
  pleaseConfirmLoginOnAPP: "請在APP上確認登錄",
  pleaseRefreshQrCode: "請刷新二維碼",
  clickToRefresh: "點擊刷新",
  accountMismatch: "帳戶類型不匹配，請使用求職端登錄",
  loginWithQRCode: "掃描二維碼登錄",
  email: "郵件",
  phone: "電話",
  haveSendEmail: "我們已向{{email}}發送了一個魔法鏈接。 請點擊鏈接繼續。",
  leftBanner: {
    free: "免費",
    lifetime: "終身",
    quick: "高效率",
    production: "製作",
    aIAssisted: "AI 簡歷助手",
    resumeEditing: "智能優化內容",
    aGoodResume: "一份好的簡歷",
    aGoodResumeDesc: "平均工資提高 37%"
  },
  enterYourEmail: "Enter your email",
  verificationEmailCode: "We will send a verification code to your email",
  confirmationCode: "Enter confirmation code",
  enterOTP: "Please enter the 6-digit code that we sent to",
  verificationPhoneCode: "We will send a verification code to your phone",
  enterYourPhone: "Enter your Phone",
  connectYourEmail: "Please connect your email",
  connectYourEmailTip: "We'll just need your email address to finish registering or logging onto Bossjob.",
  downloadApp: "下載APP",
  neptune: "Neptune",
  neptuneOffersJob: "Neptune offers job seekers verified, current information on companies hiring, enabling informed career decisions."
}, Fi = {
  getStarted: Ki
}, qi = {
  0: "成功",
  40001: "參數驗證失敗或無效",
  40002: "驗證憑證不正確",
  40003: "未提供身份验证凭据",
  40004: "找不到资源",
  40005: "您没有执行此操作的权限",
  40006: "嘗試次數過多。請在{{retry_after}}秒後再試一次",
  41001: "該電子郵件已被使用",
  41002: "客户端ID已被使用",
  41003: "密钥已被使用",
  41004: "用戶必須擁有電子郵件地址",
  41005: "無法註冊此電子郵件",
  41006: "無法更新狀態",
  41007: "上傳的文件超過了最大文件大小限制（20MB）",
  41008: "上傳的文件不受支援",
  41009: "目前的密碼不符合",
  41010: "密碼和確認密碼不符",
  41011: "您已经回复了连接请求",
  41012: "發現重複項目",
  41014: "連線請求已發送給該人才",
  41015: "您尚未向此人才发送连接请求",
  41016: "您已成功訂閱 Bosshunt 通訊",
  41017: "已创建具有此名称的流程线",
  41018: "使用此电子邮件创建了简历",
  41019: "找不到资源",
  41020: "截止日期不能早于起始日期",
  41022: "用戶沒有足夠的信用來解析",
  41023: "找不到该招聘渠道",
  41024: "找不到舞台",
  41025: "找不到简历编号",
  41026: "您无权编辑此评论",
  41027: "該郵件地址的人才已被創建",
  41028: "年薪的最低金额不能超过年薪的最高金额",
  41029: "月費起始金額不能晚於月費終止金額",
  41030: "週期的結束時間不能晚於週期的開始時間",
  41031: "此记录不存在",
  41032: "保证期从期限不能晚于保证期至期限",
  41034: "用戶沒有足夠的信用來解析簡歷",
  41035: "無法生成令牌",
  41036: "無效的令牌",
  41037: "電子郵件已驗證",
  41038: "電子郵件已存在",
  41039: "此號碼已被使用於一個帳戶，請嘗試使用其他號碼",
  41040: "您输入的一次性密码有误，请重新尝试",
  41041: "無效的電子郵件",
  41042: "Otp已被使用",
  41043: "Otp已过期",
  41044: "帳戶已被暫停",
  41045: "電話號碼已經驗證過",
  41046: "不允許的選擇",
  41047: "您的帳戶已被暫停，請聯繫 support@bossjobcom 以獲得進一步說明。",
  41048: "無效的使用者或電話號碼",
  41049: "需要填写来源字段",
  41050: "身份过期",
  41051: "用戶沒有電話號碼記錄",
  41052: "無效的 Google 憑證",
  41053: "無效的linkedin帳號",
  41054: "無效的Facebook帳號資訊",
  41055: "無效的蘋果憑證",
  41056: "您的邮件或驗證碼看起来不正确，请重新输入",
  41057: "電子郵件是必填項目",
  41058: "使用者不存在",
  41059: "無效的整數列表值",
  41060: "只有公司协调员管理员才能删除此公司",
  41061: "只有公司管理员可以上传公司文件",
  41062: "公司已经通过验证",
  41063: "上傳文件失敗",
  41064: "上傳的文件超過了最大圖片大小限制（4mb）",
  41065: "錯過的同步公司ID",
  41066: "找不到公司",
  41067: "公司正在等待验证",
  41069: "找不到工作经验",
  41070: "排序顺序无效",
  41071: "此排序方式下照片不存在",
  41072: "請完成入職流程",
  41073: "工作经验状态无效",
  41074: "名稱已存在",
  41075: "名字包含受限制的字符：+",
  41077: "無效的ID或密鑰",
  41078: "工作地址无效",
  41079: "公司未經驗證",
  41080: "無效使用者",
  41081: "招聘人员不在所选公司中",
  41082: "上傳橫幅失敗",
  41083: "上傳公司照片失敗",
  41084: "上傳標誌失敗",
  41085: "上傳的圖片超過了最大圖片大小限制（5mb）",
  41086: "上傳的圖片超過了最大圖片大小限制（1mb）",
  41087: "超出时间限制",
  41088: "無法刪除公司協調員",
  41089: "無法更改協調員的角色",
  41090: "無效的新管理員",
  41091: "文化id必须为数字",
  41092: "無效的文化ID",
  41093: "福利编号必须为数字",
  41094: "福利ID无效",
  41095: "參數值錯誤",
  41096: "不支援的國家",
  41097: "需要填写参数人才ID字段",
  41098: "緯度和經度是必填欄位",
  41099: "遗漏的同步工作ID",
  41100: "參數查詢字段的值無效",
  41101: "有些地点不存在",
  41102: "某些职位类型不存在",
  41103: "部分薪资范围不存在",
  41104: "某些职位类别不存在",
  41105: "某些主要功能不存在",
  41106: "某些职位功能 ID 不存在",
  41107: "某些职位的职称 ID 不存在",
  41108: "有些行业不存在",
  41109: "有些经验不存在",
  41110: "某些學位不存在",
  41111: "無效的值",
  41112: "訂閱工作頻率不存在",
  41113: "這個職位不存在",
  41114: "您尚未加入公司",
  41115: "無效的起始日期或結束日期",
  41116: "自動轉發已經關閉",
  41117: "自动转发已经开启",
  41118: "自动转发简历权限错误",
  41119: "郵箱不能為空",
  41120: "職位薪資已經公開",
  41121: "職位薪資已經被遮蔽",
  41122: "招聘人员无权隐藏薪资",
  41123: "招聘者没有足够的职位点数",
  41124: "該職位已經升級為特色職位",
  41125: "請輸入有效的電子郵件地址",
  41126: "招聘者没有公司",
  41127: "職位已經關閉",
  41128: "查詢參數值無效",
  41129: "該職位已經升級為緊急職位",
  41130: "此欄位不可輸入「-」",
  41131: "使用者 ID 欄位是必填的",
  41132: "找不到此職位",
  41133: "找不到求职者的简历",
  41134: "您的求職申請正在處理中",
  41135: "需要提供用户ID参数",
  41136: "所有的筛选问题都必须回答",
  41137: "無效的舉報職位原因",
  41139: "存在正在进行的联系交换请求",
  41140: "禁止与自己聊天",
  41141: "出勤已经标记完成",
  41142: "面試狀態無效",
  41143: "無效的打卡時間，必須在面試開始後30分鐘以上",
  41145: "不允许更新面试状态",
  41146: "不允許查看",
  41147: "您已经完成了此次面试的签到",
  41148: "您可以在面试开始前两小时开始签到",
  41149: "面試開始後半小時內，您可以進行簽到。",
  41150: "此職位不存在",
  41151: "此職位已停止招聘",
  41152: "禁止取消即将进行的面试",
  41153: "面試時間必須晚於當前時間",
  41154: "面試進行中",
  41155: "請求已被禁用",
  41156: "找不到工作",
  41157: "無效的履歷編號",
  41158: "無法設置正在進行中的聊天自動發送簡歷",
  41159: "正在进行现有位置确认",
  41162: "正在进行简历请求",
  41163: "已要求获取此次面试的结果",
  41164: "需要填写参数人才ID字段",
  41165: "需要填写参数人才ID字段",
  41167: "确保开始日期早于结束日期",
  41168: "地址已存在",
  41169: "Id長度不能超過1000",
  41170: "已提交超过三份简历",
  41171: "OTP已過期",
  41172: "OTP已被使用",
  41173: "該電話號碼已被使用",
  41174: "上傳的文件超過了最大文件大小限制（5 MB）",
  41175: "上傳的文件擴展名不受支援",
  41176: "上傳的圖像超過了最大圖像大小限制（500kb）",
  41177: "無效的ID值",
  41178: "無效的職位訂單",
  41179: "檔案名稱欄位為必填項目",
  41181: "您最多只能有10个常用短语",
  41182: "确保发行日期早于到期日期，到期日期晚于发行日期",
  41183: "附件网址无效",
  41184: "手機錯誤",
  41185: "內容錯誤",
  41186: "您無法刪除已選擇自動投遞的履歷",
  41187: "用戶，發送者必須一致",
  41188: "用戶，接收者必須一致",
  41191: "未找到工作经验",
  41192: "無效的工作經驗狀態，無法加入該公司",
  41194: "無法加入未驗證的公司",
  41196: "只有公司管理员才能对招聘人员进行验证，以加入该公司",
  41197: "您不能为自己进行验证以加入该公司",
  41198: "找不到招聘人员",
  41199: "招聘人员未请求加入此公司",
  41201: "招聘者没有公司记录",
  41202: "招聘人员不是公司协调员",
  41204: "缺少角色键",
  41205: "公司管理员不能在未转让管理员所有权的情况下离开公司",
  41207: "上傳的圖片超過了最大圖片尺寸",
  41208: "需要填写描述",
  41209: "需要填写日期",
  41213: "人才已被移除",
  41214: "參數刪除原因字段是必填項",
  41217: "無效的職位編號",
  41219: "您尚未加入公司",
  41221: "內容類型僅支持application/x-www-form-urlencoded，並且在請求方法為post時是必需的",
  41222: "请求方法只支持POST或GET方法",
  41223: "不允许的类别",
  41224: "如果自动回复聊天字段为true，则需要消息数据",
  41225: "您没有权限设置自动回复",
  41226: "請提供查詢參數訊息類型ID",
  41227: "用戶未註冊",
  41228: "您好，不适合的消息和自动回复消息不能包含电子邮件和电话号码",
  41229: "找不到公司列表信息",
  41230: "找不到招聘者的工作经验",
  41231: "您是公司的协调员，无法执行当前操作",
  41232: "公司未認領",
  41233: "您没有权限删除此聊天",
  41234: "您的电话号码看起来不正确，请重新输入",
  41235: "無效連結",
  41236: "您输入了错误的电话号码或区号",
  41237: "您的电话号码验证失败或超时",
  41238: "工作经验的开始时间必须早于结束时间",
  41239: "找不到活动",
  41240: "活動尚未開始",
  41241: "活動已結束",
  41242: "您尚未参与此活动",
  41243: "獎勵已完全兌換",
  41244: "已达到兑换限额",
  41245: "已提交超过三份视频简历",
  41246: "點數不足以提領",
  41247: "最低提款金额为100个波场(TRC20)积分",
  41248: "以太坊（ERC20）的最低提现金额为1000点",
  41249: "提款金额乘数为100点",
  41250: "無效的波場（TRC20）地址",
  41251: "無效的以太坊（ERC20）地址",
  41252: "查詢超過限制",
  41253: "Ensure that there are no more than 10 digits before the decimal point",
  41254: "Resume cannot exceed 5 copies",
  41255: "This resume is not yours",
  41256: "No more than 30",
  41257: "The number of times has been used up",
  41258: "You cannot obtain data for this user",
  41259: "The time cannot be greater than the current time",
  41260: "無效的验证",
  41262: "You cannot created more than 3 remote job preferences",
  41263: "You cannot created more than 3 on-site or hybrid job preferences",
  41264: "Supported resume file types are pdf,doc,docx",
  41265: "Supported video file types are mp4,avi,mov,wmv,flv,mkv,mpeg,webm,3gp,ogg",
  41266: "The import-task already exists within our company",
  41267: "Unsupported import link",
  41268: "You do not have permission to perform this operation",
  41269: "Only 10 people can be invited at a time",
  41270: "The selected role ID does not match the value",
  41271: "Invalid line crendentials",
  41272: "Invalid x crendentials",
  41273: "The invitation link has expired",
  41274: "Your identity information does not match the position you submitted, and you cannot start a chat with the employer for this position.",
  41275: "由於頻寬問題，您已超出AICV允許的查詢限制。請於24小時後再試。",
  41276: "The number of brands or products added exceeds the limit.",
  41277: "The number of related pictures added for a brand or product exceeds the limit.",
  41278: "The uploaded url does not meet the specifications.",
  41279: "The job reminder content you set is duplicated, please modify it and save it.",
  41280: "Apologies, AI is currently unavailable due to an error. Please try again later.",
  41281: "Resume parsing failed, please make sure you upload the correct resume.",
  48905: "該電子郵件已被註冊",
  50001: "內部服務器錯誤",
  50002: "上傳簡歷失敗",
  50003: "缺少的个人资料",
  50004: "此联系交换请求已处理",
  50005: "您没有足够的解锁人才积分",
  50006: "未找到面试信息",
  50007: "此简历请求已处理",
  50008: "上傳個人頭像失敗",
  50009: "解鎖人才失敗",
  50010: "需要提供参数ids",
  50011: "人才已经解锁",
  50012: "參數簡歷最後更新的名稱無效",
  50013: "目前没有找到结果，请再试一次",
  50014: "搜索薪资失败",
  50015: "You have joined another company,Please log in to the management backend again and exit the company before joining another company"
}, Vi = {
  title: "Hoş geldiniz",
  tips: "İnsanları işe almak mı istiyorsunuz? Olarak kaydolun ",
  continueWith: "ya da şununla devam edin",
  agreement: "{{value1}} ve {{value2}}'yi okudum ve kabul ettim",
  emailValid: "Lütfen geçerli bir e-posta adresi girin.",
  emailLabel: "E-posta Adresi",
  sendCodeDigit: "Lütfen gönderdiğimiz 6 haneli kodu giriniz ",
  checkSpamEmail: "Kod almadıysanız spam postanızı kontrol edin",
  otherOptions: "diğer seçenekleri deneyin",
  alternatively: "Alternatif olarak, bir",
  resendCode: "Kodu yeniden gönder",
  country: "Ülke",
  phoneNumber: "Telefon Numarası",
  twoFactor: "Güvenlik Doğrulaması",
  authentication: "kimlik doğrulaması",
  secure: "Hesabınızı güvende tutun ve e-postanıza kod alınız",
  emailTips: "Giriş yöntemi son giriş ile tutarsız, lütfen güvenliği e-posta yoluyla doğrulayınız",
  setUpLater: "Bunu daha sonra ayarlayın",
  enableTwoFactor: "iki faktör",
  authenticationEnabled: "kimlik doğrulama etkinleştirildi",
  factorTip: "Tanımadığımız bir cihaz veya tarayıcıdan giriş yapılmaya çalışıldığını fark edersek sizden e-posta adresinize gönderilen kodu ister.",
  verifyText: "Sizin olduğunuzu doğrulayınız",
  verifyExtra: "Bu ekstra adım, oturum açmaya çalışan kişinin gerçekten siz olduğunuzu gösterecek.",
  optError: "OTP gönderme başarısız oldu",
  resendEmailCode: "E-postayı yeniden gönder'OTP başarılı",
  invalidOtp: "Girdiğiniz OTP yanlış. Lütfen tekrar deneyin.",
  resendPhoneCode: "Telefonun OTP başarısını tekrar gönder",
  verifyEmail: "E-mail'i doğrula",
  thisPhoneNumberAssociated: "Hesap Seçiniz",
  accounts: "hesaplarınız.",
  thisPhoneNumber: "Bu telefon numarası şununla ilişkilidirin ",
  youNeedToChooseVerified: "İlişkilendirmek için doğrulanmış bir e-posta adresi seçmeniz gerekmekte",
  validateErr: "E-posta kaydedildi. Lütfen bağlantıyı başka bir e-postayla değiştirin",
  checkYourSpam: "Kod almadıysanız spam postanızı kontrol edin.",
  authenticationSuccessful: "Kimlik Doğrulama Başarılı",
  Bossjob: "Bossjob",
  back: "Geri",
  vipText: {
    GetVipPrivilegesImmediately: "VIP Ayrıcalıklarına Hemen Sahip Olun",
    InviteNewUsersToRegister: "Yeni Kullanıcıları Kaydolmaya Davet Et",
    BossjobAI: "Patron işi yapay zekası",
    ResumeAssistant: "Patron işi yapay zekası",
    HighSalaryOffer: "Yüksek Maaş Teklifi",
    HelpYouGet: "Almanıza Yardımcı Olun",
    promptDesc: "Hata! Zaten giriş yaptınız; tekrar tekrar kaydolmak mümkün değildir. Lütfen çıkış yapın ve tekrar deneyin.",
    returnHome: "Ana Sayfaya Dön",
    signOut: "Çıkış Yap",
    inviteFriendsToGet: "Arkadaşlarınızı Almaya Davet Edin",
    AIResumeCoaching: "AI ÖZGEÇMİŞ KOÇLUĞU",
    HighQualityVIPResumeTemplateAndAIAssistantToHelpYouGetHighPayingOffer: "Yüksek Ödemeli Teklif Almanıza Yardımcı Olacak Yüksek Kaliteli VIP Özgeçmiş Şablonu ve Yapay Zeka Asistanı.",
    copyLinkToInviteNow: "Şimdi davet etmek için bağlantıyı kopyalayın"
  },
  links: {
    apple: "Apple ile devam et",
    google: "Google ile devam et",
    facebook: "Facebook ile devam et",
    appleText: "Apple",
    line: "Continue with Line",
    twitter: "Continue with X"
  },
  seoMetaTitle: "Başlayın | Bossjob",
  JoinBossjob: "Bossjob'a katılın",
  kickStartYourCareer: "kariyerinize hızlı bir başlangıç yapın!",
  enterYourEmailAddress: "E-posta adresinizi girin",
  submit: "Gönder",
  "pleaseEnterAvalidEmailAddress.": "Lütfen geçerli bir e-posta adresi girin.",
  bySigningUp: "Kaydolarak okudum ve kabul ediyorum",
  termsOfUse: "Kullanım Koşulları",
  and: "ve",
  privacyPolicy: "Gizlilik Politikası",
  signInWith: "Şununla giriş yapın",
  lookingToHire: "İnsanları işe almak mı istiyorsunuz? Olarak kaydolun ",
  employer: "İşveren",
  welcomeBack: "Tekrar Hoş Geldiniz!",
  signUpAnAccount: "Bir hesaba kaydolun",
  pleaseEnter: "Lütfen gönderdiğimiz 6 haneli tek kullanımlık şifreyi giriniz",
  enter6DigitOTP: "6 haneli OTP'yi girin",
  getOPT: "OTP'yi al",
  heOTPYouHaveEnteredIsWrong: "Girdiğiniz OTP yanlış. Lütfen tekrar deneyin.",
  resendOTP: "Tekrar OTP gönder",
  havingTrouble: "Sorun mu yaşıyorsunuz?",
  requestAmagicLink: "Sihirli Bağlantı İste",
  seoMetaDescription: "Profesyonel kariyerinizi hızlandırmak için bugün Bossjob'a katılın! Kurslara ve iş fırsatlarına erişin ",
  seoMetaDescription2: "2 milyondan fazla profesyonelden oluşan ağ.",
  magicLinkText: "sihirli bağlantı",
  magicLink: {
    welcomeBack: "Tekrar Hoş Geldiniz!",
    signUp: "Bir hesaba kaydolun",
    haveSendEmail: "{{email}} adresine sihirli bir bağlantı gönderdik. Devam etmek için lütfen bağlantıya tıklayın.",
    toHome: "Ana sayfaya geri dön"
  },
  loginUsingSocialMediaOTP: "Sosyal medya/OTP kullanarak giriş yapın",
  loginUsingQRCode: "QR kodunu kullanarak giriş yapın",
  scanQRCodeOnAppToLogin: "Anında giriş yapmak için bu kodu Bossjob uygulamasıyla tarayın",
  donHaveApp: "Uygulamam yok",
  sendCode: "Doğrulama kodu gönder",
  howToScanQRCode: "QR kodu nasıl taranır",
  ImJobSeeker: "İş Arayanım",
  ImRecruiter: "Ben bir İşverenim",
  menuLoginToVersion: "Menü > Web sürümüne giriş yapınız",
  scannedSuccessfully: "Başarıyla tarandı",
  pleaseConfirmLoginOnAPP: "Lütfen uygulamada oturum açmayı onaylayınız",
  pleaseRefreshQrCode: "Lütfen QR kodunu yenileyin",
  clickToRefresh: "Yenilemek için tıklayın",
  accountMismatch: "Hesap türü eşleşmiyor, lütfen giriş yapmak için iş başvurusunu kullanın",
  loginWithQRCode: "QR kod ile oturum açın",
  email: "E-posta",
  phone: "Telefon Numarası",
  haveSendEmail: "{{email}} adresine sihirli bir bağlantı gönderdik. Devam etmek için lütfen bağlantıya tıklayın.",
  leftBanner: {
    free: "Ücretsiz",
    lifetime: "Ömür Boyu",
    quick: "Hızlı",
    production: "Üretim",
    aIAssisted: "Yapay Zeka Desteklidir",
    resumeEditing: "Düzenlemeye Devam Edin",
    aGoodResume: "İyi Bir Öz geçmiş",
    aGoodResumeDesc: "Maaşınızı Ortalama %37 Arttır"
  },
  enterYourEmail: "Enter your email",
  verificationEmailCode: "We will send a verification code to your email",
  confirmationCode: "Enter confirmation code",
  enterOTP: "Please enter the 6-digit code that we sent to",
  verificationPhoneCode: "We will send a verification code to your phone",
  enterYourPhone: "Enter your Phone",
  connectYourEmail: "Please connect your email",
  connectYourEmailTip: "We'll just need your email address to finish registering or logging onto Bossjob.",
  downloadApp: "Uygulamayı İndir",
  neptune: "Neptune",
  neptuneOffersJob: "Neptune offers job seekers verified, current information on companies hiring, enabling informed career decisions."
}, Wi = {
  getStarted: Vi
}, Qi = {
  0: "Başarı",
  40001: "Parametre doğrulaması başarısız veya geçersiz",
  40002: "Yanlış kimlik doğrulama bilgileri",
  40003: "Kimlik doğrulama bilgileri sağlanmadı",
  40004: "Kaynak bulunamadı",
  40005: "Bu eylemi gerçekleştirme izniniz yok",
  40006: "Lütfen {{retry_after}} saniye içinde tekrar deneyin",
  41001: "e posta Zaten alındı",
  41002: "Müşteri kimliği zaten alınmış",
  41003: "Gizli anahtar zaten alınmış",
  41004: "Kullanıcıların bir e-posta adresi olması gerekir",
  41005: "Bu e-posta kaydedilemedi",
  41006: "Güncelleme durumu açılamıyor",
  41007: "Yüklenen dosya maksimum dosya boyutu sınırını (20 MB) aşıyor",
  41008: "Yüklenen dosya desteklenmiyor",
  41009: "Mevcut şifre eşleşmiyor",
  41010: "Şifre ve onay şifresi eşleşmiyor",
  41011: "Bağlantı isteğine zaten yanıt verdiniz",
  41012: "Yinelenen öğeler bulundu",
  41014: "Bağlantı isteği bu yeteneğe gönderildi",
  41015: "Bu yeteneğe bağlantı isteği göndermediniz",
  41016: "Bosshunt haber bültenine başarıyla abone oldunuz",
  41017: "Bu ada sahip işlem hattı oluşturuldu",
  41018: "Bu e-postayı içeren özgeçmiş oluşturuldu",
  41019: "Kaynak bulunamadı",
  41020: "Bitiş tarihi başlangıç tarihinden önce olamaz",
  41022: "Kullanıcının ayrıştırmak için yeterli kredisi yok",
  41023: "Boru hattı bulunamadı",
  41024: `Sahne bulunamadı
​`,
  41025: "Devam kimlikleri bulunamadı",
  41026: "Bu yorumu düzenlemenize izin verilmiyor",
  41027: "Bu e-postaya sahip yetenek yaratıldı",
  41028: "Yıllık brüt maaş, yıllık brüt maaştan geç olamaz",
  41029: "Aylık ücret, şu tarihten itibaren aylık ücretten daha geç olamaz",
  41030: "Dönemden geri dönüş süresi, döneme geri dönüş zamanından daha geç olamaz",
  41031: "Bu kayıt mevcut değil",
  41032: "Dönemden döneme garanti süresi, garanti döneminden döneme kadar geçemez",
  41034: "Kullanıcının özgeçmişi ayrıştırmak için yeterli kredisi yok",
  41035: "Jeton oluşturulamadı",
  41036: "Geçersiz jeton",
  41037: "E-posta zaten doğrulandı",
  41038: "Bu e-posta zaten var",
  41039: "Bu numara zaten bir hesap için kullanılmış Lütfen farklı bir numara deneyin",
  41040: "Girdiğiniz OTP yanlış. Lütfen tekrar deneyin",
  41041: "Geçersiz e-posta",
  41042: "Otp kullanıldı",
  41043: "Otp'nin süresi doldu",
  41044: "Hesap askıya alındı",
  41045: "Telefon numarası zaten doğrulandı",
  41046: "İzin verilmeyen seçimler",
  41047: "Your account has been suspended Please contact support@bossjobcom for clarification",
  41048: "Geçersiz kullanıcı veya telefon numarası",
  41049: "Kaynak alanı zorunludur",
  41050: "Kimliğin sona ermesi",
  41051: "Kullanıcının telefon numarası kaydı yok",
  41052: "Geçersiz Google kimlik bilgileri",
  41053: "Geçersiz linkedin kimlik bilgileri",
  41054: "Geçersiz facebook kimlik bilgileri",
  41055: "Geçersiz elma kimlik bilgileri",
  41056: "Email adresiniz veya doğrulama kodunuz yanlış. Lütfen tekrar girin.",
  41057: "Email gereklidir",
  41058: "Kullanıcı mevcut değil",
  41059: "Geçersiz tamsayı listesi değeri",
  41060: "Bu şirketi yalnızca şirket koordinatörü yöneticisi silebilir",
  41061: "Yalnızca şirket yöneticisi şirket dokümanını yükleyebilir",
  41062: "Şirket zaten doğrulandı",
  41063: "Doküman yüklenemedi",
  41064: "Yüklenen dosya maksimum resim boyutu sınırını (4mb) aşıyor",
  41065: "Eksik senkronizasyon şirketi kimlikleri",
  41066: "Şirket bulunamadı",
  41067: "Şirket doğrulamayı bekliyor",
  41069: "İş deneyimi bulunamadı",
  41070: "Geçersiz sıralama düzeni",
  41071: "Fotoğraf bu sıralama düzeninde mevcut değil",
  41072: "Lütfen katılım sürecini tamamlayın",
  41073: "Geçersiz iş deneyimi durumu",
  41074: "İsim zaten mevcut",
  41075: "Ad kısıtlanmış karakterler içeriyor: +",
  41077: "Geçersiz kimlik veya anahtar",
  41078: "Geçersiz çalışma adresi",
  41079: "Şirket doğrulanmadı",
  41080: "Geçersiz kullanıcı",
  41081: "İşveren seçilen şirkette değil",
  41082: "Banner yüklenemedi",
  41083: "Şirket fotoğrafı yüklenemedi",
  41084: "Logo yüklenemedi",
  41085: "Yüklenen resim maksimum resim boyutu sınırını (5mb) aşıyor",
  41086: "Yüklenen resim maksimum resim boyutu sınırını (1mb) aşıyor",
  41087: "Zaman sınırı aşıldı",
  41088: "Şirket koordinatörü silinemiyor",
  41089: "Bir koordinatörün rolü değiştirilemez",
  41090: "Geçersiz yeni yönetici",
  41091: "Kültür kimlikleri sayı olmalıdır",
  41092: "Geçersiz kültür kimlikleri",
  41093: "Avantaj kimlikleri sayı olmalıdır",
  41094: "Geçersiz avantaj kimlikleri",
  41095: "Parametre değeri hatası",
  41096: "Desteklenmeyen ülke",
  41097: "Parametre yetenek kimlikleri alanı zorunludur",
  41098: "Parametre enlem ve boylam zorunlu alanlardır",
  41099: "Eksik senkronizasyon işi kimlikleri",
  41100: "Parametre sorgu alanı geçersiz değer",
  41101: "Bazı konumlar mevcut değil",
  41102: "Bazı iş türleri mevcut değil",
  41103: "Bazı maaş aralıkları mevcut değil",
  41104: "Bazı iş kategorileri mevcut değil",
  41105: "Bazı ana işlevler mevcut değil",
  41106: "Bazı iş işlevi kimlikleri mevcut değil",
  41107: "Bazı işlev iş unvanı kimliği mevcut değil",
  41108: "Bazı sektörler mevcut değil",
  41109: "Bazı deneyimler mevcut değil",
  41110: "Bazı dereceler mevcut değil",
  41111: "geçersiz değer",
  41112: "Abone olma işi frekansı mevcut değil",
  41113: "Bu iş mevcut değil",
  41114: "Şirkete katılmadınız",
  41115: "Başlangıç tarihi veya bitiş tarihi geçersiz",
  41116: "Otomatik yönlendirme zaten kapatıldı",
  41117: "Otomatik iletme zaten açık",
  41118: "Otomatik iletme devam etme izni hatası",
  41119: "E-postalar boş olamaz",
  41120: "İşçi maaşının maskesi zaten düşürüldü",
  41121: "İş maaşı zaten maskelendi",
  41122: "İşverenin maaşı maskeleme izni yok",
  41123: "İşverenin yeterli iş kredisi yok",
  41124: "İş zaten öne çıkan bir işe yükseltildi",
  41125: "Geçerli bir e-posta adresi girin",
  41126: "İşverenin şirketi yok",
  41127: "İş zaten kapatıldı",
  41128: "Sorgu parametreleri geçersiz değer",
  41129: "İş zaten acil bir işe yükseltildi",
  41130: "Bu alana “-” girilemez",
  41131: "Kullanıcı kimliği alanı zorunludur",
  41132: "Bu iş bulunamadı",
  41133: "İş arayanın özgeçmişi bulunamadı",
  41134: "İş başvurunuz işleme alınıyor",
  41135: "Parametre kullanıcı kimliği gerekli",
  41136: "Tarama sorularının tamamının yanıtlanması zorunludur",
  41137: "Geçersiz rapor işi nedeni",
  41139: "Mevcut kişi değişimi isteği devam ediyor",
  41140: "Kendinizle sohbet etmenize izin verilmiyor",
  41141: "Katılım zaten işaretlendi",
  41142: "Geçersiz görüşme durumu",
  41143: "Katılımı işaretlemek için geçersiz süre, görüşme başladıktan sonra 30 dakikadan fazla olmalıdır",
  41145: "Görüşme durumunun güncellenmesine izin verilmiyor",
  41146: "Kontrol edilmesine izin verilmiyor",
  41147: "Bu röportaj için zaten kayıt yaptırdınız",
  41148: "Mülakat başlamadan iki saat öncesinden itibaren check-in yapabilirsiniz.",
  41149: "Mülakat başladıktan en geç yarım saat sonra giriş yapabilirsiniz.",
  41150: "Bu iş mevcut değil",
  41151: "Bu iş aktif değil",
  41152: "Yaklaşan röportajın iptal edilmesine izin verilmiyor",
  41153: "Görüşme süresi mevcut saatten daha uzun olmalıdır",
  41154: "Mevcut görüşme devam ediyor",
  41155: "İstek zaten devre dışı bırakıldı",
  41156: "İş Bulunamadı",
  41157: "Geçersiz özgeçmiş kimliği",
  41158: "Devam eden sohbet için özgeçmişin otomatik olarak gönderilmesi ayarlanamıyor",
  41159: "Mevcut konum onayı devam ediyor",
  41162: "Mevcut özgeçmiş isteği devam ediyor",
  41163: "Bu görüşmenin sonuçları istendi",
  41164: "Parametre yetenek kimliği alanı gerekli",
  41165: "Parametre yetenek kimlikleri alanı zorunludur",
  41167: "Başlangıç tarihi alanının bitiş tarihinden önce olduğundan emin olun",
  41168: "Adres zaten mevcut",
  41169: "Kimlik uzunluğu 1000'den büyük olamaz",
  41170: "Üçten fazla özgeçmiş gönderildi",
  41171: "OTP'nin süresi doldu",
  41172: "OTP zaten kullanıldı",
  41173: "OTP zaten kullanıldı",
  41174: "Yüklenen dosya maksimum dosya boyutu sınırını (5 MB) aşıyor",
  41175: "Yüklenen dosya uzantısı desteklenmiyor",
  41176: "Yüklenen resim maksimum resim boyutu sınırını (500kb) aşıyor",
  41177: "Geçersiz kimlik değeri",
  41178: "Geçersiz iş emri",
  41179: "Dosya adı alanı zorunludur",
  41181: "En fazla 10 ortak kelime öbeğiniz olabilir",
  41182: "Düzenleme tarihinin son kullanma tarihinden önce olduğundan ve son kullanma tarihinin veriliş tarihinden sonra olduğundan emin olun",
  41183: "Geçersiz ek URL'si",
  41184: "Mobil hata",
  41185: "Gövde hatası",
  41186: "Otomatik gönderilen özgeçmiş için seçilen özgeçmişi silemezsiniz",
  41187: "Kullanıcı ve gönderen tutarlı olmalıdır",
  41188: "Kullanıcı ve alıcı tutarlı olmalı",
  41191: "İş deneyimi bulunamadı",
  41192: "Geçersiz iş deneyimi durumu, bu şirkete katılamıyor",
  41194: "Doğrulanmamış şirkete katılamıyorum",
  41196: "Only company admin can perform verification for recruiter to join this company",
  41197: "Bu şirkete katılmak için kendiniz doğrulama yapamazsınız",
  41198: "İşveren bulunamadı",
  41199: "İşveren bu şirkete katılma talebinde bulunmadı",
  41201: "İşverenin şirket kaydı yok",
  41202: "İşveren şirket koordinatörü değil",
  41204: "Eksik rol anahtarı",
  41205: "Şirket yöneticisi, yönetici sahipliğini aktarmadan şirketten ayrılamaz",
  41207: "Yüklenen resim maksimum resim boyutunu aşıyor",
  41208: "Açıklama gerekli",
  41209: "Tarih gerekli",
  41213: "Yetenek zaten kaldırıldı",
  41214: "Parametrenin kaldırılmasının nedeni alanı zorunludur",
  41217: "Bu iş mevcut değil",
  41219: "Şirkete katılmadınız",
  41221: "İçerik türü yalnızca application/x-www-form-urlencoded'ı destekler ve istek yöntemi gönderildiğinde gereklidir",
  41222: "istek yöntemi yalnızca gönderme veya alma yöntemlerini destekler",
  41223: "İzin verilmeyen kategori",
  41224: "Otomatik yanıt sohbet alanı doğruysa mesaj verilerine ihtiyaç vardır",
  41225: "Otomatik yanıtı ayarlama izniniz yok",
  41226: "Lütfen sorgu parametresi mesaj türü kimliğini sağlayın",
  41227: "Kullanıcı kayıtlı değil",
  41228: `
`,
  41229: "Şirket listeleme bilgisi bulunamadı",
  41230: "işveren iş deneyimi bulunamadı",
  41231: "Şirketin koordinatörüsünüz ve mevcut işlemi gerçekleştiremezsiniz",
  41232: "Şirket hak talebinde bulunulmadı",
  41233: "Bu sohbeti silme izniniz yok",
  41234: "Telefon numaranız doğru görünmüyor, lütfen tekrar girin",
  41235: "Geçersiz link",
  41236: "Yanlış telefon veya alan kodu girdiniz",
  41237: "Telefon numarası doğrulamanız başarısız oldu veya zaman aşımına uğradı",
  41238: "İş deneyimi başlangıç zamanı bitiş zamanından kısa olmalıdır",
  41239: "Etkinlik bulunamadı",
  41240: "Etkinlik henüz başlamadı",
  41241: "Etkinlik sona erdi",
  41242: "Bu etkinliğe katılmadınız",
  41243: "Ödül tamamen kullanıldı",
  41244: "Kullanma sınırına ulaşıldı",
  41245: "Üçten fazla video özgeçmiş gönderildi",
  41246: "Geri çekilmek için yeterli puan yok",
  41247: "Tron(TRC20) için minimum çekim tutarı 100 puandır.",
  41248: "Ethereum(ERC20) için minimum çekim tutarı 1000 puandır.",
  41249: "Para çekme tutarı çarpanı 100 puandır",
  41250: "Geçersiz Tron(TRC20) adresi",
  41251: "Geçersiz Ethereum(ERC20) adresi",
  41252: "Sorgu sınırı aşıyor",
  41253: "Ondalık noktadan önce 10 rakamdan fazla olmadığından emin olun",
  41254: "Özgeçmiş 5 kopyayı geçemez",
  41255: "Bu özgeçmiş senin değil",
  41256: "En fazla 30",
  41257: "Kullanılma sayısı tükendi",
  41258: `Bu kullanıcı için veri alamazsınız
​`,
  41259: "Zaman geçerli saatten daha büyük olamaz",
  41260: "Geçersiz doğrulama",
  41262: "3'ten fazla uzak iş tercihi oluşturamazsınız",
  41263: "3'ten fazla yerinde veya hibrit iş tercihi oluşturamazsınız",
  41264: "Desteklenen özgeçmiş dosya türleri pdf,doc,docx'tir",
  41265: "Desteklenen video dosyası türleri: mp4,avi,mov,wmv,flv,mkv,mpeg,webm,3gp,ogg",
  41266: "İthalat görevi şirketimizde zaten mevcut",
  41267: "Desteklenmeyen içe aktarma bağlantısı",
  41268: "Bu işlemi gerçekleştirme izniniz yok",
  41269: "Aynı anda yalnızca 10 kişi davet edilebilir",
  41270: "Seçilen rol kimliği değerle eşleşmiyor",
  41271: "Geçersiz hat kimlik bilgileri",
  41272: "Geçersiz x kimlik bilgileri",
  41273: "Davet bağlantısının süresi doldu",
  41274: "Your identity information does not match the position you submitted, and you cannot start a chat with the employer for this position.",
  41275: "Due to bandwidth issues, you have exceeded the allowable limit of queries for AICV. Please try again in 24 hours.",
  41276: "The number of brands or products added exceeds the limit.",
  41277: "The number of related pictures added for a brand or product exceeds the limit.",
  41278: "The uploaded url does not meet the specifications.",
  41279: "The job reminder content you set is duplicated, please modify it and save it.",
  41280: "Apologies, AI is currently unavailable due to an error. Please try again later.",
  41281: "Resume parsing failed, please make sure you upload the correct resume.",
  48905: "E-posta kaydedildi",
  50001: "İç Sunucu Hatası",
  50002: "Özgeçmiş yüklenemedi",
  50003: "Eksik profiller",
  50004: "Bu kişi değişimi isteği işleme alındı",
  50005: "Yeterince kilit açma yetenek krediniz yok",
  50006: "Röportaj mesajı bulunamadı",
  50007: "Bu özgeçmiş isteği işleme alındı",
  50008: "Profil resmi yüklenemedi",
  50009: "Kilidi açılan yetenek başarısız oldu",
  50010: "Parametre kimlikleri gerekli",
  50011: "Yeteneğin kilidi açıldı",
  50012: "Parametre özgeçmişinin son güncellenme adı geçersiz değer",
  50013: "Şu anda sonuç bulunamadı Lütfen tekrar deneyin",
  50014: "Maaş arama başarısız",
  50015: "Başka bir şirkete katıldınız. Başka bir şirkete katılmadan önce lütfen yönetim arka ucuna tekrar giriş yapın ve şirketten çıkın"
}, Ji = {
  title: "Selamat datang ke",
  tips: "Ingin mengambil pekerja? Daftar sebagai ",
  continueWith: "atau teruskan dengan",
  agreement: "Saya telah membaca dan bersetuju untuk {{value1}} dan {{value2}}",
  emailValid: "Sila masukkan alamat e-mel yang sah.",
  emailLabel: "Alamat E-mel",
  sendCodeDigit: "Sila masukkan kod 6 digit yang kami hantar ",
  checkSpamEmail: "Periksa surat spam anda jika anda tidak menerima kod",
  otherOptions: "pilihan lain",
  alternatively: "Sebagai alternatif, minta",
  resendCode: "Hantar semula kod",
  country: "Negara",
  phoneNumber: "Nombor Telefon",
  twoFactor: "Pengesahan Keselamatan",
  authentication: "autentikasi",
  secure: "Selamatkan akaun anda dan terima kod melalui e-mel anda",
  emailTips: "Kaedah log masuk tidak sesuai dengan log masuk terakhir, sila sahkan keselamatan melalui e-mel",
  setUpLater: "Tetapkan kemudian",
  enableTwoFactor: "dua-faktor",
  authenticationEnabled: "autentikasi diaktifkan",
  factorTip: "Sekiranya kami melihat percubaan masuk dari peranti atau penyemak imbas yang tidak kami kenali, kami akan meminta kod yang dihantar ke alamat e-mel anda.",
  verifyText: "Sahkan bahawa ini anda",
  verifyExtra: "Langkah tambahan ini menunjukkan bahawa anda benar-benar cuba log masuk.",
  optError: "Penghantaran OTP gagal",
  resendEmailCode: "Penyampaian semula OTP melalui e-mel berjaya",
  invalidOtp: "OTP yang anda masukkan adalah salah. Sila cuba lagi.",
  resendPhoneCode: "Penyampaian semula OTP telefon berjaya",
  verifyEmail: "Sahkan e-mel",
  thisPhoneNumberAssociated: "Pilih akaun",
  accounts: "akaun.",
  thisPhoneNumber: "Nombor telefon ini dikaitkan dengan ",
  youNeedToChooseVerified: "Anda perlu memilih alamat e-mel yang disahkan untuk dikaitkan",
  validateErr: "E-mel telah didaftarkan. Sila ubah pengikatan ke e-mel lain",
  checkYourSpam: "Periksa surat spam anda jika anda tidak menerima kod.",
  authenticationSuccessful: "Pengesahan Berjaya",
  Bossjob: "Bossjob",
  back: "Kembali",
  vipText: {
    GetVipPrivilegesImmediately: "Dapatkan Keistimewaan VIP Segera",
    InviteNewUsersToRegister: "Jemput Pengguna Baru Untuk Mendaftar",
    BossjobAI: "AI Bossjob",
    ResumeAssistant: "Pembantu Resume",
    HighSalaryOffer: "Tawaran Gaji Tinggi",
    HelpYouGet: "Menolong Anda Untuk Mendapatkan",
    promptDesc: "Alamak, anda sudah log masuk; mendaftar berulang kali tidak boleh dilakukan. Sila log keluar dan cuba lagi.",
    returnHome: "Kembali ke Halaman Utama",
    signOut: "Daftar Keluar",
    inviteFriendsToGet: "Jemput Rakan Untuk Mendapatkan",
    AIResumeCoaching: "BIMBINGAN RESUME AI",
    HighQualityVIPResumeTemplateAndAIAssistantToHelpYouGetHighPayingOffer: "Templat Resume VIP Berkualiti Tinggi Dan Pembantu AI Untuk Membantu Anda Mendapatkan Tawaran Dengan Bayaran Tinggi.",
    copyLinkToInviteNow: "Salin pautan untuk menjemput sekarang"
  },
  links: {
    apple: "Teruskan dengan Apple",
    google: "Teruskan dengan Google",
    facebook: "Teruskan dengan Facebook",
    appleText: "Apple",
    line: "Continue with Line",
    twitter: "Continue with X"
  },
  seoMetaTitle: "Mulakan | Bossjob",
  JoinBossjob: "Sertai Bossjob",
  kickStartYourCareer: "mulakan kerjaya anda!",
  enterYourEmailAddress: "Masukkan alamat e-mel anda",
  submit: "Hantar",
  "pleaseEnterAvalidEmailAddress.": "Sila masukkan alamat e-mel yang sah.",
  bySigningUp: "Dengan mendaftar, saya telah membaca dan bersetuju untuk",
  termsOfUse: "Syarat Penggunaan",
  and: "dan",
  privacyPolicy: "Dasar Privasi",
  signInWith: "Daftar masuk dengan",
  lookingToHire: "Ingin mengambil pekerja? Daftar sebagai ",
  employer: "Majikan",
  welcomeBack: "Selamat kembali!",
  signUpAnAccount: "Daftar akaun",
  pleaseEnter: "Sila masukkan kata laluan sekali pakai 6-digit yang kami hantar",
  enter6DigitOTP: "Masukkan OTP 6 angka",
  getOPT: "dapatkan OPT",
  heOTPYouHaveEnteredIsWrong: "OTP yang anda masukkan adalah salah. Sila cuba lagi.",
  resendOTP: "Hantar semula OTP",
  havingTrouble: "Menghadapi masalah?",
  requestAmagicLink: "Minta Pautan Magic",
  seoMetaDescription: "Sertailah Bossjob untuk mempercepat kerjaya profesional anda hari ini! Akses kursus dan peluang pekerjaan di ",
  seoMetaDescription2: "Rangkaian 2 juta+ profesional.",
  magicLinkText: "pautan magic",
  magicLink: {
    welcomeBack: "Selamat kembali!",
    signUp: "Daftar akaun",
    haveSendEmail: "Kami telah menghantar pautan magic ke {{email}}. Sila klik pada pautan untuk meneruskan.",
    toHome: "Kembali ke Halaman Utama"
  },
  loginUsingSocialMediaOTP: "Log masuk menggunakan media sosial/ OTP",
  loginUsingQRCode: "Log masuk dengan kod QR",
  scanQRCodeOnAppToLogin: "Imbas kod ini dengan aplikasi Bossjob untuk log masuk dengan serta-merta",
  donHaveApp: "Tidak mempunyai Aplikasi",
  sendCode: "Hantar kod pengesahan",
  howToScanQRCode: "Cara mengimbas kod QR",
  ImJobSeeker: "Saya Adalah Pencari Kerja",
  ImRecruiter: "Saya seorang Perekrut",
  menuLoginToVersion: "Menu > Log masuk ke versi web",
  scannedSuccessfully: "Diimbas dengan jayanya",
  pleaseConfirmLoginOnAPP: "Sila sahkan log masuk di Aplikasi",
  pleaseRefreshQrCode: "Tolong segar semula kod QR",
  clickToRefresh: "Klik untuk segar semula",
  accountMismatch: "Jenis akaun tidak sepadan, sila gunakan aplikasi pekerjaan untuk log masuk",
  loginWithQRCode: "Log masuk dengan kod QR",
  email: "E-mel",
  phone: "Telefon",
  haveSendEmail: "Kami telah menghantar pautan magic ke {{email}}. Sila klik pada pautan untuk meneruskan.",
  leftBanner: {
    free: "Percuma",
    lifetime: "Seumur Hidup",
    quick: "Pantas",
    production: "Pengeluaran",
    aIAssisted: "Dibantu AI",
    resumeEditing: "Penyuntingan Resume",
    aGoodResume: "Resume yang Baik",
    aGoodResumeDesc: "Meningkatkan Gaji Anda Dengan Purata 37%"
  },
  enterYourEmail: "Enter your email",
  verificationEmailCode: "We will send a verification code to your email",
  confirmationCode: "Enter confirmation code",
  enterOTP: "Please enter the 6-digit code that we sent to",
  verificationPhoneCode: "We will send a verification code to your phone",
  enterYourPhone: "Enter your Phone",
  connectYourEmail: "Please connect your email",
  connectYourEmailTip: "We'll just need your email address to finish registering or logging onto Bossjob.",
  downloadApp: "Muat Turun App",
  neptune: "Neptune",
  neptuneOffersJob: "Neptune offers job seekers verified, current information on companies hiring, enabling informed career decisions."
}, Xi = {
  getStarted: Ji
}, Zi = {
  0: "Berjaya",
  40001: "Pengesahan parameter gagal atau tidak sah",
  40002: "Butiran autentikasi yang tidak betul",
  40003: "Butiran autentikasi tidak disediakan",
  40004: "Sumber tidak ditemui",
  40005: "Anda tidak mempunyai kebenaran untuk melakukan tindakan ini",
  40006: "Percubaan terlalu kerap. Sila cuba lagi dalam {{retry_after}} saat",
  41001: "E-mel telah diambil",
  41002: "Id pelanggan telah diambil",
  41003: "Kunci rahsia telah diambil",
  41004: "Pengguna mesti mempunyai alamat e-mel",
  41005: "Gagal untuk mendaftar e-mel ini",
  41006: "Tidak dapat mengemas kini status",
  41007: "Fail yang dimuat naik melebihi had maksimum fail (20MB)",
  41008: "Fail yang dimuat naik tidak disokong",
  41009: "Kata laluan semasa tidak sepadan",
  41010: "Kata laluan dan sahkan kata laluan tidak sepadan",
  41011: "Anda telah memberi respons terhadap permintaan penyambungan ini",
  41012: "Item berkembar dijumpai",
  41014: "Permintaan penyambungan telah dihantar kepada ahli bakat ini",
  41015: "Anda belum menghantar permintaan penyambungan kepada ahli bakat ini",
  41016: "Anda telah melanggan buletin Bosshunt dengan jayanya",
  41017: "Saluran bakat dengan nama ini telah dicipta",
  41018: "Resume bersama e-mel ini telah dicipta",
  41019: "Sumber tidak ditemui",
  41020: "Tarikh kini tidak boleh dari tarikh sebelumnya",
  41022: "Pengguna tidak mempunyai kredit yang mencukupi untuk hurai",
  41023: "Saluran bakat tidak ditemui",
  41024: "Stage tidak dijumpai",
  41025: "Id Resume tidak dijumpai",
  41026: "Anda tidak dibenarkan untuk mengedit komen ini",
  41027: "Ahli bakat bersama emel ini telah dicipta",
  41028: "Gaji kasar tahunan dari tidak boleh lewat daripada gaji kasar tahunan hingga",
  41029: "Caj bulanan dari tidak boleh lewat daripada caj bulanan hingga",
  41030: "Masa turnaround dari tempoh tidak boleh lewat daripada masa turnaround hingga tempoh",
  41031: "Rekod ini tidak wujud",
  41032: "Jaminan tempoh dari tempoh tidak boleh lewat daripada jaminan tempoh hingga tempoh",
  41034: "Pengguna tidak mempunyai kredit yang mencukupi untuk menguraikan resume",
  41035: "Gagal untuk menghasilkan token",
  41036: "Token tidak sah",
  41037: "E-mel telah disahkan",
  41038: "E-mel sudah wujud",
  41039: "Nombor ini telah digunakan untuk membuat akaun Sila cuba nombor lain",
  41040: "OTP yang anda masukkan adalah salah. Sila cuba lagi",
  41041: "E-mel tidak sah",
  41042: "Otp sudah digunakan",
  41043: "Otp telah tamat tempoh",
  41044: "Akaun telah digantung",
  41045: "Nombor telefon sudah disahkan",
  41046: "Pilihan yang tidak dibenarkan",
  41047: "Akaun anda telah digantung Sila hubungi support@bossjobcom untuk penjelasan lebih lanjut",
  41048: "Pengguna atau nombor telefon yang tidak sah",
  41049: "Ruang sumber diperlukan",
  41050: "Habis tempoh identiti",
  41051: "Pengguna tidak mempunyai rekod nombor telefon",
  41052: "Butiran google tidak sah",
  41053: "Butiran linkedin tidak sah",
  41054: "Butiran facebook tidak sah",
  41055: "Butiran apple tidak sah",
  41056: "Alamat email atau kod pengesahan anda salah. Sila masukkan semula.",
  41057: "E-mel diperlukan",
  41058: "Pengguna tidak wujud",
  41059: "Senarai nilai integer tidak sah",
  41060: "Hanya pentadbir koordinator syarikat yang boleh memadam syarikat ini",
  41061: "Hanya pentadbir syarikat yang boleh memuat naik dokumen syarikat",
  41062: "Syarikat ini telah disahkan",
  41063: "Gagal untuk muat naik dokumen",
  41064: "Fail yang dimuat naik melebihi had imej maksimum (4MB)",
  41065: "Terlepas menyelaraskan Id syarikat",
  41066: "Syarikat tidak dijumpai",
  41067: "Syarikat masih menunggu pengesahan",
  41069: "Pengalaman kerja tidak dijumpai",
  41070: "Urutan penyusunan tidak sah",
  41071: "Gambar tidak wujud pada urutan penyusunan ini",
  41072: "Sila jalani proses latihan induksi",
  41073: "Status pengalaman kerja tidak sah",
  41074: "Nama sudah wujud",
  41075: "Nama mengandungi aksara yang terhad: +",
  41077: "Id atau kunci yang tidak sah",
  41078: "Alamat tempat kerja tidak sah",
  41079: "Syarikat ini belum disahkan",
  41080: "Pengguna tidak sah",
  41081: "perekrut tidak berada dalam syarikat yang dipilih",
  41082: "Gagal memuat naik banner",
  41083: "Gagal memuat naik gambar syarikat",
  41084: "Gagal memuat naik logo",
  41085: "Imej yang dimuat naik melebihi had imej maksimum (5mb)",
  41086: "Imej yang dimuat naik melebihi had imej maksimum (1mb)",
  41087: "Had masa melebihi had",
  41088: "Tidak boleh memadam koordinator syarikat",
  41089: "Tidak boleh menukar peranan koordinator",
  41090: "Pentadbir baru tidak sah",
  41091: "Id budaya mestilah nombor",
  41092: "Id budaya tidak sah",
  41093: "Id faedah mestilah nombor",
  41094: "Id faedah tidak sah",
  41095: "Ralat nilai parameter",
  41096: "Negara tidak disokong",
  41097: "Parameter untuk ruang id bakat diperlukan",
  41098: "Parameter latitud dan longitud adalah ruang yang diperlukan",
  41099: "Terlepas menyelaraskan Id pekerjaan",
  41100: "Ruang parameter kueri mempunyai nilai yang tidak sah",
  41101: "Beberapa lokasi tidak wujud",
  41102: "Beberapa jenis pekerjaan tidak wujud",
  41103: "Beberapa julat gaji tidak wujud",
  41104: "Beberapa kategori pekerjaan tidak wujud",
  41105: "Beberapa fungsi utama tidak wujud",
  41106: "Beberapa id fungsi pekerjaan tidak wujud",
  41107: "Beberapa id tajuk fungsi pekerjaan tidak wujud",
  41108: "Beberapa industri tidak wujud",
  41109: "Beberapa pengalaman tidak wujud",
  41110: "Beberapa ijazah tidak wujud",
  41111: "Nilai tidak sah",
  41112: "Frekuensi langganan pekerjaan tidak wujud",
  41113: "Pekerjaan ini tidak wujud",
  41114: "Anda belum menyertai syarikat",
  41115: "Tarikh dari atau tarikh hingga tidak sah",
  41116: "Penghantaran automatik telah dimatikan",
  41117: "Penghantaran automatik telah diaktifkan",
  41118: "Ralat kebenaran penghantaran automatik resume",
  41119: "E-mel tidak boleh kosong",
  41120: "Gaji pekerjaan telah didedahkan",
  41121: "Gaji pekerjaan telah disembunyikan",
  41122: "Perekrut tidak mempunyai kebenaran untuk menyembunyikan gaji",
  41123: "Perekrut tidak mempunyai kredit pekerjaan yang mencukupi",
  41124: "Pekerjaan ini telah dinaiktaraf menjadi pekerjaan yang disarankan",
  41125: "Masukkan alamat e-mel yang sah",
  41126: "Perekrut ini tidak mempunyai syarikat",
  41127: "Pekerjaan ini telah ditutup",
  41128: "Parameter kueri mempunyai nilai yang tidak sah",
  41129: "Pekerjaan ini telah dinaiktaraf menjadi pekerjaan penting",
  41130: "Tidak boleh memasukkan “-” dalam ruang ini",
  41131: "Ruang id pengguna diperlukan",
  41132: "Pekerjaan ini tidak dijumpai",
  41133: "Resume pencari kerja tidak dijumpai",
  41134: "Permohonan pekerjaan anda sedang diproses",
  41135: "Parameter id pengguna diperlukan",
  41136: "Semua soalan penapisan harus dijawab",
  41137: "Sebab-sebab laporan pekerjaan tidak sah",
  41139: "Permintaan pertukaran nombor telefon sudah wujud dan sedang berjalan",
  41140: "Tidak dibenarkan bersembang dengan diri sendiri",
  41141: "Kehadiran telah ditandakan",
  41142: "Status temu duga tidak sah",
  41143: "Masa yang tidak sah untuk menanda kehadiran, mestilah lebih dari 30 minit selepas temu duga bermula",
  41145: "Tidak dibenarkan untuk mengemas kini status temu duga",
  41146: "Tidak dibenarkan untuk memeriksa",
  41147: "Anda sudah mendaftar untuk temu duga ini",
  41148: "Anda boleh mula mendaftar dua jam sebelum temu duga bermula",
  41149: "Anda boleh mendaftar paling lewat setengah jam selepas temu duga bermula",
  41150: "Pekerjaan ini tidak wujud",
  41151: "Pekerjaan ini tidak aktif",
  41152: "Tidak dibenarkan untuk membatalkan temu duga yang akan datang",
  41153: "Masa temu duga mestilah lebih besar daripada masa semasa",
  41154: "Terdapat temu duga dalam proses",
  41155: "Permintaan telah dinyahaktifkan",
  41156: "Pekerjaan Tidak Dijumpai",
  41157: "Id resume tidak sah",
  41158: "Tidak dapat menetapkan penghantaran automatik resume untuk perbualan yang sedang berlangsung",
  41159: "Terdapat pengesahan lokasi dalam proses",
  41162: "Terdapat resume dalam proses",
  41163: "Keputusan temu duga ini telah diminta",
  41164: "Parameter untuk ruang id bakat diperlukan",
  41165: "Parameter untuk ruang id bakat diperlukan",
  41167: "Pastikan ruang tarikh mula adalah lebih awal daripada tarikh tamat",
  41168: "Alamat telah wujud",
  41169: "Panjang id tidak boleh lebih besar dari 1000",
  41170: "Lebih dari tiga resume telah dihantar",
  41171: "OTP tamat tempoh",
  41172: "OTP telah digunakan",
  41173: "Nombor telefon ini telah digunakan",
  41174: "Fail yang dimuat naik melebihi had fail maksimum (5mb)",
  41175: "Sambungan fail yang dimuat naik tidak disokong",
  41176: "Imej yang dimuat naik melebihi had imej maksimum (500kb)",
  41177: "Nilai id tidak sah",
  41178: "Urutan pekerjaan tidak sah",
  41179: "Ruang untuk nama fail diperlukan",
  41181: "Anda hanya boleh mempunyai maksimum 10 frasa biasa",
  41182: "Pastikan tarikh diterbitkan adalah lebih awal daripada tarikh luput, dan tarikh luput adalah lebih lewat daripada tarikh diterbitkan",
  41183: "Url lampiran tidak sah",
  41184: "Ralat telefon",
  41185: "Ralat badan",
  41186: "Anda tidak boleh memadam resume yang telah dipilih untuk penghantaran automatik resume",
  41187: "Pengguna dan pengirim mestilah konsisten",
  41188: "Pengguna dan penerima mestilah konsisten",
  41191: "Pengalaman kerja tidak dijumpai",
  41192: "Status pengalaman kerja tidak sah, tidak dapat menyertai syarikat ini",
  41194: "Tidak boleh menyertai syarikat yang belum disahkan",
  41196: "Hanya pentadbir syarikat yang boleh melakukan pengesahan untuk perekrut menyertai syarikat ini",
  41197: "Anda tidak boleh melakukan pengesahan diri sendiri untuk menyertai syarikat ini",
  41198: "Perekrut tidak dijumpai",
  41199: "Perekrut tidak membuat permohonan untuk menyertai syarikat ini",
  41201: "Perekrut tidak mempunyai rekod syarikat",
  41202: "Perekrut bukan koordinator syarikat",
  41204: "Kehilangan kunci peranan",
  41205: "Pentadbir syarikat tidak boleh meninggalkan syarikat tanpa memindahkan hak pentadbiran",
  41207: "Imej yang dimuat naik melebihi had imej maksimum",
  41208: "Keterangan diperlukan",
  41209: "Data diperlukan",
  41213: "Ahli bakat telah dikeluarkan",
  41214: "Parameter untuk ruang alasan dibuang diperlukan",
  41217: "Id pekerjaan tidak sah",
  41219: "Anda belum menyertai syarikat",
  41221: "Jenis kandungan hanya menyokong application/x-www-form-urlencoded dan diperlukan apabila kaedah permohonan adalah Post",
  41222: "kaedah permohonan hanya menyokong Post atau Kaedah Get",
  41223: "Kategori tidak dibenarkan",
  41224: "Sekiranya ruang balasan sembang automatik adalah betul, data mesej diperlukan",
  41225: "Anda tidak mempunyai kebenaran untuk menetapkan balasan automatik",
  41226: "Sila berikan kueri parameter untuk id jenis mesej",
  41227: "Penggguna belum berdaftar",
  41228: "Salam sejahtera, Mesej yang tidak sesuai dan mesej balasan automatik tidak boleh mengandungi e-mel dan nombor telefon",
  41229: "Maklumat penyenaraian syarikat tidak dijumpai",
  41230: "pengalaman kerja perekrut tidak dijumpai",
  41231: "Anda adalah koordinator syarikat dan tidak dapat melakukan operasi semasa ini",
  41232: "Syarikat belum dituntut",
  41233: "Anda tidak mempunyai kebenaran untuk memadam perbualan ini",
  41234: "Nombor telefon anda kelihatan tidak betul, sila masukkan semula",
  41235: "Pautan Tidak Sah",
  41236: "Anda telah memasukkan nombor telefon atau kod kawasan yang tidak sah",
  41237: "Pengesahan nombor telefon anda gagal atau melepasi tempoh masa",
  41238: "Masa mula pengalaman bekerja haruslah kurang daripada masa akhir",
  41239: "Acara tidak dijumpai",
  41240: "Acara belum dimulakan lagi",
  41241: "Acara telah berakhir",
  41242: "Anda tidak mengambil bahagian dalam acara ini",
  41243: "Ganjaran telah ditebus sepenuhnya",
  41244: "Telah mencapai had penebusan",
  41245: "Lebih dari tiga video resume telah dihantar",
  41246: "Tidak mencukupi mata untuk membuat pengeluaran",
  41247: "Jumlah pengeluaran minimum adalah 100 mata untuk Tron (TRC20)",
  41248: "Jumlah pengeluaran minimum adalah 1000 mata untuk Ethereum(ERC20)",
  41249: "Pengganda jumlah pengeluaran adalah 100 mata",
  41250: "Alamat Tron (TRC20) tidak sah",
  41251: "Alamat Ethereum (ERC20) tidak sah",
  41252: "Kueri melebihi had",
  41253: "Pastikan bahawa terdapat tidak lebih dari 10 digit sebelum titik perpuluhan",
  41254: "Resume tidak boleh melebihi 5 salinan",
  41255: "Resume ini bukan milik anda",
  41256: "Tidak lebih daripada 30",
  41257: "Bilangan kali telah habis digunakan",
  41258: "Anda tidak dapat memperoleh data untuk pengguna ini",
  41259: "Masa tidak boleh melebihi masa semasa",
  41260: "Pengesahan tidak sah",
  41262: "Anda tidak boleh mencipta lebih daripada 3 pilihan keutamaan pekerjaan jarak jauh",
  41263: "Anda tidak boleh mencipta lebih daripada 3 pilihan keautamaan pekerjaan di tempat bekerja atau hibrid",
  41264: "Jenis fail resume yang disokong adalah pdf,doc,docx",
  41265: "Jenis fail video yang disokong adalah mp4,avi,mov,wmv,flv,mkv,mpeg,webm,3gp,ogg",
  41266: "Import-task telah wujud dalam syarikat kami",
  41267: "Pautan import tidak disokong",
  41268: "Anda tidak mempunyai kebenaran untuk menjalankan operasi ini",
  41269: "Hanya 10 orang sahaja boleh dijemput pada satu masa",
  41270: "ID peranan yang dipilih tidak sepadan dengan nilai",
  41271: "Bukti kelayakan baris tidak sah",
  41272: "Bukti kelayakan x tidak sah",
  41273: "Pautan jemputan telah tamat tempoh",
  41274: "Your identity information does not match the position you submitted, and you cannot start a chat with the employer for this position.",
  41275: "Due to bandwidth issues, you have exceeded the allowable limit of queries for AICV. Please try again in 24 hours.",
  41276: "The number of brands or products added exceeds the limit.",
  41277: "The number of related pictures added for a brand or product exceeds the limit.",
  41278: "The uploaded url does not meet the specifications.",
  41279: "The job reminder content you set is duplicated, please modify it and save it.",
  41280: "Apologies, AI is currently unavailable due to an error. Please try again later.",
  41281: "Resume parsing failed, please make sure you upload the correct resume.",
  48905: "E-mel telah didaftarkan",
  50001: "Ralat server dalaman",
  50002: "Gagal untuk memuat naik resume",
  50003: "Kehilangan profil",
  50004: "Permintaan pertukaran nombor telefon ini telah diproses",
  50005: "Anda tidak mempunyai baki yang mencukupi untuk membuka kredit bakat",
  50006: "Mesej temu duga tidak dijumpai",
  50007: "Permohonan resume ini telah diproses",
  50008: "Gagal memuat naik gambar profil",
  50009: "Gagal membuka bakat",
  50010: "Parameter id diperlukan",
  50011: "Bakat telah dibuka",
  50012: "Parameter nama resume terakhir dikemas kini adalah nilai yang tidak sah",
  50013: "Tiada hasil dijumpai pada masa ini Sila cuba lagi",
  50014: "Pencarian gaji gagal",
  50015: "Anda telah menyertai syarikat lain, Sila log masuk ke backend pengurusan sekalii lagi dan keluar dari syarikat sebelum menyertai syarikat lain"
}, oa = "https://api.bossjob.com", et = () => fetch(`${oa}/translation/manifest`).then((e) => e.json()).catch((e) => {
  throw new Error(`Fetch translation/manifest error: ${e}`);
}), Oe = (e, a, n) => fetch(`${oa}/translation/content/version/${e}/${a}${n}`).then((i) => i.json()).catch((i) => {
  throw new Error(`Fetch /translation/content/version error: ${i}`);
}), ze = { errorcode: ra, ...ta }, Be = { errorcode: Di, ...Mi }, Re = { errorcode: $i, ..._i }, xe = { errorcode: Ui, ...Hi }, Ne = { errorcode: qi, ...Fi }, Le = { errorcode: Qi, ...Wi }, Me = { errorcode: Zi, ...Xi }, I = {
  "en-US": () => ze,
  "en-us": () => ze,
  "zh-CN": () => Be,
  "zh-cn": () => Be,
  id: () => Re,
  "id-ID": () => Re,
  "ja-JP": () => xe,
  ja: () => xe,
  "zh-TW": () => Ne,
  "zh-tw": () => Ne,
  "tr-TR": () => Le,
  tr: () => Le,
  "ms-MY": () => Me,
  ms: () => Me
}, ie = {
  en: "en",
  "en-US": "en",
  "en-us": "en",
  "zh-CN": "zh-CN",
  "zh-cn": "zh-CN",
  "id-ID": "id",
  id: "id",
  "ja-JP": "ja",
  ja: "ja",
  "zh-TW": "zh-TW",
  "zh-tw": "zh-TW",
  "tr-TR": "tr",
  tr: "tr",
  "ms-MY": "ms",
  ms: "ms",
  "es-ES": "es-ES",
  "es-es": "es-ES"
}, at = (e) => !e || e === "en" ? ie.en : ie[e] || ie.en, sa = "crowdin-login", oe = "__crowdin_version__", se = "__crowdin_language__", la = typeof window > "u", da = /* @__PURE__ */ Object.create(null), nt = process.env.NODE_ENV === "development" ? console.log : () => {
}, it = (e) => la ? da[e] : localStorage.getItem(sa), tt = ({ match: e, data: a }) => {
  la ? da[e] = JSON.stringify(a) : localStorage.setItem(sa, JSON.stringify(a));
}, rt = ({ version: e, lang: a }) => {
  if (!e || !a)
    return null;
  let n = it(a);
  return !n || (n = JSON.parse(n), !n[se] || !n[oe]) || n[se] !== a ? null : n[oe] >= e ? n : null;
}, ot = async (e) => {
  var a, n;
  try {
    const i = {
      job_seeker: 19,
      jobseekerPath: "/remote-login-web/init_language.json",
      error_code: 6,
      errorPath: "/backend/errorcode.json"
    }, { data: t } = await et(), { files: r, active_version: o } = t ?? {}, s = at(e), d = rt({ version: o, lang: s });
    if (d)
      return d;
    const l = (h, b, T) => {
      var y;
      const f = r.find((v) => v.id == h);
      return (y = f == null ? void 0 : f.path) != null && y.includes(b) ? f == null ? void 0 : f.path : T;
    }, [c, w] = await Promise.all([
      Oe(
        o,
        s,
        l(i.job_seeker, "remote-login-web", i.jobseekerPath)
      ),
      Oe(
        o,
        s,
        l(i.error_code, "errorcode", i.errorPath)
      )
    ]);
    if (Ce(c) || Ce(w))
      return ((a = I[e]) == null ? void 0 : a.call(I)) || I["en-us"]();
    const k = {
      ...c,
      errorcode: w,
      [oe]: o,
      [se]: s
    };
    return tt({ match: s, data: k }), k;
  } catch (i) {
    return nt({ getDictionaryError: i }), ((n = I[e]) == null ? void 0 : n.call(I)) || I["en-us"]();
  }
}, ua = ba({
  ...ta,
  errorcode: ra
}), st = ua.Provider, lt = ({ children: e, lang: a }) => {
  var d;
  const n = ((d = I[a]) == null ? void 0 : d.call(I)) || I["en-us"](), [i, t] = C(n), [r, o] = C(!0), s = async (l) => {
    try {
      o(!0);
      const c = await ot(l);
      c && t(c);
    } catch {
      t(n);
    } finally {
      o(!1);
    }
  };
  return W(() => {
    a && s(a);
  }, []), /* @__PURE__ */ S.jsx(st, { value: i, children: r ? null : e });
};
function dt() {
  const e = J(ua);
  if (e === void 0)
    throw new Error("useLanguageContext must be used within a LanguageProvider");
  return e;
}
const ut = (e, a = {}) => {
  var n;
  (n = window.fbq) == null || n.call(window, "track", e, a);
}, mt = (e, a = (i) => i, n) => {
  const i = fa(
    (t) => Ka(e, (r) => {
      t(r ? a(r) : void 0);
    }),
    () => {
      const t = q(e);
      if (t)
        return a(t);
    },
    () => {
      if (!n)
        return;
      const t = n();
      return ct(t) ? ya(t.then(a)) : a(t);
    }
  );
  return va(i);
};
function ct(e) {
  return !!e && typeof e.then == "function";
}
const kt = ({ langKey: e }) => P("GET", "/config/blog-address/lists", {
  language_code: e || "en-US"
}), ma = g.createContext(void 0);
function gt(e) {
  const a = _e(), [n, i] = C({});
  W(() => {
    (async () => {
      try {
        const s = (await kt({ langKey: a })).data;
        i(s);
      } catch {
      }
    })();
  }, [a]);
  const t = mt("CONFIG");
  return /* @__PURE__ */ S.jsx(ma.Provider, { value: { config: t, blogAddressUrl: n }, children: e.children });
}
function pt() {
  const e = g.useContext(ma);
  if (e === void 0)
    throw new Error("useConfigContext must be used within a ConfigProvider");
  return e;
}
function ca() {
  const e = window.location.hostname;
  return e.includes("localhost") || e.includes("demo.") ? "https://dev.employer.bossjob.com" : e.includes("staging.") ? "https://staging-employer.bossjob.com" : "https://employer.bossjob.com";
}
const ht = ({ sessionid: e, languageKey: a, countryKey: n, redirect: i, sessionType: t }) => {
  const r = n || $e(), o = a || _e(), s = ue(o), d = ca(), l = new URL(d + "/keep-login");
  return l.searchParams.set("country", r), l.searchParams.set("lang", s), i && l.searchParams.set("redirect", i), t && l.searchParams.set("sessionType", t), e && l.searchParams.set("sessionid", e), l.toString();
}, bt = ({ userId: e }) => {
  var t;
  const a = (t = window == null ? void 0 : window.location) == null ? void 0 : t.href;
  function n(r) {
    const o = new URL(r);
    if (o.pathname.includes("/job/")) {
      const s = new URLSearchParams(o.search), d = s.get("utm_source"), l = s.get("utm_medium");
      if (d && l)
        return { utmSource: d, utmMedium: l };
    }
    return null;
  }
  if (!a)
    return Promise.resolve();
  const i = n(a);
  return i ? pi({ user_id: e, network: i.utmSource, campaign: i.utmMedium }, {}) : Promise.resolve();
}, Gt = () => {
  const [, e] = C(1), [a, n] = C(""), [i, t] = C(), [r, o] = C(!1), [s, d] = C(null), [l, c] = C(!1), { config: w } = pt(), k = dt(), { openNotification: h } = En(), [b, T] = C(null), [f, y] = C(null), v = Va(), B = v.get("referral_code"), z = v.get("invited_source"), R = $e(), p = Pa(() => hi(w), [w]);
  W(() => {
    b !== null && pa();
  }, [b]);
  const L = (u) => {
    c(!0);
    const m = localStorage.getItem("uuid"), x = {
      email: a,
      otp: u,
      source: H ? "mobile_web" : "web",
      userId: s,
      browser_serial_number: m,
      referral_code: B || void 0,
      invited_source: z || void 0
    };
    m || delete x.browser_serial_number, ee(x);
  }, Y = (u, m) => {
    var A, ge;
    const x = localStorage.getItem("uuid");
    c(!0);
    const G = {
      phone_num: m,
      otp: u,
      source: H ? "mobile_web" : "web",
      userId: s,
      browser_serial_number: x,
      mobile_country_id: (ge = (A = p.filter((ha) => m.includes(ha.value))) == null ? void 0 : A[0]) == null ? void 0 : ge.id,
      referral_code: B || void 0,
      invited_source: z || void 0
    };
    ee(G);
  }, D = (u) => {
    u.is_new_account && typeof window < "u" && (window != null && window.fbq && ut("sign_up", {
      user_id: u == null ? void 0 : u.id
    }), window != null && window.gtag && (window.gtag("event", "sign_up", {
      user_id: u == null ? void 0 : u.id,
      email: u == null ? void 0 : u.email
    }), window.BMDataLayer = window.BMDataLayer || [], window.BMDataLayer.push({ conversionID: "67b53e4c1b3a7f15c736cc41", eventId: "register0219", event: "conversion", eventValue: "{ConversionValueUSD}" }), u != null && u.email && (window.gtag("set", "user_data", { email: u.email }), R == "sg" ? window.gtag("event", "conversion", { send_to: "AW-844310282/wSVyCIjy6cYZEIrOzJID" }) : R == "ph" && window.gtag("event", "conversion", { send_to: "AW-844310282/5w66CL3G-MYZEIrOzJID" }))), window != null && window.ttq && window.ttq.track("CompleteRegistration", {
      user_id: u == null ? void 0 : u.id,
      email: u == null ? void 0 : u.email
    }));
  }, ee = (u) => mi(u).then((m) => (m.data && (re(m.data), y(m.data), D(m.data), u.userId || bt({ userId: m.data.id })), Promise.resolve(m.data))).catch((m) => (T({ ...m }), Promise.reject(m))), ga = async (u, m = !1) => {
    if ((ae("loginType") || "jobSeeker") === "recruiter" && !H) {
      const G = ae("sessionid") || "", A = ht({ sessionid: G });
      window.location.replace(A);
      return;
    }
    te("HIDE_LOGIN_MODAL"), te("ON_LOGIN_SUCCESS", { data: u, isPhone: m });
  }, pa = () => {
    o(!0), c(!1);
  };
  return {
    setStep: e,
    email: a,
    setEmail: n,
    setUserId: d,
    defaultLoginCallBack: ga,
    userId: s,
    emailTOP: i,
    setEmailTOP: t,
    emailOTPInputDisabled: l,
    handleAuthLoginForEmail: L,
    handleAuthLoginForPhone: Y,
    handleAuthSendEmailMagicLink: () => {
      const u = ae("loginType") || "jobSeeker", m = {
        email: a,
        source: H ? "mobile_web" : "web"
      }, x = u == "recruiter";
      x && (m.orig = ca());
      let G = ki;
      !H && x && (G = gi), G(m).then(() => {
        var A;
        h({
          type: "success",
          message: null,
          description: bi((A = k == null ? void 0 : k.getStarted) == null ? void 0 : A.haveSendEmail, a)
        });
      }).catch((A) => {
        h({
          type: "error",
          message: null,
          description: (k == null ? void 0 : k.errorcode[A == null ? void 0 : A.code]) || A.message
        });
      });
    },
    handleAuthSocialLogin: async (u) => ci(u).then((m) => {
      if (m.code == 0)
        return re(m.data), D(m.data), y(m.data), Promise.resolve(m.data);
    }).catch((m) => (T(m == null ? void 0 : m.message), Promise.reject(m))),
    emailTOPError: r,
    userInfo: f,
    error: b,
    setError: T,
    sendEventWithLoginData: D,
    logoutRequest: (u) => ui(u).then((m) => Promise.resolve(m.data)),
    loginRequest: ee
  };
}, ka = ({
  contexts: e,
  children: a
}) => /* @__PURE__ */ S.jsx(S.Fragment, { children: e.reduceRight((n, i) => g.cloneElement(i, {}, n), a) });
ka.displayName = "ContextComposerProvider";
const ft = () => {
  const e = "2026042927653653";
  return W(() => (window.fbAsyncInit = function() {
    window.FB.init({
      appId: e,
      cookie: !0,
      xfbml: !0,
      version: "v19.0"
    }), window.FB.AppEvents.logPageView();
  }, function(a, n, i) {
    if (!a.getElementById(i)) {
      var t = a.createElement(n);
      t.id = i, t.src = "https://connect.facebook.net/en_US/sdk.js";
      var r = a.getElementsByTagName("head")[0] || a.body;
      r.appendChild(t);
    }
  }(document, "script", "facebook-jssdk"), () => {
  }), [e]), null;
}, yt = () => (W(() => Fa("SET_COOKIES_WITH_LOGIN_DATA", (e) => {
  const { data: a } = e;
  re(a.data);
}), []), /* @__PURE__ */ S.jsx(S.Fragment, { children: /* @__PURE__ */ S.jsx(ft, {}) })), _t = (e) => {
  const { children: a } = e, { lang: n } = e;
  return /* @__PURE__ */ S.jsxs(
    ka,
    {
      contexts: [
        /* @__PURE__ */ S.jsx(lt, { lang: n }, "LanguageProvider"),
        /* @__PURE__ */ S.jsx(gt, {}, "ConfigProvider"),
        /* @__PURE__ */ S.jsx(In, {}, "NotificationProvider")
      ],
      children: [
        /* @__PURE__ */ S.jsx(yt, {}),
        a
      ]
    }
  );
};
export {
  Dt as A,
  ht as B,
  _t as C,
  ua as L,
  En as a,
  Gt as b,
  It as c,
  mt as d,
  Xe as e,
  On as f,
  qn as g,
  dt as h,
  Ze as i,
  pt as j,
  Ct as k,
  bi as l,
  Et as m,
  hi as n,
  Wn as o,
  Ot as p,
  Lt as q,
  Rn as r,
  zt as s,
  Rt as t,
  Va as u,
  Bt as v,
  Nt as w,
  xt as x,
  P as y,
  Mt as z
};
//# sourceMappingURL=index-23ca9bfe.js.map
